<div  class="usercontainer">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0" *ngIf="power != 16">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span *ngIf="fake_info.id!=-1||item.id!=4"  [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <div *ngIf="now=='12'">

        <div class="analysis-container">
            <!-- 標題 -->
            <div class="header">
                <h1>活躍分析</h1>
                <span class="period-tag">半年內有上線數據</span>
            </div>

            <!-- 性別切換 Tab -->
            <div class="gender-tabs">
                <button
                    class="tab-btn"
                    [class.active]="selectedGender === 'male'"
                    (click)="onGenderChange('male');defalt_create()">
                    男生
                </button>
                <button
                    class="tab-btn"
                    [class.active]="selectedGender === 'female'"
                    (click)="onGenderChange('female');defalt_create()">
                    女生
                </button>
            </div>

            <div class="deposit-filter" *ngIf="selectedGender === 'male'">
                <button
                    class="filter-btn"
                    [class.active]="depositFilter === 'all'"
                    (click)="changedepositFilter('all')">
                    全部
                </button>

                <button
                    class="filter-btn"
                    [class.active]="depositFilter === 'paid'"
                    (click)="changedepositFilter('paid')">
                    有儲值
                </button>

                <button
                    class="filter-btn"
                    [class.active]="depositFilter === 'unpaid'"
                    (click)="changedepositFilter('unpaid')">
                    無儲值
                </button>
            </div>

            <div style="display: flex; flex-wrap: wrap; justify-content: space-between;">
                 <!-- 顯示類型 Tab -->
                <div class="analysis-tab-container">
                    <button
                        class="analysis-tab-btn"
                        [class.analysis-tab-active]="activeTab == 'query'"
                        (click)="selectTab('query');">
                        區間統計
                    </button>
                    <button
                        class="analysis-tab-btn"
                        [class.analysis-tab-active]="activeTab == 'diff'"
                        (click)="selectTab('diff');">
                        差異比對
                    </button>
                    <button
                        *ngIf="false"
                        class="analysis-tab-btn"
                        [class.analysis-tab-active]="activeTab == 'first'"
                        (click)="selectTab('first');selectActiveTab('message');">
                        留存追蹤
                    </button>

                </div>

                <!-- 顯示類型 Tab -->
                <div class="analysis-tab-active-container">
                    <button
                        *ngIf="activeTab != 'first'"
                        class="analysis-active-tab-btn"
                        [class.analysis-active-tab-active]="activeTypeTab == 'activity'"
                        (click)="selectActiveTab('activity');">
                        活躍分析
                    </button>
                    <button
                        class="analysis-active-tab-btn"
                        [class.analysis-active-tab-active]="activeTypeTab == 'message'"
                        (click)="selectActiveTab('message');">
                        訊息數分析
                    </button>
                </div>
            </div>

            <!-- 篩選區域 -->
            <div class="filter-section">
                <div class="filter-row">

                    <!-- 隊伍經紀分群 (僅女生顯示) -->
                    <div class="filter-item" *ngIf="selectedGender === 'female'">
                        <label>分析分群</label>
                        <select [(ngModel)]="selectedFilterPlatform" (change)="onFilterListChange()">
                            <option value="0">平台分群</option>
                            <option value="1">隊伍經紀分群</option>
                            <option value="2">女生等級分群</option>
                            <option value="3">非經紀用戶分群</option>
                        </select>
                    </div>

                    <!-- 平台分群 -->
                    <div class="filter-item"  *ngIf="selectedGender === 'male' || (selectedGender === 'female' && selectedFilterPlatform == '0')">
                        <label>平台分群</label>
                        <select [(ngModel)]="selectedPlatform" (change)="onFilterChange()">
                            <option value="0">全部平台</option>
                            <option value="1">Android</option>
                            <option value="2">iOS</option>
                            <option value="3">Web</option>
                        </select>
                    </div>

                    <!-- 隊伍經紀分群 (僅女生顯示) -->
                    <div class="filter-item" *ngIf="selectedGender === 'female' && selectedFilterPlatform == '1'">
                        <label>隊伍經紀分群</label>
                        <select [(ngModel)]="selectedVendor" (change)="onFilterChange()">
                            <option *ngFor="let vendor of vendorList" [value]="vendor.id">
                                {{vendor.vendor_name}}
                            </option>
                        </select>
                    </div>

                    <!-- 女生等級分群 (僅女生顯示) -->
                    <div class="filter-item" *ngIf="selectedGender === 'female' && selectedFilterPlatform == '2'">
                        <label>女生等級</label>
                        <select [(ngModel)]="selectedLevel" (change)="onFilterChange()">
                            <option *ngFor="let level of levelList" [value]="level.mt_level">
                                {{level.mt_level_name}} ({{level.num}}人)
                            </option>
                        </select>
                    </div>

                    <!-- 時間顯示 -->
                    <div class="filter-item">
                        <label>時間顯示</label>
                        <select [(ngModel)]="timeGranularity" (change)="onFilterChange()">
                            <option value="daily">每日</option>
                            <option value="monthly">每月</option>
                        </select>
                    </div>
                </div>

                <!-- ==================== 查詢區間分析 - 單組日期 ==================== -->

                <button  class="accordion-btn" type="button" (click)="showRegisterDate = !showRegisterDate" *ngIf="activeTypeTab == 'message'">
                    <span class="dot"></span>
                    鎖定註冊日
                    <span class="chev" [class.open]="showRegisterDate">⌄</span>
                </button>

                <div class="accordion" [class.open]="showRegisterDate" *ngIf="showRegisterDate && activeTypeTab == 'message'" style="margin-bottom: 10px;">
                    <ng-container>
                        <div class="date-range-group" *ngIf="timeGranularity === 'daily'">
                            <div class="group-label">📅 註冊日區間</div>

                            <div class="date-range">
                                <div class="filter-item">
                                    <label>開始日期</label>
                                    <input
                                        type="date"
                                        [(ngModel)]="startDatecreate"
                                        [min]="oneYearAgoMonth"
                                        [max]="endDatecreate || currentMonth">
                                </div>

                                <span class="date-separator">至</span>

                                <div class="filter-item">
                                    <label>結束日期</label>
                                    <input
                                        type="date"
                                        [(ngModel)]="endDatecreate"
                                        [min]="startDatecreate"
                                        [max]="today">
                                </div>
                            </div>
                        </div>

                         <!-- 月份區間選擇 (每月) -->
                        <div class="date-range-group" *ngIf="timeGranularity === 'monthly'">
                            <div class="group-label">📅 註冊日區間</div>
                            <div class="date-range">
                                <div class="filter-item">
                                    <label>開始月份</label>
                                    <input
                                        type="month"
                                        [(ngModel)]="startMonthcreate"
                                        [min]="oneYearAgoMonth"
                                        [max]="endMonthcreate || currentMonth">
                                </div>
                                <span class="date-separator">至</span>
                                <div class="filter-item">
                                    <label>結束月份</label>
                                    <input
                                        type="month"
                                        [(ngModel)]="endMonthcreate"
                                        [min]="startMonthcreate"
                                        [max]="currentMonth">
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

            <ng-container *ngIf="activeTab == 'query'">
                <!-- 日期區間選擇 (每日) -->
                <div class="date-range" *ngIf="timeGranularity === 'daily'">
                    <div class="filter-item">
                        <label>開始日期</label>
                        <input
                            type="date"
                            [(ngModel)]="startDate"
                            [min]="oneYearAgo"
                            [max]="endDate || today">
                    </div>
                    <span class="date-separator">至</span>
                    <div class="filter-item">
                        <label>結束日期</label>
                        <input
                            type="date"
                            [(ngModel)]="endDate"
                            [min]="startDate"
                            [max]="today">
                    </div>
                </div>

                <!-- 月份區間選擇 (每月) -->
                <div class="date-range" *ngIf="timeGranularity === 'monthly'">
                    <div class="filter-item">
                        <label>開始月份</label>
                        <input
                            type="month"
                            [(ngModel)]="startMonth"
                            [min]="oneYearAgoMonth"
                            [max]="endMonth || currentMonth">
                    </div>
                    <span class="date-separator">至</span>
                    <div class="filter-item">
                        <label>結束月份</label>
                        <input
                            type="month"
                            [(ngModel)]="endMonth"
                            [min]="startMonth"
                            [max]="currentMonth">
                    </div>
                </div>
            </ng-container>

            <!-- ==================== 區間差異分析 - 兩組日期 ==================== -->
            <ng-container *ngIf="activeTab == 'diff' || activeTab == 'first'">
                <!-- 每日 - 兩組日期區間 -->
                <div *ngIf="timeGranularity === 'daily'">
                    <!-- 第一組日期 -->
                    <div class="date-range-group">
                        <div class="group-label">📅 第一組區間</div>
                        <div class="date-range">
                            <div class="filter-item">
                                <label>開始日期</label>
                                <input
                                    type="date"
                                    [(ngModel)]="startDate1"
                                    [min]="oneYearAgo"
                                    [max]="endDate1 || today">
                            </div>
                            <span class="date-separator">至</span>
                            <div class="filter-item">
                                <label>結束日期</label>
                                <input
                                    type="date"
                                    [(ngModel)]="endDate1"
                                    [min]="startDate1"
                                    [max]="today">
                            </div>
                        </div>
                    </div>

                    <!-- 第二組日期 -->
                    <div class="date-range-group">
                        <div class="group-label">📅 第二組區間</div>
                        <div class="date-range">
                            <div class="filter-item">
                                <label>開始日期</label>
                                <input
                                    type="date"
                                    [(ngModel)]="startDate2"
                                    [min]="oneYearAgo"
                                    [max]="endDate2 || today">
                            </div>
                            <span class="date-separator">至</span>
                            <div class="filter-item">
                                <label>結束日期</label>
                                <input
                                    type="date"
                                    [(ngModel)]="endDate2"
                                    [min]="startDate2"
                                    [max]="today">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 每月 - 兩組月份區間 -->
                <div *ngIf="timeGranularity === 'monthly'">
                    <!-- 第一組月份 -->
                    <div class="date-range-group">
                        <div class="group-label">📅 第一組區間</div>
                        <div class="date-range">
                            <div class="filter-item">
                                <label>開始月份</label>
                                <input
                                    type="month"
                                    [(ngModel)]="startMonth1"
                                    [min]="oneYearAgoMonth"
                                    [max]="endMonth1 || currentMonth">
                            </div>
                            <span class="date-separator">至</span>
                            <div class="filter-item">
                                <label>結束月份</label>
                                <input
                                    type="month"
                                    [(ngModel)]="endMonth1"
                                    [min]="startMonth1"
                                    [max]="currentMonth">
                            </div>
                        </div>
                    </div>

                    <!-- 第二組月份 -->
                    <div class="date-range-group">
                        <div class="group-label">📅 第二組區間</div>
                        <div class="date-range">
                            <div class="filter-item">
                                <label>開始月份</label>
                                <input
                                    type="month"
                                    [(ngModel)]="startMonth2"
                                    [min]="oneYearAgoMonth"
                                    [max]="endMonth2 || currentMonth">
                            </div>
                            <span class="date-separator">至</span>
                            <div class="filter-item">
                                <label>結束月份</label>
                                <input
                                    type="month"
                                    [(ngModel)]="endMonth2"
                                    [min]="startMonth2"
                                    [max]="currentMonth">
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <button class="btn-search-date" (click)="onTimesearch()" style="margin-top: 10px;">查詢</button>
            </div>
            <div class="hint-banner" *ngIf="activeTypeTab == 'message'">
                由於統計條件為「近半年內有上線紀錄」，符合條件的使用者人數固定，因此各區間人數不會隨時間變動。
            </div>

            <!-- 顯示類型 Tab -->
            <div class="gender-tabs" *ngIf="activeTab == 'query' && activeTypeTab == 'activity'">
                <button
                    class="tab-btn1"
                    [class.active]="selectedList === 'pic'"
                    (click)="onListChange('pic')">
                    圖表顯示
                </button>
                <button
                    class="tab-btn1"
                    [class.active]="selectedList === 'list'"
                    (click)="onListChange('list')">
                    列表顯示
                </button>
            </div>

             <!-- 搜尋  -->
            <div class="gender-tabs" *ngIf="activeTypeTab == 'activity'">
                <div class="search-container-2">
                    <div class="search-wrapper-2">
                        <span class="search-icon">🔍</span>
                        <input
                            type="text"
                            class="search-input-2"
                            placeholder="搜尋對象..."
                            [(ngModel)]="target_search_user"
                            (keydown.enter)="searchTargetUser()"
                        >
                        <!-- 清除按鈕 - 只在有值時顯示 -->
                        <button
                            class="clear-btn"
                            *ngIf="target_search_user && target_search_user.trim() !== ''"
                            (click)="clearSearch()"
                            type="button"
                            title="清除">
                            ✕
                        </button>
                        <button class="search-btn-2" (click)="searchTargetUser()" type="button">
                            確認
                        </button>
                    </div>
               </div>
            </div>

             <!-- 列表顯示 -->
             <!-- 活躍區間  -->
            <div class="chart-section" [hidden]="selectedList == 'pic'" *ngIf="activeTab == 'query' && activeTypeTab == 'activity'">
                <app-table-v2 [type]="1" [attr.key]="selectedList" [data]="list_arr"  [tcontent]="list_tcontent" *ngIf="list_arr.length>0" (sortdata)="handlesortdatadetail($event)">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'gg'">
                            <i style="margin: 0 10px 0 0;" class="fas fa-wrench" style="cursor:pointer;color:darkcyan" (click)="view_user_history(post.val.user_id,0)"></i>
                        </div>
                    </ng-template>
                </app-table-v2>
                <app-pagnation (callback)="callbackList($event)" [data]="pageobjstr"></app-pagnation>
           </div>

            <!-- 圖表區域 -->
            <!-- 活躍區間  -->
            <div class="chart-section" [hidden]="selectedList == 'list'"  *ngIf="activeTab == 'query' && activeTypeTab == 'activity'">
                <!-- 圖表容器 -->
                 <div class="chart-container">
                    <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="lineOptions2" style="display: block;width: 100%;"></highcharts-chart>
                </div>
                <div class="chart-container">
                    <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="lineOptions3" style="display: block;width: 100%;"></highcharts-chart>
                </div>
                <div class="chart-container">
                    <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="lineOptions4" style="display: block;width: 100%;"></highcharts-chart>
                </div>
                <div class="chart-container">
                    <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="lineOptions5" style="display: block;width: 100%;"></highcharts-chart>
                </div>
            </div>

            <div class="diff-analysis-container" *ngIf="activeTab == 'diff' && diff_data.length>0 && activeTypeTab == 'activity'" >
                <!-- 標題區 -->
                <div class="diff-analysis-header">
                    <h2>📊 區間差異分析</h2>
                    <p class="diff-analysis-subtitle">比較兩個時間區間的用戶活躍變化</p>
                </div>

                <!-- 統計卡片區 -->
                <div class="diff-analysis-stats-grid">
                    <!-- 第一區間 -->
                    <div class="diff-analysis-stat-card diff-analysis-period-card">
                        <div class="diff-analysis-card-icon">📅</div>
                        <div class="diff-analysis-card-content">
                            <div class="diff-analysis-card-label">第一區間用戶</div>
                            <div class="diff-analysis-card-value">{{summary.period1_total}}</div>
                            <!-- <div class="diff-analysis-card-subtitle">人</div> -->
                        </div>
                    </div>

                    <!-- 第二區間 -->
                    <div class="diff-analysis-stat-card diff-analysis-period-card">
                        <div class="diff-analysis-card-icon">📅</div>
                        <div class="diff-analysis-card-content">
                            <div class="diff-analysis-card-label">第二區間用戶</div>
                            <div class="diff-analysis-card-value">{{summary.period2_total}}</div>
                            <!-- <div class="diff-analysis-card-subtitle">人</div> -->
                        </div>
                    </div>

                    <!-- 共同用戶 -->
                    <div class="diff-analysis-stat-card diff-analysis-common-card">
                        <div class="diff-analysis-card-icon">🤝</div>
                        <div class="diff-analysis-card-content">
                            <div class="diff-analysis-card-label">共同用戶</div>
                            <div class="diff-analysis-card-value">{{summary.common_users_count}}</div>
                            <!-- <div class="diff-analysis-card-subtitle">人</div> -->
                        </div>
                    </div>

                    <!-- 新增用戶 -->
                    <div class="diff-analysis-stat-card diff-analysis-increase-card">
                        <div class="diff-analysis-card-icon">📈</div>
                        <div class="diff-analysis-card-content">
                            <div class="diff-analysis-card-label">新增用戶</div>
                            <div class="diff-analysis-card-value diff-analysis-positive">+{{summary.new_users_count}}</div>
                            <!-- <div class="diff-analysis-card-subtitle">人</div> -->
                        </div>
                    </div>

                    <!-- 減少用戶 -->
                    <div class="diff-analysis-stat-card diff-analysis-decrease-card">
                        <div class="diff-analysis-card-icon">📉</div>
                        <div class="diff-analysis-card-content">
                            <div class="diff-analysis-card-label">減少用戶</div>
                            <div class="diff-analysis-card-value diff-analysis-negative">-{{summary.lost_users_count}}</div>
                            <!-- <div class="diff-analysis-card-subtitle">人</div> -->
                        </div>
                    </div>

                    <!-- 變化率 -->
                    <div class="diff-analysis-stat-card diff-analysis-growth-card"
                         [ngClass]="summary.growth_rate >= 0 ? 'diff-analysis-positive-growth' : 'diff-analysis-negative-growth'">
                        <div class="diff-analysis-card-icon">{{summary.growth_rate >= 0 ? '🚀' : '⚠️'}}</div>
                        <div class="diff-analysis-card-content">
                            <div class="diff-analysis-card-label">人數變化率</div>
                            <div class="diff-analysis-card-value"
                                 [ngClass]="summary.growth_rate >= 0 ? 'diff-analysis-positive' : 'diff-analysis-negative'">
                                {{summary.growth_rate >= 0 ? '+' : ''}}{{summary.growth_rate}}%
                            </div>
                            <div class="diff-analysis-card-subtitle">相較第一區間</div>
                        </div>
                    </div>
                </div>

                <!-- 用戶列表區 -->
                <div class="diff-analysis-user-lists-container">
                    <!-- 新增用戶列表 -->
                    <div class="diff-analysis-user-list-card diff-analysis-new-users-section">
                        <div class="diff-analysis-list-header">
                            <h3>
                                <span class="diff-analysis-header-icon">✨</span>
                                新增用戶
                                <span class="diff-analysis-badge diff-analysis-badge-success">{{new_users.length}}</span>
                            </h3>
                        </div>
                        <div class="diff-analysis-list-body">
                            <div *ngIf="new_users.length === 0" class="diff-analysis-empty-state">
                                <div class="diff-analysis-empty-icon">😊</div>
                                <p>無新增用戶</p>
                            </div>
                            <div *ngFor="let user of new_users; let i = index">
                                <a  href="{{ link }}/user/{{ user.uid }}" target="_blank">
                                    <div class="diff-analysis-user-item diff-analysis-new-user-item" style="margin-bottom: 10px;">
                                        <div class="diff-analysis-user-rank">{{i + 1}}</div>
                                        <div class="diff-analysis-user-avatar">
                                            <img loading="lazy" *ngIf="user.profile_pic"
                                                [src]="user.profile_pic"
                                                [alt]="user.name"
                                                class="diff-analysis-avatar-img"
                                                (error)="onImageError($event, user)">
                                            <span *ngIf="!user.profile_pic" class="diff-analysis-avatar-text">
                                                {{user.name}}
                                            </span>
                                        </div>
                                        <div class="diff-analysis-user-info">
                                            <div class="diff-analysis-user-name">{{user.name}}</div>
                                            <div class="diff-analysis-user-uid">ID: {{user.uid}}</div>
                                        </div>
                                        <div class="diff-analysis-user-stats">
                                            <div class="diff-analysis-stat-item">
                                                <span class="diff-analysis-stat-icon">🔑</span>
                                                <span class="diff-analysis-stat-value">{{user.login_times_front}}</span>
                                                <span class="diff-analysis-stat-label">登入次數</span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- 減少用戶列表 -->
                    <div class="diff-analysis-user-list-card diff-analysis-lost-users-section">
                        <div class="diff-analysis-list-header">
                            <h3>
                                <span class="diff-analysis-header-icon">💔</span>
                                減少用戶
                                <span class="diff-analysis-badge diff-analysis-badge-danger">{{lost_users.length}}</span>
                            </h3>
                        </div>
                        <div class="diff-analysis-list-body">
                            <div *ngIf="lost_users.length === 0" class="diff-analysis-empty-state">
                                <div class="diff-analysis-empty-icon">🎉</div>
                                <p>無流失用戶</p>
                            </div>
                            <div *ngFor="let user of lost_users; let i = index">
                                <a  href="{{ link }}/user/{{ user.uid }}" target="_blank">
                                    <div  class="diff-analysis-user-item diff-analysis-new-user-item" style="margin-bottom: 10px;">
                                        <div class="diff-analysis-user-rank">{{i + 1}}</div>
                                        <div class="diff-analysis-user-avatar">
                                            <img loading="lazy" *ngIf="user.profile_pic"
                                                 [src]="user.profile_pic"
                                                 [alt]="user.name"
                                                 class="diff-analysis-avatar-img"
                                                 (error)="onImageError($event, user)">
                                            <span *ngIf="!user.profile_pic" class="diff-analysis-avatar-text">
                                                {{user.name}}
                                            </span>
                                        </div>
                                        <div class="diff-analysis-user-info">
                                            <div class="diff-analysis-user-name">{{user.name}}</div>
                                            <div class="diff-analysis-user-uid">ID: {{user.uid}}</div>
                                        </div>
                                        <div class="diff-analysis-user-stats">
                                            <div class="diff-analysis-stat-item">
                                                <span class="diff-analysis-stat-icon">🔑</span>
                                                <span class="diff-analysis-stat-value">{{user.login_times_front}}</span>
                                                <span class="diff-analysis-stat-label">登入次數</span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- 列表顯示 -->
            <!-- 訊息數分析-->
            <div class="chart-section" *ngIf="activeTab == 'query' && activeTypeTab == 'message' && selectedGender === 'male'">
                <div class="message_analytics">
                    <!-- Header -->
                    <div class="message_analytics-header">
                        <div class="message_analytics-headerLeft">
                            <div class="message_analytics-title">男生儲值分段 × 收到女生訊息</div>
                            <div class="message_analytics-desc">依儲值區間觀察訊息流量與分布</div>
                        </div>

                        <div class="message_analytics-headerRight">
                            <div class="message_analytics-controls">
                                <div class="message_analytics-select">
                                    <label class="message_analytics-selectLabel">排序</label>
                                    <select class="message_analytics-selectInput" [(ngModel)]="sortKey">
                                        <option value="get_text_num">收到訊息</option>
                                    </select>
                                </div>

                                <button class="message_analytics-sortBtn" (click)="toggleSortDir()" type="button">
                                    <span class="message_analytics-sortText">{{ sortDir === 'desc' ? '高→低' : '低→高' }}</span>
                                </button>
                            </div>

                            <div class="message_analytics-searchWrap">
                                <span class="message_analytics-searchIcon">⌕</span>
                                <input
                                    class="message_analytics-searchInput"
                                    type="text"
                                    placeholder="搜尋姓名 / UID"
                                    (change)="searchKeyword()"
                                    [(ngModel)]="target_search_user"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Range cards -->
                    <div class="message_analytics-cards">
                        <div class="message_analytics-card" *ngFor="let b of filteredBlocks;trackBy: trackByFn">
                            <div class="message_analytics-cardTop">
                                <div>
                                    <div class="message_analytics-badge">{{ b.title }}</div>
                                    <div
                                        class="message_analytics-range"
                                        [attr.title]="getRangeTip(b.key)"
                                    >
                                        {{ b.key }}
                                    </div>
                                </div>
                                <div class="message_analytics-count">{{ b.count }} 人</div>
                            </div>

                            <!-- ✅ Detail list：改成 scroll 容器 -->
                            <div class="message_analytics-list message_analytics-listScroll">
                                <div class="message_analytics-row" *ngFor="let u of b.users">
                                    <div class="message_analytics-user">
                                        <a  target="_blank" href="{{link}}/user/{{ u.uid}};act=1">
                                            <img loading="lazy" class="message_analytics-userImg" [src]="u.profile_pic" />
                                        </a>
                                        <div class="message_analytics-userMeta">
                                            <div class="message_analytics-userName">{{ u.name }}</div>
                                            <div class="message_analytics-userSub">
                                                UID:
                                                <span class="message_analytics-mono">{{ u.uid }}</span>
                                            </div>
                                            <div class="message_analytics-userSub">
                                                最後登入時間：
                                                <span class="message_analytics-mono">{{ u.last_singin_date }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="message_analytics-metrics">
                                        <div class="message_analytics-metric" *ngIf="false">
                                            <div class="message_analytics-metricLabel">儲值</div>
                                            <div class="message_analytics-metricValue">{{ u.deposit_twd | number }}</div>
                                        </div>
                                        <div class="message_analytics-metric">
                                            <div class="message_analytics-metricLabel">收到訊息</div>
                                            <div
                                                class="message_analytics-pill"
                                                [class.message_analytics-pillZero]="!u.get_text_num"
                                                [class.message_analytics-pillHot]="u.get_text_num >= 50"
                                            >
                                                {{ u.get_text_num | number }}
                                            </div>
                                        </div>
                                             <div class="message_analytics-metric">
                                            <div class="message_analytics-metricLabel">事件推播</div>
                                            <div
                                                class="message_analytics-pill"
                                                [class.message_analytics-pillZero]="!0"
                                            >
                                                {{ u.trigger_push_num | number }}
                                            </div>
                                        </div>
                                             <div class="message_analytics-metric">
                                            <div class="message_analytics-metricLabel">單次推播</div>
                                            <div
                                                class="message_analytics-pill"
                                                 class="message_analytics-pill"
                                                [class.message_analytics-pillZero]="!0"
                                            >
                                                {{ u.once_push_num | number }}
                                            </div>
                                        </div>

                                        <div class="message_analytics-metric">
                                            <div class="message_analytics-metricLabel">定期推播</div>
                                            <div
                                                class="message_analytics-pill"
                                                [class.message_analytics-pillZero]="!0"
                                            >
                                                {{ u.regular_push_num | number }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <app-pagnation
                                *ngIf="b.paging_key == 'pagemessagestr2'"
                                class="message_analytics-pager"
                                [data]="pagemessagestr2"
                                (callback)="callbackListpage2($event)">
                            </app-pagnation>
                            <app-pagnation
                                *ngIf="b.paging_key == 'pagemessagestr1'"
                                class="message_analytics-pager"
                                [data]="pagemessagestr1"
                                (callback)="callbackListpage1($event)">
                            </app-pagnation>
                            <app-pagnation
                                *ngIf="b.paging_key == 'pagemessagestr'"
                                class="message_analytics-pager"
                                [data]="pagemessagestr"
                                (callback)="callbackListpage($event)">
                            </app-pagnation>

                        </div>
                    </div>
                </div>
            </div>

            <div class="chart-section" *ngIf="activeTab == 'query' && activeTypeTab == 'message' && selectedGender === 'female'">
                <div class="gmDash" *ngIf="dataMap">
                <!-- Header -->
                <div class="gmDash-header">
                    <div>
                        <div class="gmDash-title">女生訊息儀表板</div>
                        <div class="gmDash-subtitle">統計：有丟訊息 vs 上線沒丟訊息</div>
                    </div>

                    <div class="gmDash-pill" *ngIf="false">
                        總人數：{{ (dataMap?.hasText?.length || 0) + (dataMap?.noText?.length || 0) }}
                    </div>

                </div>
                <div class="sortBar" style="justify-content: space-between;">
                    <div class="message_analytics-searchWrap">
                        <span class="message_analytics-searchIcon">⌕</span>
                        <input
                            class="message_analytics-searchInput"
                            type="text"
                            placeholder="搜尋姓名 / UID"
                            (change)="searchKeyword()"
                            [(ngModel)]="target_search_user"
                        />
                    </div>
                    <div>
                        <label class="sortLabel">排序</label>
                        <select class="sortSelect" [(ngModel)]="hasSort" (change)="hasSortChange();">
                            <option value="msg_desc">訊息多 → 少</option>
                            <option value="msg_asc">訊息少 → 多</option>
                        </select>
                    </div>
                </div>

                    <!-- KPI -->
                    <div class="gmDash-kpi" *ngIf="false">
                        <div class="kpiCard kpiCard--accent">
                            <div class="kpiLabel">女生有丟訊息</div>
                            <div class="kpiValue">{{ dataMap?.hasText_total || 0 }}</div>
                        </div>

                        <div class="kpiCard kpiCard--warn">
                            <div class="kpiLabel">上線沒丟訊息</div>
                            <div class="kpiValue">{{ dataMap?.noText_total || 0 }}</div>
                            <div class="kpiMeta">可列入推播/引導名單</div>
                        </div>

                        <div class="kpiCard">
                            <div class="kpiLabel">互動率</div>
                            <div class="kpiValue">{{ interactionRate }}%</div>
                            <div class="kpiMeta">有丟 / 全部</div>
                        </div>
                    </div>

                    <!-- Lists -->
                    <div class="gmDash-grid">
                        <!-- hasText -->
                        <section class="listCard">
                            <div class="listHeader">
                                <div>
                                    <div class="listTitle">有丟訊息</div>
                                </div>
                            </div>

                            <div class="listBody">
                                <div class="userRow" *ngFor="let u of hasSorted">
                                    <a  target="_blank" href="{{link}}/user/{{ u.uid}};act=1">
                                        <img loading="lazy" class="avatar" [src]="u.profile_pic || defaultAvatar" alt="avatar" />
                                    </a>
                                    <div class="userMeta">
                                        <div class="userName">{{ u.name || '-' }}</div>
                                        <div class="userSub">{{ u.uid || u.user_id }}</div>
                                    </div>
                                    <div class="metric metric--good">
                                        <div class="metricNum">{{ u.text_num }}</div>
                                        <div class="metricLabel">訊息</div>
                                    </div>
                                </div>

                                <div class="empty" *ngIf="(dataMap?.hasText?.length || 0) === 0">
                                    目前沒有「有丟訊息」的女生
                                </div>
                            </div>
                            <app-pagnation
                                class="message_analytics-pager"
                                [data]="pagegirl_messagestr1"
                                (callback)="callbackmessagepage1($event)">
                            </app-pagnation>
                        </section>

                        <!-- noText -->
                        <section class="listCard">
                            <div class="listHeader">
                                <div>
                                    <div class="listTitle">上線沒丟訊息</div>
                                </div>
                            </div>

                            <div class="listBody listBody--scroll">
                                <div class="userRow" *ngFor="let u of noSorted">
                                    <a  target="_blank" href="{{link}}/user/{{ u.uid}};act=1">
                                        <img loading="lazy" class="avatar" [src]="u.profile_pic || defaultAvatar" alt="avatar" />
                                    </a>
                                    <div class="userMeta">
                                        <div class="userName">{{ u.name || '-' }}</div>
                                        <div class="userSub">{{ u.uid || u.user_id }}</div>
                                    </div>
                                    <div class="metric metric--muted">
                                        <div class="metricNum">0</div>
                                        <div class="metricLabel">訊息</div>
                                    </div>
                                </div>

                                <div class="empty" *ngIf="(dataMap?.noText?.length || 0) === 0">
                                    目前沒有「上線沒丟訊息」的女生
                                </div>
                            </div>
                            <app-pagnation
                                class="message_analytics-pager"
                                [data]="pagegirl_messagestr2"
                                (callback)="callbackmessagepage2($event)">
                            </app-pagnation>
                        </section>
                    </div>
                </div>
            </div>

           <div class="diff-analysis-container" *ngIf="(activeTab == 'diff' || activeTab == 'first') && activeTypeTab == 'message' && selectedGender === 'female'">
                <!-- KPI -->
                <div class="diff-header">
                    <div class="diff-title">女生訊息互動差異分析</div>
                </div>

                <!-- 有傳 -->
                <div class="diff-section">
                    <div class="section-head">
                        <div class="section-title success">🟢 有傳訊息 ({{analysisData.summary.has_count}}) </div>
                        <div class="section-tools">
                            <div class="tool">
                                <span class="tool-label">排序</span>
                                <select class="tool-select" [(ngModel)]="hasSort" (change)="hasSortChange();">
                                    <option value="msg_desc">訊息數 大 → 小</option>
                                    <option value="msg_asc">訊息數 小 → 大</option>
                                </select>
                            </div>
                            <div class="tool search">
                                <input class="tool-input" [(ngModel)]="target_search_user" (change)="searchKeyword()" placeholder="搜尋姓名 / UID"/>
                            </div>
                        </div>
                    </div>

                    <div class="scroll-box">
                        <div class="user-row" *ngFor="let u of analysisData.hasText">
                            <a  target="_blank" href="{{link}}/user/{{ u.uid}};act=1">
                                <img loading="lazy" class="avatar" [src]="u.profile_pic || 'https://chatmate.tw/img/default.png'" />
                            </a>
                            <div class="user-info">
                                <div class="name">{{ u.name || '未命名' }}</div>
                                <div class="uid">{{ u.uid }}</div>
                            </div>

                            <div class="user-metrics">
                                <div class="metric">
                                    <span class="label">訊息</span>
                                    <span class="value">{{ (u.after_text_num || u.after_text_num === 0) ? u.after_text_num : (u.text_num || 0) }}</span>
                                </div>
                                <div
                                    class="delta"
                                    [class.good]="isDeltaGood(u)"
                                    [class.bad]="isDeltaBad(u)"
                                    [class.neutral]="isDeltaNeutral(u)"
                                >
                                    Δ {{ getDelta(u) }}
                                </div>
                            </div>
                        </div>

                        <div class="empty" *ngIf="analysisData.hasText === 0">
                            沒有符合的資料
                        </div>
                    </div>
                    <app-pagnation
                        class="message_analytics-pager"
                        [data]="pagegirl_messagestr1"
                        (callback)="callbackmessagepage1($event)">
                    </app-pagnation>
                </div>

                <!-- 沒傳 -->
                <div class="diff-section">
                    <div class="section-head">
                        <div class="section-title muted">⚪ 沒傳訊息 ({{analysisData.summary.no_count}})</div>

                        <div class="section-tools">
                            <div class="tool">
                                <span class="tool-label">排序</span>
                                <select class="tool-select" [(ngModel)]="noSort">
                                    <option value="id_desc">ID ↓</option>
                                    <option value="id_asc">ID ↑</option>
                                    <option value="name_asc">姓名 A→Z</option>
                                    <option value="name_desc">姓名 Z→A</option>
                                    <option value="uid_asc">UID A→Z</option>
                                    <option value="uid_desc">UID Z→A</option>
                                </select>
                            </div>

                            <div class="tool search">
                                <input class="tool-input" [(ngModel)]="searchNo" placeholder="搜尋：姓名 / UID / ID"/>
                            </div>
                        </div>
                    </div>

                    <div class="scroll-box">
                        <div class="user-row" *ngFor="let u of analysisData.noText">
                            <a  target="_blank" href="{{link}}/user/{{ u.uid}};act=1">
                                <img loading="lazy" class="avatar" [src]="u.profile_pic || 'https://chatmate.tw/img/default.png'" />
                            </a>
                            <div class="user-info">
                                <div class="name">{{ u.name || '未命名' }}</div>
                                <div class="uid">{{ u.uid }}</div>
                            </div>

                            <div class="user-metrics muted">
                                未互動
                            </div>
                        </div>

                        <div class="empty" *ngIf="analysisData.noText.length === 0">
                            沒有符合的資料
                        </div>
                    </div>
                    <app-pagnation
                        class="message_analytics-pager"
                        [data]="pagegirl_messagestr2"
                        (callback)="callbackmessagepage2($event)">
                    </app-pagnation>
                </div>
            </div>


            <div class="diff-analysis-container" *ngIf="(activeTab == 'diff' || activeTab == 'first') && activeTypeTab == 'message' &&  analysisData.length > 0 &&  selectedGender === 'male'">
                <div class="message_analytics">
                    <div class="message_analytics-header">
                        <div class="message_analytics-headerLeft">
                            <div class="message_analytics-title">男生儲值分段 × 收到女生訊息</div>
                            <div class="message_analytics-desc">差異比對</div>
                        </div>

                        <div class="message_analytics-headerRight">
                            <div class="message_analytics-controls">
                                <div class="message_analytics-select">
                                    <label class="message_analytics-selectLabel">排序</label>
                                    <select class="message_analytics-selectInput" [(ngModel)]="sortKey">
                                        <option value="get_text_num">收到訊息</option>
                                    </select>
                                </div>

                                <button class="message_analytics-sortBtn" (click)="toggleSortDir()" type="button">
                                    <span class="message_analytics-sortText">{{ sortDir === 'desc' ? '高→低' : '低→高' }}</span>
                                </button>
                            </div>

                            <div class="message_analytics-searchWrap">
                                <span class="message_analytics-searchIcon">⌕</span>
                                <input
                                    class="message_analytics-searchInput"
                                    type="text"
                                    placeholder="搜尋姓名 / UID"
                                    (change)="searchKeyword()"
                                    [(ngModel)]="target_search_user"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="message_analytics-rangeCard" *ngFor="let range of analysisData">
                        <div class="message_analytics-rangeHeader">
                            <div class="message_analytics-badge">
                                {{ rangeLabel(range.range_key) }}
                            </div>
                            <div class="message_analytics-rangeTitle" [attr.title]="getRangeTip(range.range_key)">{{ range.range_key }}</div>
                            <div class="message-delta">
                                <span class="label">總訊息數變化量</span>

                                <span
                                    class="value"
                                    [ngClass]="{
                                      'up': (range.message_total.period2 || 0) > (range.message_total.period1 || 0),
                                      'down': (range.message_total.period2 || 0) < (range.message_total.period1 || 0),
                                      'same': (range.message_total.period2 || 0) === (range.message_total.period1 || 0)
                                    }"
                                >
                                    {{ range.message_total.period1 || 0 }}
                                    <span class="arrow">→</span>
                                        {{ range.message_total.period2 || 0 }}
                                    </span>
                            </div>
                            <div class="message_analytics-rangeMeta">{{ range.count || 0 }} 人</div>
                        </div>

                        <!-- ✅ 新增：可捲動的清單容器 -->
                        <div class="message_analytics-scrollList">
                            <div class="message_analytics-userRow" *ngFor="let u of range.users">
                                <div class="message_analytics-user">
                                    <a  target="_blank" href="{{link}}/user/{{ u.period2?.uid || u.period1?.uid }};act=1">
                                        <img loading="lazy" [src]="u.period2?.profile_pic || u.period1?.profile_pic" />
                                    </a>

                                    <div>
                                        <div class="message_analytics-userName">{{ u.period2?.name || u.period1?.name }}</div>
                                        <div class="message_analytics-userUid">{{ u.period2?.uid || u.period1?.uid }}</div>
                                        <div class="message_analytics-userUid">最後登入時間：{{ u.period2?.last_singin_date || u.period1?.last_singin_date }}</div>
                                    </div>
                                </div>

                                <div class="message_analytics-metric">
                                    <span class="label">收到訊息</span>
                                    <span class="value"
                                        [class.up]="(u.period2?.get_text_num || 0) > (u.period1?.get_text_num || 0)"
                                        [class.down]="(u.period2?.get_text_num || 0) < (u.period1?.get_text_num || 0)">
                                        {{ u.period1?.get_text_num || 0 }} → {{ u.period2?.get_text_num || 0 }}
                                    </span>
                                </div>

                                <div class="message_analytics-status" [class]="u.type">
                                    {{ u.type | uppercase }}
                                </div>
                            </div>
                        </div>
                        <app-pagnation
                            *ngIf="range.range_key == '30001+'"
                            class="message_analytics-pager"
                            [data]="pagemessagestr2"
                            (callback)="callbackListpage2($event)">
                        </app-pagnation>
                        <app-pagnation
                            *ngIf="range.range_key == '5001-30000'"
                            class="message_analytics-pager"
                            [data]="pagemessagestr1"
                            (callback)="callbackListpage1($event)">
                        </app-pagnation>
                        <app-pagnation
                            *ngIf="range.range_key == '100-5000'"
                            class="message_analytics-pager"
                            [data]="pagemessagestr"
                            (callback)="callbackListpage($event)">
                        </app-pagnation>
                        <app-pagnation
                            *ngIf="range.range_key == '0-99'"
                            class="message_analytics-pager"
                            [data]="pagemessagestr"
                            (callback)="callbackListpage($event)">
                        </app-pagnation>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="now=='8'" class="profile" style="margin-left:10px ;">

        <div *ngIf="overlayFlag">
            <div id="overlay"></div>
            <div id="chatRoom" class="chat-room">
                <div style="padding-bottom:26px">
                    <div class="icons-container" (click)="overlayFlag = false;checkstatus()" style=" position: absolute; /* 使用絕對定位 */top: 0; /* 距離父容器的頂部 */right: 0; /* 距離父容器的左側 */z-index: 1; /* 確保按鈕位於所有其他元素之上 */">
                        <i class="fas fa-times"></i>
                    </div>
                </div>
                <div class="scrollbar">
                    <div *ngFor="let item of detail_data; let i = index">

                        <div *ngIf="item.user_uid==chat_obj.to">
                            <div id="messages" class="messages" *ngIf="item.type*1==1 && item.content.length>0 && item.user_uid!='system'">
                                <div class="message" >

                                    <div style="width: 50px; height: 50px;  border-radius: 50%; margin-right:8px;overflow: hidden;">
                                        <img loading="lazy" style="width: 100%; height: 100%;" [src]="chartlistdata.profile_pic">
                                    </div>
                                    <div class="message-content" >
                                        {{item.content}}
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>


                            <div id="messages" class="messages" *ngIf="item.type*1==2 && item.media.file">
                                <div class="message" >
                                    <div style="width: 50px; height: 50px;  border-radius: 50%; margin-right:8px;overflow: hidden;">
                                        <img loading="lazy" style="width: 100%; height: 100%;" [src]="chartlistdata.profile_pic">
                                    </div>
                                    <div class="message-content" >
                                        <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>


                            <div id="messages" class="messages" *ngIf="item.type*1==3 && item.media.file">
                                <div class="message">
                                    <div style="width: 50px; height: 50px;  border-radius: 50%; margin-right:8px;overflow: hidden;">
                                        <img loading="lazy" style="width: 100%; height: 100%;" [src]="chartlistdata.profile_pic">
                                    </div>
                                    <div class="message-content" >
                                        <img loading="lazy"  style="width:100px" [src]="item.media.file[0].file_url">
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                            <div id="messages" class="messages" *ngIf="item.type*1==4 && item.media.file">
                                <div class="message">
                                    <div style="width: 50px; height: 50px;  border-radius: 50%; margin-right:8px;overflow: hidden;">
                                        <img loading="lazy" style="width: 100%; height: 100%;" [src]="chartlistdata.profile_pic">
                                    </div>
                                    <div class="message-content" >
                                        <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>


                            <div id="messages" class="messages" *ngIf="item.type*1==5">
                                <div class="message">
                                    <div class="message-content">
                                        系統:雙用戶進行互動
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                            <div id="messages" class="messages" *ngIf="item.type*1==7">
                                <div class="message">
                                    <div class="message-content">
                                        系統:對動態回復了:{{item.content}}
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                            <div id="messages" class="messages" *ngIf="item.type*1==8||item.type*1==10">
                                <div class="message">
                                    <div class="message-content" >
                                        系統:招呼語
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>



                            <div id="messages" class="messages" *ngIf="item.type*1==9">
                                <div class="message">
                                    <div class="message-content" >
                                        系統:使用群發:{{item.content}}
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                            <div id="messages" class="messages" *ngIf="item.type*1==11">
                                <div class="message">
                                    <div class="message-content" >
                                        系統:贈送了禮物
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                            <div id="messages" class="messages" *ngIf="item.type*1==14">
                                <div class="message">
                                    <div class="message-content" >
                                        系統:贈送了活動禮物
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                            <div id="messages" class="messages" *ngIf="item.type*1==15">
                                <div class="message">
                                    <div class="message-content" >
                                        系統:報名約會
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                            <div id="messages" class="messages" *ngIf="item.type*1==16">
                                <div class="message">
                                    <div class="message-content" >
                                        系統:解鎖動態
                                    </div>
                                    <span class="message-time">
                                        {{item.timeT}}
                                    </span>
                                </div>
                            </div>

                        </div>

                        <div *ngIf="item.user_uid==chat_obj.me">
                            <div class="message my-message" *ngIf="item.type*1==1 && item.content.length>0 && item.user_uid!='system'">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    {{item.content}}
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==2 && item.media.file">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    <video style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                </div>
                            </div>

                            <div class="message my-message"  *ngIf="item.type*1==3  && item.media.file">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    <img loading="lazy"  style="width:100px" [src]="item.media.file[0].file_url">
                                </div>
                            </div>

                            <div class="message my-message"  *ngIf="item.type*1==4  && item.media.file">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    <video style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==5">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    系統:雙用戶進行互動
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==7">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    系統:對動態回復了:{{item.content}}
                                </div>
                            </div>

                            <div class="message my-message"  *ngIf="item.type*1==8||item.type*1==10">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    系統:招呼語
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==9">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    使用群發:{{item.content}}
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==11">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    系統:贈送了禮物
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==14">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content" *ngIf="item.type*1==14">
                                    系統:贈送了活動禮物
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==16">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    系統:解鎖動態
                                </div>
                            </div>

                            <div class="message my-message" *ngIf="item.type*1==15">
                                <div style="display: flex;flex-direction: column-reverse;padding-right: 8px;">
                                    <span class="message-status">{{is_read[item.is_read*1]}}</span>
                                    <span class="message-time">{{item.timeT}}</span>
                                </div>
                                <div class="message-content">
                                    系統:報名約會
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="chat-pager">
                    <span class="chat-pager-info">
                        共 <b>{{chat_total_count}}</b> 句 / <b>{{chat_total_pages}}</b> 頁
                        <span class="chat-pager-cur">第 {{chat_page}} 頁</span>
                    </span>
                    <div class="chat-pager-btns">
                        <button type="button" class="chat-pager-btn"
                            [disabled]="chat_loading || chat_page<=1"
                            (click)="loadChatPage(1)">«</button>
                        <button type="button" class="chat-pager-btn"
                            [disabled]="chat_loading || chat_page<=1"
                            (click)="loadChatPage(chat_page-1)">‹</button>
                        <button type="button"
                            *ngFor="let p of getChatPageList()"
                            class="chat-pager-btn chat-pager-num"
                            [class.is-active]="p === chat_page"
                            [disabled]="chat_loading"
                            (click)="loadChatPage(p)">{{p}}</button>
                        <button type="button" class="chat-pager-btn"
                            [disabled]="chat_loading || chat_page>=chat_total_pages"
                            (click)="loadChatPage(chat_page+1)">›</button>
                        <button type="button" class="chat-pager-btn"
                            [disabled]="chat_loading || chat_page>=chat_total_pages"
                            (click)="loadChatPage(chat_total_pages)">»</button>
                        <span class="chat-pager-goto">
                            <input type="number" min="1" [max]="chat_total_pages"
                                class="chat-pager-input"
                                [(ngModel)]="chat_page_input"
                                [disabled]="chat_loading || chat_total_pages<=0"
                                (keyup.enter)="gotoChatPage()"
                                placeholder="頁碼">
                            <button type="button" class="chat-pager-btn chat-pager-go"
                                [disabled]="chat_loading || chat_total_pages<=0"
                                (click)="gotoChatPage()">前往</button>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <select class="form-control" style="width: 160px;display: inline-block;margin: 10px;" [(ngModel)]="tool_obj.profile_menu" (change)="pagedefaule();get_profile(edit_data);">
            <option *ngFor="let item of profile_menu_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <div class="resume">
            <div class="person">
                <div class="introduce">
                    <h4>{{profileMenuName()}}</h4>
                </div>

                <!-- 用戶標籤列：排程 voxy/cron/user_tag_cron.php 產生；完整內容在下拉「用戶標籤」 -->
                <div class="utag-strip" *ngIf="tool_obj.profile_menu!='13' && (user_tags || user_tags_loading)">
                    <ng-container *ngIf="user_tags && user_tags.profile">
                        <span class="utag-chip utag-seg" *ngIf="user_tags.profile.seg" title="分群">{{user_tags.profile.seg}} 群</span>
                        <span class="utag-chip utag-{{t.cls}}" *ngFor="let t of user_tags.brief" [title]="t.cat + '｜' + t.tip">{{t.key}}<b>{{t.val}}</b></span>
                        <a class="utag-more" (click)="tool_obj.profile_menu='13';get_profile(edit_data)">全部標籤 ›</a>
                        <div class="utag-summary" *ngIf="user_tags.summary && user_tags.summary['摘要']">{{user_tags.summary['摘要']}}</div>
                    </ng-container>
                    <span class="utag-empty" *ngIf="user_tags && !user_tags.profile">
                        尚無標籤：{{user_tags.ready === false ? '標籤資料表尚未建立' : (user_tags.seg_info && user_tags.seg_info.seg ? '屬於 ' + user_tags.seg_info.seg + ' 群，排程尚未輪到' : (user_tags.seg_info ? user_tags.seg_info.label : ''))}}
                        <a class="utag-more" (click)="tool_obj.profile_menu='13';get_profile(edit_data)">詳情 ›</a>
                    </span>
                    <span class="utag-empty" *ngIf="user_tags_loading && !user_tags">標籤載入中…</span>
                </div>
                <app-check-permissions [data]="'Kus1'">
                    <div *ngIf="tool_obj.profile_menu=='0'">
                        <textarea (change)="savetextarea()" [(ngModel)]="edit_data.memo"></textarea>
                    </div>
                </app-check-permissions>
                <app-check-permissions [data]="'Kus1'"  [type]="1">
                    <div *ngIf="tool_obj.profile_menu=='0'">
                        <textarea  [(ngModel)]="edit_data.memo"></textarea>
                    </div>
                </app-check-permissions>

                <div *ngIf="tool_obj.profile_menu=='1' &&  isDesktop == false" class="mobcontainer">
                    <h2 style="margin-bottom: 15px">{{edit_data.name}} 的事件紀錄</h2>

                    <app-date [time]="time" [type]="true" [timeset]="timeset" [limitset]="limitset" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <div class="events-list">
                        <div class="event-header">
                            <span>類型</span>
                            <span>項目名稱</span>
                            <span>鑽石數</span>
                            <span>對象頭像</span>
                            <span>對象名稱</span>
                            <span>時間</span>
                        </div>
                        <div *ngFor="let dataitem of content_data; trackBy: trackByFn" class="event-item">
                            <span class="labelmob label-{{dataitem.type}}">{{type_list[dataitem.type]}}</span>
                            <span>{{dataitem.event_name}}</span>
                            <span>{{formatNumber(dataitem.diamond)}}</span>
                            <img loading="lazy" [src]="dataitem.profile_pic" alt="" class="avatar">
                            <span><app-userandactive  [post]="dataitem"></app-userandactive></span>
                            <span>{{dataitem.target_dt}}</span>
                        </div>
                        <div *ngIf="content_data.length == 0" class="event-item">
                            <span>目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='1' && isDesktop == true" class="container">
                    <h2 style="margin-right: 22px;">{{edit_data.name}} 的事件紀錄</h2>

                    <app-date [time]="time" [type]="true" [timeset]="timeset" [limitset]="limitset" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <table class="lists">
                        <thead>
                            <tr>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">項目名稱</th>
                                <th style="width: 15%;">鑽石數</th>
                                <th style="width: 15%;">對象頭像</th>
                                <th style="width: 15%;">對象名稱</th>
                                <th style="width: 15%;">時間</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;"><span class="label label-{{dataitem.type}}">{{type_list[dataitem.type]}}</span></td>
                                <td style="width: 15%;">{{dataitem.event_name}}</td>
                                <td style="width: 15%;">{{formatNumber(dataitem.diamond)}}</td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    <app-userandactive  [post]="dataitem"></app-userandactive>
                                </td>
                                <td style="width: 15%;">{{dataitem.target_dt}}</td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td>目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <div *ngIf="tool_obj.profile_menu=='3' && isDesktop == false" class="mobcontainer">
                    <h2>{{edit_data.name}} 的登入紀錄</h2>
                    <div class="utag-note">
                        登入紀錄<b>只保留最近 90 天</b>，每天的排程會清掉更早的資料，所以查不到更久以前的紀錄是正常的、不是壞掉。
                        另外修剪只會跑在「近期有上線」的人身上，<b>長期沒上線的用戶會停在他最後一次活躍當下的狀態</b>
                        （例如最後登入是去年，就只會看到那前後幾天）。
                    </div>
                    <div class="events-list">
                        <div class="record-item-login">
                            <span class="item-label-login">日期</span>
                            <span class="item-label-login">登入次數</span>
                        </div>
                        <div class="record-item-login" *ngFor="let date of content_data;">
                            <span class="item-value-login">{{date.date}}</span>
                            <span class="item-value-login" style="padding-right: 50px;">{{date.times}}</span>
                        </div>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-value-login">目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='3' && isDesktop == true" class="container">
                    <h2>{{edit_data.name}} 的登入紀錄</h2>
                    <div class="utag-note">
                        登入紀錄<b>只保留最近 90 天</b>，每天的排程會清掉更早的資料，所以查不到更久以前的紀錄是正常的、不是壞掉。
                        另外修剪只會跑在「近期有上線」的人身上，<b>長期沒上線的用戶會停在他最後一次活躍當下的狀態</b>
                        （例如最後登入是去年，就只會看到那前後幾天）。
                    </div>
                    <div class="login-record">
                        <div class="record-item">
                            <span class="item-label">日期</span>
                            <span class="item-label">登入次數</span>
                        </div>
                        <div class="record-item" *ngFor="let date of content_data;">
                            <span class="item-value">{{date.date}}</span>
                            <span class="item-value" style="padding-right: 50px;">{{date.times}}</span>
                        </div>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-value">目前無資料</span>
                        </div>
                    </div>
                </div>

                <!-- 14 懸賞紀錄：bounty_list 裡他被懸賞(user_id) 與他去領賞(get_reward_user_id) 兩種角色都列 -->
                <div *ngIf="tool_obj.profile_menu=='14'" class="container">
                    <h2>{{edit_data.name}} 的懸賞紀錄</h2>
                    <div class="utag-note">
                        同時列出他<b>被懸賞</b>（別人來找他可以領賞）與他<b>去領別人的賞</b>兩種紀錄，用「角色」欄區分。
                        狀態：過期 / 取消 / 執行中 / 待派彩 / 已派彩。
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm utag-table">
                            <thead><tr><th>角色</th><th>懸賞對象</th><th>領賞人</th><th>鑽石</th><th>狀態</th><th>期間</th><th>發起人</th><th>建立</th></tr></thead>
                            <tbody>
                                <tr *ngFor="let b of content_data">
                                    <td>{{b.role}}</td>
                                    <td>
                                        <a *ngIf="b.target_uid" href="{{link}}/user/{{b.target_uid}};act=1" target="_blank">{{b.target_name || b.target_uid}}</a>
                                        <span *ngIf="!b.target_uid">—</span>
                                    </td>
                                    <td>
                                        <a *ngIf="b.getter_uid" href="{{link}}/user/{{b.getter_uid}};act=1" target="_blank">{{b.getter_name || b.getter_uid}}</a>
                                        <span *ngIf="!b.getter_uid">未領</span>
                                    </td>
                                    <td>{{b.diamond | number}}</td>
                                    <td>{{b.status_name}}</td>
                                    <td><small>{{b.due_start_date}} ~ {{b.due_end_date}}</small></td>
                                    <td>{{b.emp_name || '—'}}</td>
                                    <td><small>{{b.create_dt}}</small></td>
                                </tr>
                                <tr *ngIf="content_data.length == 0"><td colspan="8">目前無資料</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- 15 簡訊紀錄：once_sms_return(一次性) + sms_sent_log(群發) 合併，依時間新到舊 -->
                <div *ngIf="tool_obj.profile_menu=='15'" class="container">
                    <h2>{{edit_data.name}} 的簡訊紀錄</h2>
                    <div class="utag-note">
                        三個來源合併：<b>後台群發簡訊</b>（後台「一次性推播／簡訊」發的）、<b>系統群發簡訊</b>（未完成註冊、老友回歸等排程發的）、
                        <b>後台單人簡訊</b>（在這頁按「發送簡訊」直接發的）。
                        「有點開」是指他點了簡訊裡的短網址（ttpw.cc）。手機驗證碼不在這裡。
                        <br>⚠ 後台單人簡訊 <b>2026-09-14 之前發的是從後台操作日誌補登回來的</b>：當時這個功能直接呼叫外部簡訊商、沒存回傳，所以那些筆的結果會顯示「未知」。
                        排程發的簡訊也要等實際派送後才會出現（建立任務當下還不會有）。
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm utag-table">
                            <thead><tr><th>時間</th><th>來源</th><th>內容</th><th>短碼</th><th>有點開</th><th>備註</th></tr></thead>
                            <tbody>
                                <tr *ngFor="let s of content_data">
                                    <td><small>{{s.dt}}</small></td>
                                    <td>{{s.source}}</td>
                                    <td style="white-space: pre-wrap; max-width: 420px;">{{s.content || '—'}}</td>
                                    <td><small>{{s.code || '—'}}</small></td>
                                    <td>{{s.clicked ? '是' : '否'}}</td>
                                    <td><small>{{s.note}}</small></td>
                                </tr>
                                <tr *ngIf="content_data.length == 0"><td colspan="6">目前無資料</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='2'  && isDesktop == false " class="mobcontainer">
                    <h2>{{edit_data.name}} 的交易紀錄</h2>

                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <div class="export" style="margin-top: 0.5%;" *ngIf="(urltoken?.length > 0 && packstatus)">
                        有超過6個月的紀錄點此匯出
                        <a  href="{{urlprotoken}}" target="_blank"  class="btn btn-info">匯出</a>
                    </div>

                    <input type="text" id="searchInput-trade" placeholder="搜尋對象..." (change)="searchTarget()" [(ngModel)]="target_search">
                    <div class="events-list">
                        <div class="record-item-trade">
                            <span class="item-label-trade" style="width: 20%;">對象</span>
                            <span class="item-label-trade" style="width: 20%;">類型</span>
                            <span class="item-label-trade" style="width: 20%;">額度</span>
                            <span class="item-label-trade" style="width: 20%;">小結</span>
                            <span class="item-label-trade" style="width: 20%;">日期</span>
                        </div>
                        <ng-container *ngFor="let item of content_data">
                        <div class="record-item-trade" [style.cursor]="(item.rdes==='活動獎勵' && item.activity_name) ? 'pointer' : 'default'"
                             (click)="(item.rdes==='活動獎勵' && item.activity_name) ? (item._open = !item._open) : null">
                            <span class="item-value-trade" style="width: 20%;"><app-userandactive  [post]="item" [active]="3"></app-userandactive></span>
                            <span class="item-value-trade" style="width: 20%;">
                                {{item.rdes}}
                                <span *ngIf="item.rdes==='活動獎勵' && item.activity_name" style="color:#1565c0;font-size:12px;">{{item._open ? '▾' : '▸'}}</span>
                            </span>
                            <span class="item-value-trade" style="width: 20%;">{{item.added_value}}</span>
                            <span class="item-value-trade" style="width: 20%;">{{formatNumber(item.new_value)}}</span>
                            <span class="item-value-trade" style="width: 20%;">{{item.create_dt}}</span>
                        </div>
                        <div *ngIf="item._open && item.activity_name" style="padding:8px 18px;background:#f5f8ff;border-left:3px solid #1565c0;font-size:13px;color:#333;">
                            <b>活動：</b>{{item.activity_name}}<span *ngIf="item.activity_detail"> ｜ {{item.activity_detail}}</span>
                        </div>
                        </ng-container>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-value-trade" style="width: 20%;">目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='2'  && isDesktop == true " class="container">
                    <h2 style="margin-right: 10px;">{{edit_data.name}} 的交易紀錄</h2>

                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <div class="export" style="margin-top: 0.5%;" *ngIf="(urltoken?.length > 0 && packstatus)">
                        有超過6個月的紀錄點此匯出
                        <a  href="{{urlprotoken}}" target="_blank"  class="btn btn-info">匯出</a>
                    </div>

                    <input type="text" id="searchInput" placeholder="搜尋對象..." (change)="searchTarget()" [(ngModel)]="target_search">
                    <div class="login-record">
                        <div class="record-item">
                            <span class="item-label" style="width: 20%;">對象</span>
                            <span class="item-label" style="width: 20%;">類型</span>
                            <span class="item-label" style="width: 20%;">額度</span>
                            <span class="item-label" style="width: 20%;">小結</span>
                            <span class="item-label" style="width: 20%;">日期</span>
                        </div>
                        <ng-container *ngFor="let item of content_data">
                        <div class="record-item" [style.cursor]="(item.rdes==='活動獎勵' && item.activity_name) ? 'pointer' : 'default'"
                             (click)="(item.rdes==='活動獎勵' && item.activity_name) ? (item._open = !item._open) : null">
                            <span class="item-value" style="width: 20%;"><app-userandactive  [post]="item" [active]="3"></app-userandactive></span>
                            <span class="item-value" style="width: 20%;">
                                {{item.rdes}}
                                <span *ngIf="item.rdes==='活動獎勵' && item.activity_name" style="color:#1565c0;font-size:12px;">{{item._open ? '▾' : '▸'}}</span>
                            </span>
                            <span class="item-value" style="width: 20%;">{{item.added_value}}</span>
                            <span class="item-value" style="width: 20%;">{{formatNumber(item.new_value)}}</span>
                            <span class="item-value" style="width: 20%;">{{item.create_dt}}</span>
                        </div>
                        <div *ngIf="item._open && item.activity_name" style="padding:8px 18px;background:#f5f8ff;border-left:3px solid #1565c0;font-size:13px;color:#333;">
                            <b>活動：</b>{{item.activity_name}}<span *ngIf="item.activity_detail"> ｜ {{item.activity_detail}}</span>
                        </div>
                        </ng-container>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-value" style="width: 20%;">目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='4' && isDesktop == false" class="mobcontainer">
                    <h2>{{edit_data.name}} 的熱門恩客</h2>


                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <div class="events-list">
                        <div class="accordions-item-guest" *ngFor="let item of items">
                            <div class="accordions-header-guest" style="display: flex;" [class.active]="item.active" (click)="toggleItem(item)">
                                <div class="img_small" >
                                    <img loading="lazy"  [src]="item.profile_pic" alt="" class="picuser-guest">
                                </div>
                                <div>
                                    <span class="spans" style="font-size:15px"><app-userandactive  [post]="item"></app-userandactive></span>
                                    <div style="margin-top:10px;text-align: right;">
                                        <i class="fas fa-gem diamond-icon" ></i><span class="spannum">{{ formatNumber(item.total_diamond) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="accordions-content-guest" [style.max-height]="item.active ? '100%' : '0'">
                                <h2>{{item.name}} 的紀錄</h2>
                                <div class="login-record">
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">活動</span>
                                        <span class="item-label-guest" style="width: 20%;">{{ formatNumber(item.active_diamond) }}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">解鎖</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.album_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">約會</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.date_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">紅包</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.donate_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">遊戲</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.game_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">禮物</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.gift_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">直播</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.live_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">文字</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.text_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">視訊</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.video_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">語音</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.voice_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">語音房</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.voice_room_diamond)}}</span>
                                    </div>
                                    <div class="record-item-guest">
                                        <span class="item-label-guest" style="width: 20%;margin-left: 2%;">其他</span>
                                        <span class="item-label-guest" style="width: 20%;">{{formatNumber(item.other_diamond)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="items.length == 0">
                            <span class="item-label-guest" style="width: 20%;">目前無資料</span>
                        </div>
                    </div>
                </div>


                <div *ngIf="tool_obj.profile_menu=='4' && isDesktop == true" class="container">
                    <h2 style="margin-right: 20px;">{{edit_data.name}} 的熱門恩客</h2>

                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <div class="accordions">
                        <div class="accordions-item" *ngFor="let item of items">
                            <div class="accordions-header" style="display: flex;" [class.active]="item.active" (click)="toggleItem(item)">
                                <div class="img_small" >
                                    <img loading="lazy"  [src]="item.profile_pic" alt="" class="picuser">
                                </div>
                                <div>
                                    <span class="spans"><app-userandactive  [post]="item"></app-userandactive></span>
                                    <div style="margin-top:10px;text-align: right;">
                                        <i class="fas fa-gem diamond-icon" ></i><span class="spannum">{{ formatNumber(item.total_diamond) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="accordions-content" [style.max-height]="item.active ? '100%' : '0'">
                                <h2>{{item.name}} 的紀錄</h2>
                                <div class="login-record">
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">活動</span>
                                        <span class="item-label" style="width: 20%;">{{ formatNumber(item.active_diamond) }}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">解鎖</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.album_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">約會</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.date_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">紅包</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.donate_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">遊戲</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.game_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">禮物</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.gift_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">直播</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.live_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">文字</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.text_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">視訊</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.video_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">語音</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.voice_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">語音房</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.voice_room_diamond)}}</span>
                                    </div>
                                    <div class="record-item">
                                        <span class="item-label" style="width: 20%;margin-left: 2%;">其他</span>
                                        <span class="item-label" style="width: 20%;">{{formatNumber(item.other_diamond)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="items.length == 0">
                            <span style="width: 20%;">目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='5' && isDesktop == false"class="mobcontainer">
                    <h2 style="margin-bottom:20px"  *ngIf="edit_data.gender == 1">{{edit_data.name}}的儲值金額列表</h2>


                    <app-date [time]="time" [type]="true" [timeset]="dimomenttimeset" (rangeSelected)="handleRangeSelected($event)"></app-date>
                    <div class="record-table" style="margin-top: 10px;" *ngIf="edit_data.gender == 1">
                        <div class="record-header">總儲值金額</div>
                        <div class="record-section" style="display: flex;justify-content: space-around;">
                            <div class="record-section" style="border-bottom:1px">
                                <div class="total-label">總金額</div>
                                <div class="total-value">${{content_data[0]?.deposit_info?.total_money || '0'}}</div>
                            </div>
                            <div class="record-section">
                                <div class="total-label">總鑽石</div>
                                <div class="total-value">{{diamondtotal}}</div>
                            </div>
                        </div>

                        <div *ngIf="content_data[0]?.deposit_info?.data">
                            <div *ngFor="let itemdata of content_data[0].deposit_info.data">
                                <div class="record-header">{{os_typelist[itemdata.os_type]}}儲值紀錄</div>
                                <div class="record-section">
                                    <div class="record-row">
                                        <span class="record-label">儲值總金額</span>
                                        <span class="record-value">${{itemdata.money}}</span>
                                    </div>
                                    <div class="record-row">
                                        <span class="record-label">儲值次數</span>
                                        <span class="record-value">{{itemdata.num}}次</span>
                                    </div>
                                    <div class="record-row">
                                        <span class="record-label">占總趴數</span>
                                        <span class="record-value">{{itemdata.money_percent}}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="record-table" style="margin-top: 10px;" *ngIf="edit_data.gender == 2">
                        <div class="record-header">總鑽石數</div>
                        <div class="record-section">
                            <div class="total-label">總鑽石</div>
                            <div class="total-value">{{diamondtotal}}</div>
                        </div>
                    </div>

                    <div class="cool-hr" *ngIf="edit_data.gender == 1"></div>

                    <div style="margin-top: 20px;">
                        <h2>{{edit_data.name}} 的鑽石分析圖表</h2>
                    </div>

                    <div class="login-record">
                        <div  class="picchart-mob">
                            <highcharts-chart *ngIf="gender=='2'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions" style="display: block;width: 100%;margin:10px"></highcharts-chart>
                            <highcharts-chart *ngIf="gender=='1'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions2" style="display: block;width: 100%;margin:10px"></highcharts-chart>
                        </div>

                        <div  class="picchart-mob">
                            <highcharts-chart  *ngIf="gender=='2'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions3" style="display: block;width: 100%;margin:10px"></highcharts-chart>
                            <highcharts-chart  *ngIf="gender=='1'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions4" style="display: block;width: 100%;margin:10px"></highcharts-chart>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='5' && isDesktop == true"class="container">
                    <h2 style="margin-bottom:20px;margin-right: 20px;"  *ngIf="edit_data.gender == 1">{{edit_data.name}} 的儲值金額列表</h2>

                    <app-date [time]="time" [type]="true" [timeset]="dimomenttimeset" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <div class="record-table" *ngIf="edit_data.gender == 1">
                        <div class="record-header">總儲值金額</div>
                        <div class="record-section" style="display: flex;justify-content: space-around;">
                            <div class="record-section" style="border-bottom:1px">
                                <div class="total-label">總金額</div>
                                <div class="total-value">${{content_data[0]?.deposit_info?.total_money || '0'}}</div>
                            </div>
                            <div class="record-section">
                                <div class="total-label">總鑽石</div>
                                <div class="total-value">{{diamondtotal}}</div>
                            </div>
                        </div>

                        <div *ngIf="content_data[0]?.deposit_info?.data">
                            <div *ngFor="let itemdata of content_data[0].deposit_info.data">
                                <div class="record-header">{{os_typelist[itemdata.os_type]}}儲值紀錄</div>
                                <div class="record-section">
                                    <div class="record-row">
                                        <span class="record-label">儲值總金額</span>
                                        <span class="record-value">${{itemdata.money}}</span>
                                    </div>
                                    <div class="record-row">
                                        <span class="record-label">儲值次數</span>
                                        <span class="record-value">{{itemdata.num}}次</span>
                                    </div>
                                    <div class="record-row">
                                        <span class="record-label">占總趴數</span>
                                        <span class="record-value">{{itemdata.money_percent}}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="record-table" *ngIf="edit_data.gender == 2" style="margin-top: 5px;">
                        <div class="record-header">總鑽石數</div>
                        <div class="record-section">
                            <div class="total-label">總鑽石</div>
                            <div class="total-value">{{diamondtotal}}</div>
                        </div>
                    </div>

                    <div class="cool-hr" *ngIf="edit_data.gender == 1"></div>

                    <div style="margin-top: 20px;">
                        <h2>{{edit_data.name}} 的鑽石分析圖表</h2>
                    </div>

                    <div class="login-record">
                        <div  class="picchart">
                            <highcharts-chart *ngIf="gender=='2'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                            <highcharts-chart *ngIf="gender=='1'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions2" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                        </div>

                        <div  class="picchart">
                            <highcharts-chart  *ngIf="gender=='2'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions3" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                            <highcharts-chart  *ngIf="gender=='1'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions4" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                        </div>
                    </div>
                </div>


                <div *ngIf="tool_obj.profile_menu=='6' && isDesktop == false" class="mobcontainer">
                    <h2>{{edit_data.name}} 的新手任務列表</h2>
                    <div class="login-record">
                        <div class="record-item-newplayer">
                            <span class="item-label-newplayer" style="width: 20%;">任務狀態</span>
                            <span class="item-label-newplayer" style="width: 20%;">完成時間</span>
                            <span class="item-label-newplayer" style="width: 20%;">任務名稱</span>
                            <span class="item-label-newplayer" style="width: 20%;">現有積分</span>
                            <span class="item-label-newplayer" style="width: 20%;">目標積分</span>
                            <span class="item-label-newplayer" style="width: 20%;">鑽石數</span>
                            <span class="item-label-newplayer" style="width: 20%;">是否領獎</span>
                        </div>
                        <div class="record-item-newplayer" *ngFor="let key of content_data">
                            <span class="item-label-newplayer" style="width: 20%;">
                                <div class="icon-newplayer completed" *ngIf="key.cmp == '1'">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="icon-newplayer incomplete" *ngIf="key.cmp == '0'">
                                    <div class="bar-newplayer">
                                    <div class="bar_center-newplayer" *ngIf="key.now !== 0" [style.width.%]="key.target !== 0 ?((key.now / key.target) * 100).toFixed(2):0"></div>
                                    <span class="percentage-newplayer">{{key.target !== 0 ? ((key.now / key.target) * 100).toFixed(2):0 }}%</span>
                                </div>
                                </div>
                            </span>
                            <span class="item-label-newplayer" style="width: 20%;">{{key.dt | date:'yyyy-MM-dd'}}</span>
                            <span class="item-label-newplayer" style="width: 20%;">{{key.name}}</span>
                            <span class="item-label-newplayer" style="width: 20%;">{{key.now}}</span>
                            <span class="item-label-newplayer" style="width: 20%;">{{key.target}}</span>
                            <span class="item-label-newplayer" style="width: 20%;">{{formatNumber(key.points)}}</span>
                            <span class="item-label-newplayer" style="width: 20%;">
                                <div class="icon-newplayer yes" *ngIf="key.reward == '1'">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="icon-newplayer no" *ngIf="key.reward == '0'">
                                    <i class="fas fa-times-circle"></i>
                                </div>
                            </span>
                        </div>
                        <div class="record-item-newplayer" *ngIf="content_data.length == 0">
                            <span class="item-label-newplayer" style="width: 20%;">目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='6' && isDesktop == true" class="container">
                    <h2>{{edit_data.name}} 的新手任務列表</h2>
                    <div class="login-record">
                        <div class="record-item">
                            <span class="item-label" style="width: 20%;">任務狀態</span>
                            <span class="item-label" style="width: 20%;">完成時間</span>
                            <span class="item-label" style="width: 20%;">任務名稱</span>
                            <span class="item-label" style="width: 20%;">現有積分</span>
                            <span class="item-label" style="width: 20%;">目標積分</span>
                            <span class="item-label" style="width: 20%;">鑽石數</span>
                            <span class="item-label" style="width: 20%;">是否領獎</span>
                        </div>
                        <div class="record-item" *ngFor="let key of content_data">
                            <span class="item-label" style="width: 20%;">
                                <div class="icon completed" *ngIf="key.cmp == '1'">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="icon incomplete" *ngIf="key.cmp == '0'">
                                    <div class="bar">
                                    <div class="bar_center" *ngIf="key.now !== 0" [style.width.%]="key.target !== 0 ?((key.now / key.target) * 100).toFixed(2):0"></div>
                                    <span class="percentage">{{key.target !== 0 ? ((key.now / key.target) * 100).toFixed(2):0 }}%</span>
                                </div>
                                </div>
                            </span>
                            <span class="item-label" style="width: 20%;">{{key.dt | date:'yyyy-MM-dd'}}</span>
                            <span class="item-label" style="width: 20%;">{{key.name}}</span>
                            <span class="item-label" style="width: 20%;">{{key.now}}</span>
                            <span class="item-label" style="width: 20%;">{{key.target}}</span>
                            <span class="item-label" style="width: 20%;">{{formatNumber(key.points)}}</span>
                            <span class="item-label" style="width: 20%;">
                                <div class="icon yes" *ngIf="key.reward == '1'">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="icon no" *ngIf="key.reward == '0'">
                                    <i class="fas fa-times-circle"></i>
                                </div>
                            </span>
                        </div>
                        <div  class="record-item" *ngIf="content_data.length == 0">
                            <span class="item-label" style="width: 20%;">目前無資料</span>
                        </div>
                    </div>
                </div>


                <div *ngIf="tool_obj.profile_menu=='7'  && isDesktop == false" class="mobcontainer">
                    <h2>{{edit_data.name}} 的聊天列表</h2>
                    <input type="text" id="searchInput" placeholder="搜尋對象..." (change)="searchChartTarget()" [(ngModel)]="target_search" style="width: 240px;">
                    <table class="lists-chat">
                        <thead>
                            <tr>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">對象頭像</th>
                                <th style="width: 15%;">對象名稱</th>
                                <th style="width: 15%;">聊天內容</th>
                                <th style="width: 15%;">未讀訊息數</th>
                                <th style="width: 15%;">時間</th>
                                <th style="width: 15%;">詳細內容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;"><span class="label label-{{dataitem.type}}">{{type_chat_list[dataitem.type]}}</span></td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    <app-userandactive  [post]="dataitem" [active] = 4></app-userandactive>
                                </td>
                                <td style="width: 15%;">{{dataitem.content}}</td>
                                <td style="width: 15%;">{{dataitem.unread}}</td>
                                <td style="width: 15%;">
                                    {{dataitem.create_dt}}
                                </td>
                                <td style="width: 15%;">
                                    <i class="icon fas fa-info-circle" (click)="overlayFlag = true;select_user(dataitem,0);checkstatus()"></i>
                                </td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td style="width: 15%;">目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div *ngIf="tool_obj.profile_menu=='7' && isDesktop == true" class="container">
                    <h2 style="margin-right: 10px;">{{edit_data.name}} 的聊天列表</h2>
                    <input type="text" id="searchInput" placeholder="搜尋對象..." (change)="searchChartTarget()" [(ngModel)]="target_search">
                    <table class="lists">
                        <thead>
                            <tr>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">對象頭像</th>
                                <th style="width: 15%;">對象名稱</th>
                                <th style="width: 15%;">聊天內容</th>
                                <th style="width: 15%;">未讀訊息數</th>
                                <th style="width: 15%;">時間</th>
                                <th style="width: 15%;">詳細內容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;"><span class="label label-{{dataitem.type}}">{{type_chat_list[dataitem.type]}}</span></td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    <app-userandactive  [post]="dataitem" [active] = 4></app-userandactive>
                                </td>
                                <td style="width: 15%;">{{dataitem.content}}</td>
                                <td style="width: 15%;">{{dataitem.unread}}</td>
                                <td style="width: 15%;">
                                    {{dataitem.create_dt}}
                                </td>
                                <td style="width: 15%;">
                                    <i class="icon fas fa-info-circle" (click)="overlayFlag = true;select_user(dataitem,0);checkstatus()"></i>
                                </td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td style="width: 15%;">目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="tool_obj.profile_menu=='8'" class="container">
                    <h2 style="margin-right: 20px;">{{edit_data.name}} 的動態列表</h2>


                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>


                    <div style="margin-top: 5px;margin-bottom: 5px;">
                        <select class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="story_type_num" (change)="get_profile(edit_data);">
                            <option *ngFor="let item of story_type" [ngValue]="item.id">{{item.name}}</option>
                        </select>

                        <select  *ngIf="story_type_num == 0"  class="form-control" style="margin-left:3%;width: 160px;display: inline-block;" [(ngModel)]="copy_story_num" (change)="get_profile(edit_data);">
                            <option *ngFor="let item of copy_story_type" [ngValue]="item.id">{{item.name}}</option>
                        </select>

                        <select  *ngIf="story_type_num == 1"  class="form-control" style="margin-left:3%;width: 160px;display: inline-block;" [(ngModel)]="story_lock_num" (change)="get_profile(edit_data);">
                            <option *ngFor="let item of story_lock_type" [ngValue]="item.id">{{item.name}}</option>
                        </select>

                        <select  *ngIf="story_type_num == 1"  class="form-control" style="margin-left:3%;width: 220px;display: inline-block;" [(ngModel)]="view_story_type_num" (change)="get_profile(edit_data);">
                            <option *ngFor="let item of view_story_type" [ngValue]="item.id">{{item.name}}</option>
                        </select>

                    </div>

                    <div class="dynamic-list" *ngFor="let dataitem of content_data; trackBy: trackByFn">
                        <div class="list-item">
                            <div *ngIf="dataitem.is_enable == '6'" class="warning-badge">
                                <span class="warning-icon">⚠️</span>
                                <span class="warning-text">盜圖</span>
                            </div>
                            <img loading="lazy"  [src]="dataitem.url" alt="清涼照不見了" *ngIf="dataitem.type == '3'" style="max-width: 100%; height: auto;">
                            <video src="{{dataitem.url}}" controls *ngIf="dataitem.type == '4'"></video>
                            <div class="description">
                                <h3>動態描述</h3>
                                <p>{{dataitem.content}}</p>
                            </div>
                            <div class="description" *ngIf="story_type_num == 1">
                                <h3>上傳作者</h3>
                                <p>{{dataitem.name}}</p>
                                <h3 *ngIf="view_story_type_num == 1">不顯示於用戶解鎖動態</h3>
                                <p *ngIf="view_story_type_num == 1" style="color: red;">{{ getEnableDescription(dataitem.is_enable) }}</p>
                            </div>

                            <div class="actions">
                                <span class="likes">{{dataitem.love}} ❤️</span>
                                <span class="favorites">{{dataitem.collect}} 🌟</span>
                                <span class="comments">{{dataitem.comment_num}} 💬</span>
                                <span class="unlocks" *ngIf="story_lock_num == 1">1 🔓</span>
                                <span class="unlocks" *ngIf="story_lock_num == 3">{{dataitem.delock_num}} 🔓</span>
                                <span class="diamonds">{{dataitem.diamond}} 💎</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="content_data.length == 0">
                        <div class="list-item">目前無資料</div>
                    </div>
                </div>


                <!-- 13 用戶標籤：完整面板（資料來自 get_user_profile.php action 13 = UserTag::get_detail） -->
                <div *ngIf="tool_obj.profile_menu=='13'" class="container utag-panel">
                    <h2 style="margin-right: 20px;">{{edit_data.name}} 的用戶標籤</h2>

                    <div *ngIf="!user_tags" class="utag-card">{{user_tags_loading ? '載入中…' : '讀取失敗，請重新整理'}}</div>
                    <div *ngIf="user_tags && user_tags.ready === false" class="utag-card">
                        標籤資料表尚未建立（user_tag_profile / user_tag_chat_pair / user_tag_run_log），請先在主庫建表，見 voxy/docs/dev/dev_log/20260909_user_tag_ai.md。
                    </div>

                    <ng-container *ngIf="user_tags && user_tags.ready !== false">
                        <div class="utag-meta">
                            <span *ngIf="user_tags.seg_info">分群判定：<b>{{user_tags.seg_info.seg || '—'}}</b> {{user_tags.seg_info.label}}</span>
                            <span>最後上線日：<b>{{user_tags.last_singin_date ? (user_tags.last_singin_date | slice:0:10) : '—'}}</b><span class="utag-den" *ngIf="user_tags.last_singin_days !== null && user_tags.last_singin_days !== undefined">（{{user_tags.last_singin_days === 0 ? '今天' : user_tags.last_singin_days + ' 天前'}}）</span></span>
                            <ng-container *ngIf="user_tags.profile">
                                <span>最後更新：<b>{{user_tags.profile.updated_at || (user_tags.profile.seg ? '分析中 / 排隊中' : '尚未排到（標籤來自聊天對象分析時回填）')}}</b></span>
                                <span>AI 用量：<b>{{user_tags.profile.ai_calls}}</b> 次 / <b>${{user_tags.profile.cost_usd | number:'1.4-4'}}</b></span>
                            </ng-container>
                            <span class="utag-actions">
                                <button type="button" class="utag-btn utag-btn-main" (click)="requeue_user_tags(false)">重新排入分析</button>
                                <button type="button" class="utag-btn" (click)="requeue_user_tags(true)">重新排入並深讀對話</button>
                            </span>
                        </div>

                        <div *ngIf="!user_tags.profile" class="utag-card">
                            這位用戶還沒有標籤。{{user_tags.seg_info && user_tags.seg_info.seg ? '屬於 ' + user_tags.seg_info.seg + ' 群，排程（每 5 分鐘一人）尚未輪到，可按「重新排入分析」提前。' : '不符合 A/B/C 任一分群條件，排程不會主動分析。'}}
                        </div>

                        <ng-container *ngIf="user_tags.profile">
                            <div class="utag-acc-bar" *ngIf="user_tags.groups.length">
                                標籤分類
                                <a class="utag-more" (click)="toggleAllGroups(true)">全部展開</a>
                                <a class="utag-more" (click)="toggleAllGroups(false)">全部收合</a>
                                <span class="utag-den">標籤多的分類預設收起來，點標題可展開</span>
                            </div>

                            <div class="utag-card" *ngIf="user_tags.summary">
                                <h5>AI 速寫 <small>{{user_tags.summary.at}} · {{user_tags.summary.model}}</small></h5>
                                <p>{{user_tags.summary['摘要']}}</p>
                                <p *ngIf="user_tags.summary['接觸建議']"><b>接觸建議：</b>{{user_tags.summary['接觸建議']}}</p>
                                <p *ngIf="user_tags.summary['回歸切入點']"><b>老友回歸切入點：</b>{{user_tags.summary['回歸切入點']}}</p>
                                <p *ngIf="user_tags.summary['離開原因']"><b>離開原因：</b>{{user_tags.summary['離開原因']}}<span class="utag-den">（D 群專用：提領過但超過 30 天沒上的陪聊）</span></p>
                            </div>

                            <div class="utag-card" *ngFor="let g of user_tags.groups">
                                <h5 class="utag-acc" (click)="g.open = !g.open" [title]="g.open ? '點一下收合' : '點一下展開'">
                                    <span class="utag-caret">{{g.open ? '▾' : '▸'}}</span>{{g.cat}} <small>{{g.current.length}} 個</small>
                                    <span class="utag-peek" *ngIf="!g.open">{{g.peek}}</span>
                                    <a *ngIf="g.history.length && g.open" class="utag-more" (click)="$event.stopPropagation(); user_tags_history_open[g.cat] = !user_tags_history_open[g.cat]">{{user_tags_history_open[g.cat] ? '收合歷程' : '切換歷程 ' + g.history.length}}</a>
                                </h5>
                                <ng-container *ngIf="g.open">
                                    <div class="utag-chips">
                                        <span class="utag-chip utag-{{g.cls}}" *ngFor="let t of g.current" [title]="t.tip">{{t.key}}<b>{{t.val}}</b><i *ngIf="t.n > 1">×{{t.n}}</i><i *ngIf="t.src === 'ai'">AI</i></span>
                                    </div>
                                    <ul class="utag-history" *ngIf="user_tags_history_open[g.cat]">
                                        <li *ngFor="let t of g.history">{{t.key}}：{{t.val}} <span>{{t.since}} → {{t.until}} 切換</span></li>
                                    </ul>
                                </ng-container>
                            </div>

                            <div class="utag-card" *ngIf="user_tags.pref_keys.length">
                                <h5>穩聊對象方向 <small>他最常聊的那幾位女生，個人頁與聊天風格的共同點</small></h5>
                                <div class="utag-note">
                                    每列只顯示<b>前 3 名</b>，所以人數相加不會等於對象總數。
                                    「年齡層／星座／身高」每人只有一個值，各值相加最多等於「有填此欄的人數」；
                                    「興趣／個性／外型／聊天風格」一個人可以有好幾個，相加會超過人數。
                                </div>
                                <div class="utag-pref-row" *ngFor="let k of user_tags.pref_keys">
                                    <b>{{k}}</b>
                                    <span class="utag-chip utag-pref" *ngFor="let v of user_tags.pref.pref[k]">{{v[0]}}<i>{{v[1]}} 人</i></span>
                                    <em class="utag-den" *ngIf="user_tags.pref_meta[k]">
                                        {{user_tags.pref_meta[k].partners}} 位有此資料<span *ngIf="user_tags.pref_meta[k].distinct > user_tags.pref_meta[k].shown">，共 {{user_tags.pref_meta[k].distinct}} 種、只列前 {{user_tags.pref_meta[k].shown}} 種</span><span *ngIf="user_tags.pref_meta[k].mode === 'multi'"> · 可複選</span>
                                    </em>
                                </div>
                            </div>

                            <div class="utag-card" *ngIf="user_tags.pairs.length">
                                <!-- D 群女生是自己那輪讀的對話，不是被男方寫回的；其餘女生（C 群）才是被動寫回 -->
                                <h5>{{user_tags.profile.gender == 1 ? '愛聊對象' : (user_tags.profile.seg === 'D' ? '聊過的對象（她自己那輪讀的）' : '聊過的對象（由男方分析時寫回）')}}
                                    <small *ngIf="user_tags.pref && user_tags.pref.stats">已分析 {{user_tags.pref.stats.count}} 位<span *ngIf="user_tags.pref.stats.all_partners > user_tags.pref.stats.count"> / 全部 {{user_tags.pref.stats.all_partners | number}} 位</span> · 進行中 {{user_tags.pref.stats['進行中']}} · 一段時間未連繫 {{user_tags.pref.stats['一段時間未連繫']}} · 冷漠 {{user_tags.pref.stats['冷漠']}}<span *ngIf="user_tags.pref.stats.styles"> · 其中收尾不歡而散 {{user_tags.pref.stats.styles['不歡而散']}}</span></small>
                                </h5>
                                <div class="utag-note">
                                    取<b>男方發話數最多</b>的前幾位分析，不是全部聊天對象。
                                    <br><b>熱度</b>與<b>關係狀態</b>是<b>規則算的</b>，而且每次打開這頁都重算（不是分析當天的快照）。依據兩個數字：
                                    <b>最後互動距今幾天</b>（＝讀到的最新一句的時間）與<b>讀取區間內平均每天幾句</b>（讀到的句數 ÷ 那段對話橫跨的天數；鯨魚讀不完全部，所以是區間密度、不是全期平均），兩個數字都列在欄位下方可以自己核對。
                                    <br>關係狀態：{{user_tags.cfg.rel_active_days || 7}} 天內＝<b>進行中</b>；{{(user_tags.cfg.rel_active_days || 7) + 1}}~{{user_tags.cfg.rel_idle_days || 30}} 天＝<b>一段時間未連繫</b>；超過 {{user_tags.cfg.rel_idle_days || 30}} 天＝<b>冷漠</b>。
                                    <br>熱度：進行中且每天 ≥ {{user_tags.cfg.heat_per_day || 3}} 句＝<b>熱絡</b>；進行中但沒到門檻、或一段時間未連繫＝<b>一般</b>；冷漠＝<b>冷淡</b>。
                                    <br><b>收尾</b>（關係狀態下方的小字）才是 AI 的判斷，只看<b>最後一段對話怎麼收的</b> —— 有爭執、抱怨、被拒、封鎖意味 →「不歡而散」；互道再見或明顯收尾 →「和平結束」；單方面不再回 →「自然淡出」；話題還在進行 →「還在聊」。
                                    模型看不到今天的日期，所以「現在還熱不熱」不由它判斷。
                                    <br><b>付費意願</b>：AI 判斷 —— 他在對話中主動送禮、加值、答應付費的表現 → 高 / 中 / 低。
                                    <br>「讀取」＝這對讀了幾包對話（一包 200 句）／實際送進模型幾句。
                                    <span *ngIf="user_tags.pairs.length > user_tags.pairs_page.count">
                                        <br>共 {{user_tags.pairs.length}} 位，每頁 {{user_tags.pairs_page.count}} 筆，
                                        目前第 {{user_tags.pairs_page.page + 1}} 頁（換頁不會重新查詢）。
                                    </span>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-sm utag-table">
                                        <thead><tr><th>#</th><th>對象</th><th>句數</th><th>讀取</th><th>熱度</th><th>關係狀態</th><th>付費意願</th><th>關係摘要</th><th>更新</th></tr></thead>
                                        <tbody>
                                            <tr *ngFor="let p of user_tags.pairs_view; let i = index" [class.utag-err]="p.end_status === 'error'" [class.utag-bad]="p.end_style === '不歡而散'">
                                                <td><small class="utag-den">{{user_tags.pairs_page.page * user_tags.pairs_page.count + i + 1}}</small></td>
                                                <td><a href="{{link}}/user/{{p.partner_uid}};act=1" target="_blank">{{p.partner_name}}</a><br><small>{{p.partner_uid}}</small></td>
                                                <td>{{p.chat_num_total | number}}</td>
                                                <td>{{p.packets_read}} 包 / {{p.msg_count | number}} 句</td>
                                                <td>
                                                    {{p.heat || '—'}}
                                                    <br><small class="utag-den" *ngIf="p.idle_days !== null && p.idle_days !== undefined">{{p.idle_days === 0 ? '今天還在聊' : '最後互動 ' + p.idle_days + ' 天前'}}</small>
                                                    <br><small class="utag-den" *ngIf="p.per_day">讀取區間 {{p.span_days}} 天 · 每天約 {{p.per_day}} 句</small>
                                                </td>
                                                <td>{{p.rel_state || '—'}}
                                                    <br><small class="utag-den" *ngIf="p.end_style">收尾：{{p.end_style}}</small>
                                                    <br><small *ngIf="p.relation['結束原因']">{{p.relation['結束原因']}}</small></td>
                                                <td>{{p.relation['男方付費意願'] || '—'}}</td>
                                                <td>{{p.relation['摘要'] || p.relation['錯誤'] || '—'}}</td>
                                                <td><small>{{p.updated_at || '未分析'}}</small></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagnation *ngIf="user_tags.pairs.length > user_tags.pairs_page.count"
                                    (callback)="onPairsPage($event)" [data]="user_tags.pairs_pageview"></app-pagnation>
                            </div>

                            <div class="utag-card" *ngIf="user_tags.runs.length">
                                <h5>最近排程紀錄
                                    <small>此人累計花費 <b>${{user_tags.profile.cost_usd | number:'1.4-4'}}</b> · 共 {{user_tags.runs_rounds}} 輪 · 表格顯示 {{user_tags.runs.length}} 筆</small>
                                </h5>
                                <div class="utag-note">
                                    <b>階段</b>：規則標籤＝算作息／花費／個人頁那些不花錢的標籤；聊天對象＝讀某一位對象的對話丟給 AI；
                                    本輪未完＝這一輪時間用完、下一輪會接著做同一個人；完成＝這個人全部做完；略過＝沒有新資料不用重跑；錯誤＝該輪出狀況。
                                    <br><b>AI 次數</b>：這一列動作呼叫模型幾次。一位對象的對話太長會切成幾段、每段一次，最後再一次寫速寫，所以一個人加起來會有幾十次。
                                    <br>一位有 200 個對象的用戶跑一輪會寫兩百多列紀錄，所以表格固定保留<b>每一輪的結果列</b>（完成／本輪未完／略過／錯誤），
                                    明細列（規則標籤／聊天對象）只留最近幾筆。<b>結果列的成本已含該輪所有對象</b>，把全部列相加會重複計算。
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-sm utag-table">
                                        <thead><tr><th>時間</th><th>階段</th><th>狀態</th><th>耗時</th><th>AI 次數</th><th>成本</th><th>說明</th></tr></thead>
                                        <tbody>
                                            <tr *ngFor="let r of user_tags.runs" [class.utag-err]="r.status === 'error'">
                                                <td><small>{{r.create_dt}}</small></td>
                                                <td>{{phaseLabel(r.phase)}}</td>
                                                <td>{{r.status === 'ok' ? '正常' : '錯誤'}}</td>
                                                <td>{{r.elapsed_ms | number}} ms</td>
                                                <td>{{r.ai_calls}}</td>
                                                <td>${{r.cost_usd | number:'1.4-4'}}</td>
                                                <td><small>{{r.message}}</small></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>


                <div *ngIf="tool_obj.profile_menu=='9' && isDesktop == false" class="mobcontainers">
                    <h2 *ngIf="edit_data.gender == '1'">{{edit_data.name}} 的入金紀錄</h2>
                    <h2 *ngIf="edit_data.gender == '2'">{{edit_data.name}} 的出金紀錄</h2>

                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>


                    <div class="login-record" *ngIf="edit_data.gender == '1'">
                        <div class="record-item-money" style="text-align: center;">
                            <span class="item-label-money" style="width: 15%;">類型</span>
                            <span class="item-label-money" style="width: 15%;">鑽石/金額</span>
                            <span class="item-label-money" style="width: 10%;">是否確認</span>
                            <span class="item-label-money" style="width: 20%;">時間</span>
                            <span class="item-label-money" style="width: 15%;">交易ID</span>
                            <span class="item-label-money" style="width: 15%;">查看異常</span>
                        </div>
                        <div class="record-item" *ngFor="let data of content_data" style="text-align: center;">
                            <span class="label label-{{data.type}}" style="width: 15%;">{{moneyin[data.type*1]}}</span>
                            <span class="item-label-money" style="width: 15%;margin-left: 15px;">
                                <div style="text-align: left;"><i class="fas fa-gem diamond-icon" style="padding-right: 6px;"></i>{{formatNumber(data.diamond)}}</div>
                                <div style="text-align: left;margin-top: 8px;"><i class="fas fa-dollar-sign dollar-icon" style="padding-right: 6px;"></i>{{formatNumber(data.money)}}</div>
                            </span>
                            <span class="item-label-money" style="width: 10%;">
                                <div class="icon-money yes" *ngIf="data.is_checked == '1'">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="icon-money no" *ngIf="data.is_checked == '0'">
                                    <i class="fas fa-times-circle"></i>
                                </div>
                            </span>
                            <span class="item-label-money" style="width: 20%;">{{data.create_dt}}<br>美西時間<br>{{data.usa_create_dt}}</span>
                            <span class="item-label-money item-label-money-type" style="width: 15%;">{{data.trade_id}}</span>
                            <span class="item-label-money" style="width: 15%;display: flex;justify-content: space-evenly;">
                                <div class="iap-icon-money" (click)="ToTradelist('cart')" style="cursor: pointer;">
                                    <i class="fas fa-shopping-cart"></i>
                                    <span>IAP</span>
                                </div>
                                <div class="payment-icon-money" (click)="ToTradelist('credit')" style="cursor: pointer;">
                                    <i class="fas fa-credit-card"></i>
                                    <span>金流</span>
                                </div>
                            </span>
                        </div>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-label-money" style="width: 15%;">目前無資料</span>
                        </div>
                    </div>
                    <div class="login-record" *ngIf="edit_data.gender == '2'">
                        <div class="record-item-money">
                            <span class="item-label-money">類型</span>
                            <span class="item-label-money">金額</span>
                            <span class="item-label-money">日期</span>
                        </div>
                        <div class="record-item-money" *ngFor="let data of content_data">
                            <span class="label label-{{data.type}}">{{moneyout[data.type*1]}}</span>
                            <span class="item-label-money">{{formatNumber(data.money)}}</span>
                            <span class="item-label-money">{{data.create_dt}}</span>
                        </div>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-label-money">目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='9' && isDesktop == true" class="container">
                    <h2 *ngIf="edit_data.gender == '1'" style="margin-right: 20px;">{{edit_data.name}} 的入金紀錄</h2>
                    <h2 *ngIf="edit_data.gender == '2'" style="margin-right: 20px;">{{edit_data.name}} 的出金紀錄</h2>

                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>



                    <div class="login-record" *ngIf="edit_data.gender == '1'">
                        <div class="record-item" style="text-align: center;">
                            <span class="item-label" style="width: 15%;">類型</span>
                            <span class="item-label" style="width: 15%;">鑽石/金額</span>
                            <span class="item-label" style="width: 10%;">是否確認</span>
                            <span class="item-label" style="width: 20%;">時間</span>
                            <span class="item-label" style="width: 15%;">交易ID</span>
                            <span class="item-label" style="width: 15%;">查看異常</span>
                        </div>
                        <div class="record-item" *ngFor="let data of content_data" style="text-align: center;">
                            <span class="label label-{{data.type}}" style="width: 15%;">{{moneyin[data.type*1]}}</span>
                            <span class="item-label" style="width: 15%;">
                                <div style="text-align: left;"><i class="fas fa-gem diamond-icon" style="padding-right: 6px;"></i>{{formatNumber(data.diamond)}}</div>
                                <div style="text-align: left;margin-top: 8px;"><i class="fas fa-dollar-sign dollar-icon" style="padding-right: 6px;"></i>{{formatNumber(data.money)}}</div>
                            </span>
                            <span class="item-label" style="width: 10%;">
                                <div class="icon yes" *ngIf="data.is_checked == '1'">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="icon no" *ngIf="data.is_checked == '0'">
                                    <i class="fas fa-times-circle"></i>
                                </div>
                            </span>
                            <span class="item-label" style="width: 20%;">{{data.create_dt}}<br>美西時間<br>{{ data.usa_create_dt}}</span>
                            <span class="item-label" style="width: 15%;">{{data.trade_id}}</span>
                            <span class="item-label" style="width: 15%;display: flex;justify-content: space-evenly;">
                                <div class="iap-icon" (click)="ToTradelist('cart')" style="cursor: pointer;">
                                    <i class="fas fa-shopping-cart"></i>
                                    <span>IAP</span>
                                </div>
                                <div class="payment-icon" (click)="ToTradelist('credit')" style="cursor: pointer;">
                                    <i class="fas fa-credit-card"></i>
                                    <span>金流</span>
                                </div>
                            </span>
                        </div>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-label" style="width: 15%;">目前無資料</span>
                        </div>
                    </div>
                    <div class="login-record" *ngIf="edit_data.gender == '2'">
                        <div class="record-item">
                            <span class="item-label">類型</span>
                            <span class="item-label">金額</span>
                            <span class="item-label">日期</span>
                        </div>
                        <div class="record-item" *ngFor="let data of content_data">
                            <span class="label label-{{data.type}}">{{moneyout[data.type*1]}}</span>
                            <span class="item-label">{{formatNumber(data.money)}}</span>
                            <span class="item-label">{{data.create_dt}}</span>
                        </div>
                        <div *ngIf="content_data.length == 0">
                            <span class="item-label">目前無資料</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="tool_obj.profile_menu=='10' &&  isDesktop == false" class="mobcontainer">
                    <h2>{{edit_data.name}} 的活動禮物紀錄</h2>

                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>

                    <div class="events-list">
                        <div class="event-header">
                            <span>類型</span>
                            <span>禮物名稱</span>
                            <span>數量</span>
                            <span>對象頭像</span>
                            <span>對象名稱</span>
                            <span>時間</span>
                        </div>
                        <div *ngFor="let dataitem of content_data; trackBy: trackByFn" class="event-item">
                            <span class="labelmob label-{{dataitem.type}}">{{gifttype_list[dataitem.type]}}</span>
                            <span>{{dataitem.item_name}}{{dataitem.emoji}}</span>
                            <span>{{formatNumber(dataitem.num)}}</span>
                            <img loading="lazy" [src]="dataitem.target_user_profile_pic" alt="" class="avatar">
                            <span><app-userandactive  [post]="dataitem" [active] = 5></app-userandactive></span>
                            <span>{{dataitem.create_dt}}</span>
                        </div>
                        <div *ngIf="content_data.length == 0" class="event-item">
                            <span>目前無資料</span>
                        </div>
                    </div>
                </div>

                <div *ngIf="tool_obj.profile_menu=='10' && isDesktop == true" class="container">
                    <h2 style="margin-right: 10px;">{{edit_data.name}} 的活動禮物紀錄</h2>


                    <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>
                    <table class="lists">
                        <thead>
                            <tr>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">禮物名稱</th>
                                <th style="width: 15%;">數量</th>
                                <th style="width: 15%;">對象頭像</th>
                                <th style="width: 15%;">對象名稱</th>
                                <th style="width: 15%;">時間</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;"><span class="label labelactive-{{dataitem.type}}">{{gifttype_list[dataitem.type]}}</span></td>
                                <td style="width: 15%;">{{dataitem.item_name}}{{dataitem.emoji}}</td>
                                <td style="width: 15%;">{{formatNumber(dataitem.num)}}</td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.target_user_profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    <app-userandactive  [post]="dataitem" [active] = 5></app-userandactive>
                                </td>
                                <td style="width: 15%;">{{dataitem.create_dt}}</td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td>目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="tool_obj.profile_menu=='11'  && isDesktop == false" class="mobcontainer">
                    <h2>{{edit_data.name}} 的通訊紀錄列表</h2>
                    <input type="text" id="searchInput" placeholder="搜尋對象..." (change)="searchChartTarget()" [(ngModel)]="target_search" style="width: 240px;">
                    <div style="margin-top: 1%;">
                        <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>
                    </div>
                    <table class="lists-chat">
                        <thead>
                            <tr>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">發起者頭像</th>
                                <th style="width: 15%;">發起者名稱</th>
                                <th style="width: 15%;">對象頭像</th>
                                <th style="width: 15%;">對象名稱</th>
                                <th style="width: 15%;">結束通訊者</th>
                                <th style="width: 15%;">開始時間</th>
                                <th style="width: 15%;">結束時間</th>
                                <th style="width: 15%;">秒數</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;"><span class="label label-{{dataitem.type}}">{{type_chat_list[dataitem.type]}}</span></td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    <app-userandactive  [post]="dataitem" [active] = 4></app-userandactive>
                                </td>
                                <td style="width: 15%;">{{dataitem.content}}</td>
                                <td style="width: 15%;">{{dataitem.unread}}</td>
                                <td style="width: 15%;">
                                    {{dataitem.create_dt}}
                                </td>
                                <td style="width: 15%;">
                                    <i class="icon fas fa-info-circle" (click)="overlayFlag = true;select_user(dataitem,0);checkstatus()"></i>
                                </td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td style="width: 15%;">目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div *ngIf="tool_obj.profile_menu=='11' && isDesktop == true" class="container">
                    <div style="display:flex;justify-content: space-between;">
                        <h2 style="margin-right: 10px;">{{edit_data.name}} 的通訊紀錄列表</h2>
                        <input type="text" id="searchInput" placeholder="搜尋對象..." (change)="searchChartTarget()" [(ngModel)]="target_search">
                        <ul class="nav nav-pills">
                            <div *ngIf="commType == 2">
                                <i class="fas fa-plus" style="cursor: pointer;align-content: center;color: cadetblue;margin-right: 20px;font-size: xx-large;" (click)="adderrlist(edit_data)"></i>
                            </div>
                            <li class="nav-item">
                                <a class="nav-link"
                                   href="javascript:void(0)"
                                   [ngClass]="{'active': commType == 1}"
                                   (click)="comm_type(1)">
                                   通訊紀錄
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link"
                                   href="javascript:void(0)"
                                   [ngClass]="{'active': commType == 2}"
                                   (click)="comm_type(2)">
                                   通訊紀錄備查
                                </a>
                            </li>
                            <li class="nav-item"  *ngIf="commType != 2">
                                <a class="nav-link"
                                   href="javascript:void(0)"
                                   [ngClass]="{'active': commType == 3}"
                                   (click)="comm_type(3)">
                                   通訊費率紀錄
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div style="margin-top: 1%;">
                        <app-date [time]="time" [type]="true" (rangeSelected)="handleRangeSelected($event)"></app-date>
                    </div>
                    <table class="lists" *ngIf="commType == 1">
                        <thead>
                            <tr>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">發起者頭像</th>
                                <th style="width: 15%;">發起者名稱</th>
                                <th style="width: 15%;">對象頭像</th>
                                <th style="width: 15%;">對象名稱</th>
                                <th style="width: 15%;">結束通訊者</th>
                                <th style="width: 15%;">開始時間</th>
                                <th style="width: 15%;">結束時間</th>
                                <th style="width: 15%;">秒數</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;"><span class="label label-{{dataitem.type}}">{{type_commit_list[dataitem.type]}}</span></td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.from_user_profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.from_user_name}}
                                </td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.to_user_profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">{{dataitem.to_user_name}}</td>
                                <td style="width: 15%;">
                                    {{ dataitem.break_status == 1 ? '發起者掛斷' : '對方掛斷' }}
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.start_time}}
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.end_time}}
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.secs}}
                                </td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td style="width: 15%;">目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="lists" *ngIf="commType == 2">
                        <thead>
                            <tr>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">發起者頭像</th>
                                <th style="width: 15%;">發起者名稱</th>
                                <th style="width: 15%;">開始時間</th>
                                <th style="width: 15%;">詳細內容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;"><span class="label label-{{dataitem.action}}">
                                    {{type_commit_err_list[dataitem.action]}}</span></td>
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.name}}
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.create_dt}}
                                </td>
                                <td style="width: 15%;">
                                    <i class="icon fas fa-info-circle" data-toggle="modal" data-target="#staticBackdrop" (click) = "get_err_comm(dataitem)"></i>
                                </td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td style="width: 15%;">目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="lists" *ngIf="commType == 3">
                        <thead>
                            <tr>
                                <th style="width: 15%;">頭像</th>
                                <th style="width: 15%;">名稱</th>
                                <th style="width: 15%;">類型</th>
                                <th style="width: 15%;">舊值</th>
                                <th style="width: 15%;">新值</th>
                                <th style="width: 15%;">更新時間</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dataitem of content_data; trackBy: trackByFn">
                                <td style="width: 15%;">
                                    <img loading="lazy"  [src]="dataitem.profile_pic" alt="" style="width: 30px;">
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.name}}
                                </td>
                                <td style="width: 15%;">
                                    {{ dataitem.type == 1 ? '語音費率' : (dataitem.type == 2 ? '文字費率' : (dataitem.type == 3 ? '視訊費率' : '未知')) }}
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.ori_value}}
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.new_value}}
                                </td>
                                <td style="width: 15%;">
                                    {{dataitem.create_time}}
                                </td>
                            </tr>
                            <tr *ngIf="content_data.length == 0">
                                <td style="width: 15%;">目前無資料</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <app-pagnation (callback)="callback3($event)" [data]="pageobjstr3"></app-pagnation>

            </div>

            <!-- Modal -->
            <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog custom-modal-size">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">通訊紀錄備查</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <thead>
                                <tr>
                                    <th style="width: 5%;text-align: center;">類型</th>
                                    <th style="width: 10%;text-align: center;">發起者名稱</th>
                                    <th style="width: 10%;text-align: center;">發起者頭像</th>
                                    <th style="width: 10%;text-align: center;">對象名稱</th>
                                    <th style="width: 5%;text-align: center;">對象頭像</th>
                                    <th style="width: 5%;text-align: center;">費率</th>
                                    <th style="width: 5%;text-align: center;">秒數</th>
                                    <th style="width: 15%;text-align: center;">開始時間</th>
                                    <th style="width: 15%;text-align: center;">結束時間</th>
                                    <th style="width: 20%;text-align: center;">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let dataitem of err_data let i = index" >
                                    <td style="width: 5%;text-align: center;">
                                        <span class="label label-1">
                                            {{dataitem.callingCategory}}
                                        </span>
                                    </td>
                                    <td style="width: 10%;text-align: center;">
                                       {{dataitem.callerUsername}}
                                    </td>
                                    <td style="width: 10%;text-align: center;">
                                        <img loading="lazy"  [src]="dataitem.callerUserprofile_pic" alt="" style="width: 30px;">
                                    </td>
                                    <td style="width: 10%;text-align: center;">
                                        {{dataitem.receiverUsername}}
                                    </td>
                                    <td style="width: 5%;text-align: center;">
                                        <img loading="lazy"  [src]="dataitem.receiverUserprofile_pic" alt="" style="width: 30px;">
                                    </td>
                                    <td style="width: 5%;text-align: center;">
                                        {{dataitem.callingFee}}
                                    </td>
                                    <td style="width: 5%;text-align: center;">
                                        {{dataitem.duration}}
                                    </td>
                                    <td style="width: 15%;text-align: center;">
                                        {{dataitem.startCallingTime}}
                                    </td>
                                    <td style="width: 15%;text-align: center;">
                                        {{dataitem.endCalledTime}}
                                    </td>
                                    <td style="width: 20%;text-align: center;" *ngIf="dataitem.status == 0 && dataitem.duration >= 5">
                                        <button type="button"
                                            class="btn btn-secondary"
                                            data-toggle="collapse"
                                            [attr.data-target]="'#collapseExample' + i"
                                            aria-expanded="false"
                                            [attr.aria-controls]="'collapseExample' + i"
                                            style="background: rgb(67, 37, 173); margin: 0;"
                                            (click)="insert_diamond(dataitem)">
                                                補鑽
                                        </button>
                                        <div class="collapse" [attr.id]="'collapseExample' + i">
                                            <div class="card card-body">
                                                <div class="user_edit_block form-group" >
                                                    <div style="display: flex;">
                                                        <label class="col-sm-3 col-form-label">秒數</label>
                                                        <input
                                                            type="number"
                                                            class="form-control show_input"
                                                            style="width: 40%; margin-right: 6%;"
                                                            [(ngModel)]="diamond_second"
                                                            [min]="0"
                                                            (input)="validateInput()"
                                                        />
                                                        <button type="button" class="btn btn-secondary"  style="background: rgb(37 173 91); margin: 0;" (click)="send_diamon(diamond_second,dataitem,i)">
                                                            送出
                                                        </button>
                                                    </div>
                                                    <div style="text-align: left;">
                                                      <div class="tips" style="margin-right: 26%;">1.如秒數不對請輸入正確秒數</div>
                                                      <div class="tips" style="margin-right: 26%;">2.如若分鐘數少於實際分數直接輸入秒數差</div>
                                                      <div class="tips" style="margin-right: 26%;">3.(紀錄300秒實際通訊480秒則輸入180秒即可)</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width: 20%;text-align: center;" *ngIf="dataitem.status == 1 && dataitem.duration >= 5">
                                        申請中
                                    </td>
                                    <td style="width: 20%;text-align: center;" *ngIf="dataitem.status == 2 && dataitem.duration >= 5">
                                        已補完
                                    </td>
                                </tr>
                                <tr *ngIf="content_data.length == 0">
                                    <td style="width: 15%;">目前無資料</td>
                                </tr>
                                <app-pagnation (callback)="callback5($event)" [data]="pageobjstr4"></app-pagnation>
                            </tbody>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" style="background:rgb(0, 195, 255)" data-dismiss="modal">關閉</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="right">
                <div class="about">
                    <div class="border left top"></div>
                    <div class="border right top"></div>
                    <div class="border left bottom"></div>
                    <div class="border right bottom"></div>
                    <div class="about_border"></div>

                    <!--內容-->
                    <div class="info">
                        <div class="lvinfo" *ngIf="edit_data.score">
                            <div class="d-flex">
                                <div class="w-100 mr-3">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="d-flex align-items-center" style="font-size: 18px; font-weight: 700;">
                                            <span style="display: inline-block; width: 16px; height: 16px; background-color: #B8860B; margin-top: 2px;
                                                mask-image: url('https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/person-16.svg');
                                                mask-size: contain; -webkit-mask-image: url('https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/person-16.svg'); -webkit-mask-size: contain;" class="mr-2">
                                            </span>
                                            姓名
                                        </div>
                                        <span style="font-weight: 700;">{{edit_data.name}}</span>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="d-flex align-items-center" style="font-size: 18px; font-weight: 700;">
                                            <span style="display: inline-block; width: 16px; height: 16px; background-color: #B8860B; margin-top: 2px;
                                                mask-image: url('https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/sparkle-fill-16.svg');
                                                mask-size: contain; -webkit-mask-image: url('https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/sparkle-fill-16.svg'); -webkit-mask-size: contain;" class="mr-2">
                                            </span>
                                            VIP等級
                                        </div>
                                        <div class="star">{{ '★'.repeat(edit_data.score.vip_rank) }}</div>
                                    </div>

                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="d-flex align-items-center" style="font-size: 18px; font-weight: 700;">
                                            <span style="display: inline-block; width: 16px; height: 16px; background-color: #B8860B; margin-top: 2px;
                                                mask-image: url('https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/pulse-16.svg'); mask-size: contain;
                                                -webkit-mask-image: url('https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/pulse-16.svg'); -webkit-mask-size: contain;" class="mr-2">
                                            </span>
                                            活躍度
                                        </div>
                                        <div class="lv"><span>{{edit_data.score.active_score}} / </span><span class="o">100</span></div>
                                    </div>
                                    <div class="bar" >
                                        <div class="bar_center" *ngIf="edit_data.score.active_score" [style.width.%]="edit_data.score.active_score"></div>
                                    </div>
                                </div>
                                <div class="flex-grow-1" style="height: 120px;">
                                    <img loading="lazy" class="rounded-2" [src]="edit_data.profile_pic" alt="" style="height: 100%; object-fit: contain;">
                                </div>
                            </div>

                            <hr>

                            <ul class="base d-flex flex-wrap" style="font-size: 12px;">
								<li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/hash-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">ID：</span>
                                    <div class="d-flex align-items-center">{{edit_data.id}}</div>
                                </li>
                                <!-- <li> -->
                                    <!-- <label>姓名：</label> -->
                                    <!-- <div class="text">{{edit_data.name}}</div> -->
                                <!-- </li> -->
                                <li class="d-flex align-items-center w-50 mb-2" >
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/device-mobile-16.svg" width="14" height="14" class="mr-1" style="margin-top: 1px;">電話：</span>
                                    <div class="d-flex align-items-center">{{edit_data.phone_num}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/key-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">UID：</span>
                                    <div class="d-flex align-items-center">{{edit_data.uid}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/calendar-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">生日：</span>
                                    <div class="d-flex align-items-center">{{edit_data.birthday}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/device-desktop-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">裝置：</span>
                                    <div class="d-flex align-items-center" >
                                        <span *ngIf = "edit_data.os_type == 3" style="font-size: 12px;">網頁</span>
                                        <span *ngIf = "edit_data.os_type == 2" style="font-size: 12px;">iOs</span>
                                        <span *ngIf = "edit_data.os_type == 1" style="font-size: 12px;">安卓</span>
                                    </div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/ruby-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">鑽石數：</span>
                                    <div class="d-flex align-items-center">{{edit_data.total_diamond | number}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/broadcast-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">本日群發數：</span>
                                    <div class="d-flex align-items-center">{{edit_data.message_times}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/comment-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">文字費率：</span>
                                    <div class="d-flex align-items-center">{{edit_data.text_fee}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/video-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">視訊費率：</span>
                                    <div class="d-flex align-items-center">{{edit_data.video_fee}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/unmute-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">語音費率：</span>
                                    <div class="d-flex align-items-center">{{edit_data.voice_fee}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/bell-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">是否可推播：</span>
                                    <div class="d-flex align-items-center">{{edit_data.cron_push_status ? '是' : '否'}}</div>
                                </li>
                                <li class="d-flex align-items-center w-100 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/clock-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">最後推播成功時間：</span>
                                    <div class="d-flex align-items-center" style="width: 150px;">{{edit_data.last_cron_push_dt}}</div>
                                </li>
                                <li class="d-flex align-items-center w-100 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/calendar-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">註冊時間：</span>
                                    <div class="d-flex align-items-center" style="width: 150px;">{{edit_data.create_dt}}</div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/briefcase-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">身分：</span>
                                    <div class="d-flex align-items-center">{{identityName(edit_data.identity)}}<span class="utag-den">（{{edit_data.identity}}）</span></div>
                                </li>
                                <li class="d-flex align-items-center w-50 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/shield-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">帳號狀態：</span>
                                    <div class="d-flex align-items-center" [style.color]="userIsBlocked() ? '#c00' : '#1a7f37'" style="font-weight:700;">{{userStatusName()}}</div>
                                </li>
                                <li class="d-flex align-items-center w-100 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/ruby-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">現有鑽石數：</span>
                                    <!-- 換算說明收進 title：右欄在 1300~1500px 寬時只有 ~280px，整句攤開會把整欄撐到不能縮 -->
                                    <div class="d-flex align-items-center" title="{{diamondRate()}} 鑽 = 1 元（{{edit_data.gender == 1 ? '男生依儲值' : '女生依提領'}}匯率）">{{edit_data.diamond | number}}<span class="utag-den">（約 NT${{diamondToTwd(edit_data.diamond) | number}}）</span></div>
                                </li>
                                <li class="d-flex align-items-center w-100 mb-2">
                                    <span class="d-flex align-items-center" style="font-size: 12px; color: #303030;"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/sign-in-16.svg" width="14" height="14" class="mr-1" style="margin-top: 2px;">最後上線時間：</span>
                                    <div class="d-flex align-items-center" style="width: 150px;">{{edit_data.last_singin_date || '—'}}</div>
                                </li>
                            </ul>
                            <div class="d-flex align-items-center" style="gap: 8px; margin-top: 10px;">
                                <app-check-permissions [data]="'9Ms0'" style="display: contents;">
                                    <button (click)="copyToClipboard()" class="btn btn-light btn-hover text-nowrap" style="flex: 1; color: #333;">複製token</button>
                                </app-check-permissions>
                                <button type="button" class="btn btn-hover text-nowrap" style="flex: 1; background: rgb(255, 179, 0); color: #333;" (click)="view_history()">歷史經紀</button>
                                <button type="button" class="btn btn-hover text-nowrap" style="flex: 1; background: rgb(0, 179, 255); color: white;" (click)="view_nickname_history()">歷史暱稱</button>
                            </div>
                        </div>

                    </div>
                    <hr>
                    <div class="state">
                        <div class="sec_title p">
                            <h4>收益/花費比例</h4>
                        </div>
                        <ul class="list_type" *ngIf="edit_data.category">
                            <li>
                                <div class="list_title">文字</div>
                                <div class="bar" (mouseover)="showPercentage[0] = true" (mouseout)="showPercentage[0] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.text !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.text / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage" *ngIf="!showPercentage[0]">{{edit_data.category.total !== 0 ? ((edit_data.category.text / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage" *ngIf="showPercentage[0]">{{ formatNumber(edit_data.category.text) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">語音</div>
                                <div class="bar" (mouseover)="showPercentage[1] = true" (mouseout)="showPercentage[1] = false">
                                    <div class="bar_center"  *ngIf="edit_data.category.voice !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.voice / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage" *ngIf="!showPercentage[1]">{{ edit_data.category.total !== 0 ?((edit_data.category.voice / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage" *ngIf="showPercentage[1]">{{ formatNumber(edit_data.category.voice) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">視訊</div>
                                <div class="bar" (mouseover)="showPercentage[2] = true" (mouseout)="showPercentage[2] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.video !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.video / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[2]">{{ edit_data.category.total !== 0 ?((edit_data.category.video / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[2]">{{ formatNumber(edit_data.category.video) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">解鎖</div>
                                <div class="bar" (mouseover)="showPercentage[3] = true" (mouseout)="showPercentage[3] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.album !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.album / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[3]">{{ edit_data.category.total !== 0 ?((edit_data.category.album / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[3]">{{ formatNumber(edit_data.category.album) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">禮物</div>
                                <div class="bar"  (mouseover)="showPercentage[4] = true" (mouseout)="showPercentage[4] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.gift !== 0"  [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.gift / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[4]">{{ edit_data.category.total !== 0 ?((edit_data.category.gift / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[4]">{{ formatNumber(edit_data.category.gift) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">遊戲</div>
                                <div class="bar" (mouseover)="showPercentage[5] = true" (mouseout)="showPercentage[5] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.game !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.game / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[5]">{{ edit_data.category.total !== 0 ?((edit_data.category.game / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[5]">{{ formatNumber(edit_data.category.game) }}</span>

                                </div>
                            </li>
                            <li>
                                <div class="list_title">直播</div>
                                <div class="bar" (mouseover)="showPercentage[6] = true" (mouseout)="showPercentage[6] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.live !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.live / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[6]">{{ edit_data.category.total !== 0 ?((edit_data.category.live / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[6]">{{ formatNumber(edit_data.category.live) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">約會</div>
                                <div class="bar" (mouseover)="showPercentage[7] = true" (mouseout)="showPercentage[7] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.date !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.date / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[7]">{{ edit_data.category.total !== 0 ?((edit_data.category.date / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[7]">{{ formatNumber(edit_data.category.date) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">紅包</div>
                                <div class="bar" (mouseover)="showPercentage[8] = true" (mouseout)="showPercentage[8] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.donate !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.donate / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[8]">{{ edit_data.category.total !== 0 ?((edit_data.category.donate / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[8]">{{ formatNumber(edit_data.category.donate) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">語音房</div>
                                <div class="bar" (mouseover)="showPercentage[9] = true" (mouseout)="showPercentage[9] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.voice_room !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.voice_room / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[9]">{{ edit_data.category.total !== 0 ?((edit_data.category.voice_room / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[9]">{{ formatNumber(edit_data.category.voice_room) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">活動</div>
                                <div class="bar" (mouseover)="showPercentage[10] = true" (mouseout)="showPercentage[10] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.active !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.active / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[10]">{{ edit_data.category.total !== 0 ?((edit_data.category.active / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[10]">{{formatNumber(edit_data.category.active) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="list_title">其他</div>
                                <div class="bar"  (mouseover)="showPercentage[11] = true" (mouseout)="showPercentage[11] = false">
                                    <div class="bar_center" *ngIf="edit_data.category.other !== 0" [style.width.%]="edit_data.category.total !== 0 ?((edit_data.category.other / edit_data.category.total) * 100).toFixed(2):0"></div>
                                    <span class="percentage"    *ngIf="!showPercentage[11]">{{ edit_data.category.total !== 0 ?((edit_data.category.other / edit_data.category.total) * 100).toFixed(2):0 }}%</span>
                                    <span class="percentage"    *ngIf="showPercentage[11]">{{ formatNumber(edit_data.category.other) }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="special">
                        <div class="sec_title g">
                            <h4>介紹語</h4>
                        </div>
                        <p style="margin:10px">{{edit_data.greeting}}</p>
                    </div>
                    <div class="special">
                        <div class="sec_title g">
                            <h4>自我介紹</h4>
                        </div>
                        <p style="margin:10px">{{edit_data.introduction}}</p>
                    </div>
                    <div class="skill">
                        <div class="sec_title p">
                            <h4>系統Tag</h4>
                        </div>
                        <ul>
                            <li>無</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 13 懸賞與簡訊：全站懸賞紀錄（原 11 懸賞列表）+ 全站簡訊紀錄（系統群發 sms_sent_log／後台群發 once_sms_return／後台單人 manual_sms_log） -->
    <div *ngIf="now=='13'" style="margin-left:10px;">

        <div class="rec-tabs">
            <!-- 簡訊在左且預設（2026-09-16 老闆要求），懸賞在右 -->
            <button type="button" class="btn btn-sm" [class.btn-primary]="rec_sub=='sms'" [class.btn-outline-secondary]="rec_sub!='sms'" (click)="rec_sub='sms'">簡訊紀錄（全站）</button>
            <button type="button" class="btn btn-sm" [class.btn-primary]="rec_sub=='bounty'" [class.btn-outline-secondary]="rec_sub!='bounty'" (click)="rec_sub='bounty'">懸賞紀錄</button>
        </div>

        <div *ngIf="rec_sub=='bounty'">

            <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 10px;" [(ngModel)]="bountry_status_num" (change)="pagebolur.page=0;bounty_list()">
                <option *ngFor="let item of bountry_status" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <app-table-v2 [type]="1" [data]="bounty_arr"  [tcontent]="bluer_tcontent" *ngIf="bounty_arr.length>0">

                <ng-template let-post #operation_dk>

                    <div *ngIf="post.key == 'status'">
                        <span *ngIf="post.val.status==-1">過期</span>
                        <span *ngIf="post.val.status==0">取消</span>
                        <span *ngIf="post.val.status==1">執行</span>
                        <span *ngIf="post.val.status==2">待派彩</span>
                        <span *ngIf="post.val.status==3">已派彩</span>
                    </div>

                </ng-template>

            </app-table-v2>
            <div *ngIf="bounty_arr.length==0" class="utag-note">目前沒有符合這個狀態的懸賞。</div>

            <app-pagnation (callback)="callback4($event)" [data]="pagebolurstr"></app-pagnation>

        </div>

        <div *ngIf="rec_sub=='sms'">

            <div class="utag-note">
                三個來源合併、新到舊：<b>後台群發簡訊</b>（後台「一次性推播／簡訊」發的，每個收件人一筆）、
                <b>系統群發簡訊</b>（未完成註冊、老友回歸等排程群發，每個收件人一筆）、<b>後台單人簡訊</b>（履歷頁「發送簡訊」逐人發的）。
                時間是任務派送時間。「有點開」＝他點了簡訊裡的短網址（ttpw.cc），「點後登入」只有群發有追蹤。
                後台單人簡訊 <b>2026-09-14 之前的是由後台操作日誌補登</b>，結果會顯示未知。手機驗證碼不在這裡。
            </div>

            <!-- 第一列：檢視切換（逐筆紀錄 / 成效分析）。兩種檢視各自一列工具，不混在一起（2026-09-16 老闆反映下拉與按鈕擠在一起很怪） -->
            <div class="rec-tabs" style="margin-bottom:8px;">
                <button type="button" class="btn btn-sm" [class.btn-primary]="sms_view=='rows'" [class.btn-outline-secondary]="sms_view!='rows'" (click)="sms_set_view('rows')">逐筆紀錄</button>
                <button type="button" class="btn btn-sm" [class.btn-primary]="sms_view=='camp'" [class.btn-outline-secondary]="sms_view!='camp'" (click)="sms_set_view('camp')">成效分析</button>
                <span class="utag-den" style="white-space:normal;" *ngIf="sms_points !== null">三竹簡訊點數餘額 {{sms_points | number}}</span>
            </div>

            <!-- 逐筆紀錄的篩選列：來源／日期／關鍵字 -->
            <div *ngIf="sms_view=='rows'" class="d-flex align-items-center flex-wrap" style="gap:8px;margin-bottom:10px;">
                <select class="form-control" style="width:140px;display:inline-block;" [(ngModel)]="sms_source" (change)="search_sms_log()">
                    <option [ngValue]="0">全部來源</option>
                    <option [ngValue]="1">後台群發簡訊</option>
                    <option [ngValue]="2">系統群發簡訊</option>
                    <option [ngValue]="3">後台單人簡訊</option>
                </select>
                <input type="date" class="form-control" style="width:165px;display:inline-block;" [(ngModel)]="sms_start_dt" (change)="search_sms_log()">
                <span>～</span>
                <input type="date" class="form-control" style="width:165px;display:inline-block;" [(ngModel)]="sms_end_dt" (change)="search_sms_log()">
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="sms_start_dt='';sms_end_dt='';search_sms_log()" title="不限日期會掃整張群發表，會比較慢">不限日期</button>
                <input type="text" class="form-control" style="width:240px;display:inline-block;" placeholder="uid / 暱稱 / 門號 / 內容" [(ngModel)]="sms_log_keyword" (keyup.enter)="search_sms_log()">
                <button type="button" class="btn btn-primary btn-sm" (click)="search_sms_log()">搜尋</button>
            </div>

            <!-- 成效分析的工具列：三個子分頁 + 期間。成效分析一律撈三個來源，不吃上面的來源下拉與關鍵字 -->
            <div *ngIf="sms_view=='camp'" class="d-flex align-items-center flex-wrap" style="gap:8px;margin-bottom:10px;">
                <div class="sms-subtabs" style="margin:0;">
                    <button type="button" class="btn btn-sm" [class.btn-primary]="sms_camp_tab=='bulk'" [class.btn-outline-secondary]="sms_camp_tab!='bulk'" (click)="sms_camp_tab='bulk'">系統群發 <small *ngIf="sms_camp">{{sms_camp.bulk?.length || 0}} 批</small></button>
                    <button type="button" class="btn btn-sm" [class.btn-primary]="sms_camp_tab=='once'" [class.btn-outline-secondary]="sms_camp_tab!='once'" (click)="sms_camp_tab='once'">後台群發簡訊 <small *ngIf="sms_camp">{{sms_camp.once?.length || 0}} 則</small></button>
                    <button type="button" class="btn btn-sm" [class.btn-primary]="sms_camp_tab=='manual'" [class.btn-outline-secondary]="sms_camp_tab!='manual'" (click)="sms_camp_tab='manual'">後台單人簡訊 <small *ngIf="sms_camp">{{sms_camp.manual_emp?.length || 0}} 位員工</small></button>
                </div>
                <span style="color:#ccc;">｜</span>
                <span style="font-size:13px;color:#555;">期間：</span>
                <label style="margin:0;font-size:13px;cursor:pointer;user-select:none;">
                    <input type="checkbox" [(ngModel)]="sms_camp_all" (change)="search_sms_log()"> 全部歷史
                </label>
                <input type="date" class="form-control form-control-sm" style="width:150px;display:inline-block;" [(ngModel)]="sms_start_dt" [disabled]="sms_camp_all" (change)="search_sms_log()">
                <span>～</span>
                <input type="date" class="form-control form-control-sm" style="width:150px;display:inline-block;" [(ngModel)]="sms_end_dt" [disabled]="sms_camp_all" (change)="search_sms_log()">
                <span class="utag-den" style="white-space:normal;">7 天儲值要掃全部收件人對儲值單，第一次開會慢一點（之後有 10 分鐘快取）</span>
            </div>

            <!-- ═══ 成效分析（2026-09-16 UI 重排）：三個子分頁（系統群發／一次性／手動），每頁＝KPI 卡 → 圖表 → 分頁表格；口徑說明收進可展開區 ═══ -->
            <div *ngIf="sms_view=='camp'">
                <div *ngIf="sms_log_loading" class="utag-note">載入中…</div>

                <!-- ══ 後台群發簡訊：KPI → 圖 → 分頁表 ══ -->
                <div *ngIf="sms_camp && sms_camp_tab=='once'">
                    <details class="sms-card sms-note">
                        <summary>名詞說明（點開）：這些數字怎麼算、單位是什麼</summary>
                        <small class="text-muted">
                            <b>後台群發簡訊</b>＝後台「一次性推播／簡訊」建的任務，對象超過 2,000 人時系統會拆成多筆送，這裡已合併成一則（「拆 N 筆」）。<br>
                            <b>發送</b>＝這則實際送出的簡訊<u>封數</u>（一人一封）。<br>
                            <b>點開／點開率</b>＝收件人點了簡訊裡的短網址（ttpw.cc/…）的<u>人數</u>與占發送的比例。<u>只有勾「附短網址」的任務有連結可點</u>，沒附短網址的簡訊沒有東西可點，顯示「無法追蹤」，不是沒人點。
                            另外電信或防毒軟體會先幫你「預覽」網址，這種在 1 分鐘內的點開不是真人。<br>
                            <b>7 天儲值人數／儲值率／金額</b>＝收到這則簡訊的人裡，在派送後 7 天內有<u>成功儲值</u>的<u>人數</u>、占發送的比例、他們這 7 天儲值的<u>總金額（新台幣）</u>。
                            這是「收到後 7 天內有儲值」，<u>不是</u>「因為這封簡訊才儲值」——所以<b>沒點開也會有儲值</b>：他可能本來就會儲值（老客人）、可能看了簡訊直接開 App 沒點連結、或那則根本沒附短網址無法追蹤點開。
                            要看簡訊有沒有用，請比較「有發簡訊的那群」和「平常」的儲值率，或看點開的人的儲值率是否明顯高於沒點開的人。
                        </small>
                    </details>
                    <div class="sms-card">
                        <div class="sms-card-title">後台群發簡訊 <small>KPI 是各任務相加；點開只算附短網址的任務</small></div>
                        <div class="sms-kpis">
                            <div class="sms-kpi"><div class="k">任務數</div><div class="v">{{sms_camp.once?.length || 0}}</div></div>
                            <div class="sms-kpi"><div class="k">發送</div><div class="v">{{sms_sum(sms_camp.once,'sent') | number}}</div></div>
                            <div class="sms-kpi" title="只有「附短網址」的任務追蹤得到點開；沒附短網址的簡訊沒有可點的連結，不列入點開率分母"><div class="k">點開（只算附短網址的 {{sms_once_tracked().length}} 則）</div><div class="v">{{sms_sum(sms_once_tracked(),'clicked') | number}}</div><div class="s">點開率 {{sms_pct(sms_sum(sms_once_tracked(),'clicked'), sms_sum(sms_once_tracked(),'sent'))}}，這 {{sms_once_tracked().length}} 則共發 {{sms_sum(sms_once_tracked(),'sent') | number}} 封</div></div>
                            <div class="sms-kpi"><div class="k">7 天儲值人數</div><div class="v">{{sms_sum(sms_camp.once,'dep7_users') | number}}</div><div class="s">儲值率 {{sms_pct(sms_sum(sms_camp.once,'dep7_users'), sms_sum(sms_camp.once,'sent'))}}</div></div>
                            <div class="sms-kpi"><div class="k">7 天儲值金額</div><div class="v">NT$ {{sms_sum(sms_camp.once,'dep7_twd') | number}}</div></div>
                        </div>
                    </div>
                    <div class="sms-card" *ngIf="sms_chart.once">
                        <highcharts-chart [Highcharts]="Highcharts" [options]="sms_chart.once" style="display:block;width:100%;"></highcharts-chart>
                    </div>
                    <div class="sms-card">
                    <div class="sms-card-title">依任務 <small>新到舊，每頁 {{sms_pg.once.count}} 筆</small></div>
                    <div class="table-responsive">
                        <table class="table sms-wide">
                            <thead><tr><th>派送時間</th><th title="同一則簡訊對象超過 2,000 人時後台會拆成多筆送，這裡已把同一則合併；「拆 N 筆」表示這則原本拆成幾筆">任務</th><th title="簡訊／推播+簡訊；「附短網址」才追蹤得到點開">型態</th><th title="實際送出的封數（一人一封）">發送</th><th title="點了簡訊裡短網址的人數；沒附短網址的任務沒有連結可點，顯示無法追蹤">點開</th><th title="點開 ÷ 發送">點開率</th><th title="收到這則的人裡，派送後 7 天內有成功儲值的人數。不區分是不是因為這封才儲值，所以沒點開也會有儲值（本來就會儲值的老客人、或看了簡訊直接開 App）">7 天儲值人數</th><th title="7 天儲值人數 ÷ 發送">儲值率</th><th title="這些人在派送後 7 天內儲值的總金額，單位新台幣">7 天儲值金額 NT$</th><th>內容</th></tr></thead>
                            <tbody>
                                <tr *ngFor="let c of sms_page('once', sms_camp.once)">
                                    <td><small>{{c.dt}}</small></td>
                                    <td style="min-width:140px;"><small>#{{c.id}}</small> {{c.title || ((c.content || '') | slice:0:16)}}<span *ngIf="c.parts > 1" class="badge badge-light" style="margin-left:4px;" title="原本拆成 {{c.parts}} 筆送（#{{c.ids?.join(', #')}}），這裡合併成一則">拆 {{c.parts}} 筆</span></td>
                                    <td><small>{{c.inform}}</small></td>
                                    <td>{{c.sent | number}}</td>
                                    <!-- 沒附短網址＝簡訊裡沒有可點的連結，點開一定是 0：顯示「無法追蹤」而不是 0，免得被當成沒人點 -->
                                    <td><span *ngIf="c.has_url">{{c.clicked | number}}</span><span *ngIf="!c.has_url" style="color:#aaa" title="這則簡訊沒附短網址，沒有可點的連結，所以追蹤不到有沒有點開">無法追蹤</span></td>
                                    <td><span *ngIf="c.has_url" [style.color]="c.click_rate >= 10 ? '#1a7f37' : '#333'">{{c.click_rate}}%</span><span *ngIf="!c.has_url" style="color:#aaa">—</span></td>
                                    <td>{{c.dep7_users | number}}</td>
                                    <td>{{c.dep7_rate}}%</td>
                                    <td>NT$ {{c.dep7_twd | number}}</td>
                                    <td style="white-space:pre-wrap;max-width:320px;"><small>{{c.content}}</small></td>
                                </tr>
                                <tr *ngIf="!sms_log_loading && sms_camp.once.length==0"><td colspan="10">這個區間沒有後台群發簡訊任務</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <app-pagnation *ngIf="sms_pg.once.total_count > sms_pg.once.count" (callback)="sms_pg_cb('once', $event)" [data]="sms_pg_str.once"></app-pagnation>
                    </div>
                </div>

                <!-- ══ 系統群發：口徑說明（可展開）→ KPI 卡 → 四張圖 → 月趨勢表 → 批次表；數字依區間從 sms_sent_log 即時算（後端快取 10 分） ══ -->
                <div *ngIf="sms_camp && sms_camp_tab=='bulk'">
                    <details class="sms-card sms-note">
                        <summary>口徑說明（點開看每個數字怎麼算）</summary>
                        <small class="text-muted">
                            全部批次都列（含每天排程發的「未完成註冊」提醒）；發送／點開／點後登入是依{{sms_camp_all ? '全部歷史' : '上面選的日期區間'}}從逐筆派送紀錄即時算的。
                            <b>發送後 7 天儲值</b>＝收件人收到後 7 天內有成功儲值，不管有沒有點簡訊；「任一封」＝這批有一封在儲值前 7 天內就算（同一筆會算進 1 日、2 日、3 日提醒好幾批，各批相加大於實際），
                            「歸因」＝一筆儲值只算給最後一封那批（各批相加＝合計；月趨勢與合計都用歸因）。排程算的「點後儲值」只看點開的人。
                            <b>收件人現況（到今天）</b>＝收到簡訊的這些人到今天為止的狀態，不限 7 天：完成註冊＝後來有把生日填完；已刪帳號＝後來自己刪了帳號；
                            曾儲值＝一生有儲值過的人數，「一生累計 NT$」是這些人從註冊到今天所有儲值的總和，<u>不是這封簡訊帶來的</u>，只是看「我們簡訊發給的是什麼樣的人」。
                            <b>排程累計（開站以來）</b>＝排程程式每次發完累加在批次上的 發送／點開／點後登入，跟前面「依期間即時算」的數字對照用，勾全部歷史時兩邊應接近。
                            程式裡另有一個「點開後 7 天內儲值」的欄位，但算它的排程從來沒有被設定執行過，永遠是 0，所以畫面不再顯示（匯出 CSV 仍有）；
                            要看儲值成效請看「發送後 7 天儲值」（我們直接對儲值單算的，比那個排程準且不需要點開）。
                            <b>後台群發簡訊的點開</b>：只有「附短網址」的任務有可點的連結，沒附短網址的簡訊點開一律顯示「無法追蹤」，不是沒人點。
                            <b>點開快慢</b>：1 分鐘內點開的多半是電信／防毒的網址預覽掃描不是人，看「1 小時內」比較準。回饋鑽成本＝贈鑽 × 點後登入（點開後 1 小時內登入才發）。
                            <b>依發送時段</b>：排程批次時間固定，主要看每小時發的「1 小時未完成註冊」哪個時段點開率高。
                            <b>每人收到幾封</b>：完成註冊後就不會再收下一階段，收得越多＝拖越久沒完成。
                        </small>
                    </details>

                    <div class="sms-card" *ngIf="sms_camp.bulk_total">
                        <div class="sms-card-title">合計 <small>{{sms_camp_all ? '全部歷史' : '所選日期區間'}}；含每天排程發的「未完成註冊」提醒</small></div>
                        <div class="sms-kpis">
                            <div class="sms-kpi"><div class="k">發送</div><div class="v">{{sms_camp.bulk_total.sent | number}}</div><div class="s">{{sms_camp.bulk_total.users | number}} 人，平均每人 {{sms_camp.bulk_total.avg_per_user}} 封</div></div>
                            <div class="sms-kpi"><div class="k">點開</div><div class="v">{{sms_camp.bulk_total.clicked | number}} <small>({{sms_camp.bulk_total.click_rate}}%)</small></div><div class="s">1 分內 {{sms_camp.bulk_total.clk_1m_rate}}%／1 時內 {{sms_camp.bulk_total.clk_1h_rate}}%／1 天內 {{sms_camp.bulk_total.clk_1d_rate}}%</div></div>
                            <div class="sms-kpi"><div class="k">點後登入</div><div class="v">{{sms_camp.bulk_total.login | number}} <small>({{sms_camp.bulk_total.login_rate}}%)</small></div><div class="s">點開者的 {{sms_camp.bulk_total.login_per_click}}%</div></div>
                            <div class="sms-kpi"><div class="k">發送後 7 天儲值（歸因）</div><div class="v">{{sms_camp.bulk_total.dep7_users | number}} 人 <small>({{sms_camp.bulk_total.dep7_rate}}%)</small></div><div class="s">{{sms_camp.bulk_total.dep7_times | number}} 筆／NT$ {{sms_camp.bulk_total.dep7_twd | number}}，每封 NT$ {{sms_camp.bulk_total.twd_per_sent}}</div></div>
                            <div class="sms-kpi" title="收件人到今天為止有沒有把註冊完成（生日填完）。不限 7 天"><div class="k">收件人至今完成註冊</div><div class="v">{{sms_camp.bulk_total.done_reg | number}} <small>({{sms_camp.bulk_total.done_rate}}%)</small></div><div class="s">已刪帳號 {{sms_camp.bulk_total.deleted | number}} 人</div></div>
                            <div class="sms-kpi" title="收件人到今天為止曾經儲值過的人數，金額是這些人一生儲值的總和（不是這批簡訊帶來的）"><div class="k">收件人至今曾儲值</div><div class="v">{{sms_camp.bulk_total.ever_dep_users | number}} 人 <small>({{sms_camp.bulk_total.ever_dep_rate}}%)</small></div><div class="s">這些人一生累計儲值 NT$ {{sms_camp.bulk_total.ever_dep_twd | number}}</div></div>
                            <div class="sms-kpi" *ngIf="sms_camp.bulk_total.gift_cost > 0"><div class="k">回饋鑽成本</div><div class="v">{{sms_camp.bulk_total.gift_cost | number}} 鑽</div></div>
                        </div>
                    </div>

                    <div class="sms-charts">
                        <div class="sms-card sms-chart" *ngIf="sms_chart.trend"><highcharts-chart [Highcharts]="Highcharts" [options]="sms_chart.trend" style="display:block;width:100%;"></highcharts-chart></div>
                        <div class="sms-card sms-chart" *ngIf="sms_chart.hour">
                            <highcharts-chart [Highcharts]="Highcharts" [options]="sms_chart.hour" style="display:block;width:100%;"></highcharts-chart>
                            <div style="text-align:right;"><button type="button" class="btn btn-outline-secondary btn-sm" (click)="sms_export_csv('hour')">匯出時段 CSV</button></div>
                        </div>
                        <div class="sms-card sms-chart" *ngIf="sms_chart.batch"><highcharts-chart [Highcharts]="Highcharts" [options]="sms_chart.batch" style="display:block;width:100%;"></highcharts-chart></div>
                        <div class="sms-card sms-chart" *ngIf="sms_chart.expo"><highcharts-chart [Highcharts]="Highcharts" [options]="sms_chart.expo" style="display:block;width:100%;"></highcharts-chart></div>
                    </div>

                    <div class="sms-card">
                    <div class="sms-card-title">依月份 <small>7 天儲值用歸因口徑；每頁 {{sms_pg.trend.count}} 個月</small>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="sms_export_csv('trend')" [disabled]="!sms_camp.bulk_trend?.length">匯出 CSV</button>
                    </div>
                    <div class="table-responsive" style="margin-bottom:16px;">
                        <table class="table sms-wide">
                            <thead><tr><th>月份</th><th>發送</th><th>不重複人</th><th>點開（率）</th><th>點後登入（率）</th><th title="收件人在收到後 7 天內成功儲值的 人數／儲值筆數／金額（新台幣）；一筆儲值只算給最後一封。紅字＝這個月的 7 天儲值金額低於發送封數（一封簡訊至少 1 元，等於連簡訊成本都沒賺回）">7 天儲值（歸因）人／筆／NT$</th><th>7 天儲值率</th><th>每封 NT$</th><th title="這個月收到簡訊的人，到今天為止有多少人把註冊完成">收件人至今完成註冊（率）</th><th title="這個月收到簡訊的人，到今天為止有多少人刪了帳號">至今已刪帳號</th><th title="這個月收到簡訊的人，到今天為止曾儲值過的人數；金額是他們一生儲值總和，不是這封簡訊帶來的">收件人至今曾儲值 人（率）／一生累計 NT$</th></tr></thead>
                            <tbody>
                                <!-- 紅底＋紅字：7 天儲值金額 < 發送封數（一封至少 1 元，這個月沒賺回簡訊成本）— 2026-09-16 老闆要求 -->
                                <tr *ngFor="let t of sms_page('trend', sms_camp.bulk_trend)" [class.sms-loss]="t.sent > 0 && t.dep7_twd < t.sent">
                                    <td><b>{{t.ym}}</b></td>
                                    <td>{{t.sent | number}}</td>
                                    <td>{{t.users | number}}</td>
                                    <td>{{t.clicked | number}} <small [style.color]="t.click_rate >= 10 ? '#1a7f37' : '#888'">({{t.click_rate}}%)</small></td>
                                    <td>{{t.login | number}} <small style="color:#888">({{t.login_rate}}%)</small></td>
                                    <td><span [class.sms-loss-txt]="t.sent > 0 && t.dep7_twd < t.sent">{{t.dep7_users | number}} 人／{{t.dep7_times | number}} 筆／NT$ {{t.dep7_twd | number}}</span><small *ngIf="t.sent > 0 && t.dep7_twd < t.sent" class="sms-loss-txt" style="display:block;">金額 &lt; 發送 {{t.sent | number}} 封，沒賺回簡訊成本</small></td>
                                    <td [style.color]="t.dep7_rate >= 1 ? '#1a7f37' : '#333'">{{t.dep7_rate}}%</td>
                                    <td>NT$ {{t.twd_per_sent}}</td>
                                    <td>{{t.done_reg | number}} <small [style.color]="t.done_rate >= 20 ? '#1a7f37' : '#888'">({{t.done_rate}}%)</small></td>
                                    <td>{{t.deleted | number}}</td>
                                    <td>{{t.ever_dep_users | number}} <small style="color:#888">({{t.ever_dep_rate}}%)</small>／NT$ {{t.ever_dep_twd | number}}</td>
                                </tr>
                                <tr *ngIf="!sms_log_loading && !sms_camp.bulk_trend?.length"><td colspan="11">這個區間沒有群發派送紀錄</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <app-pagnation *ngIf="sms_pg.trend.total_count > sms_pg.trend.count" (callback)="sms_pg_cb('trend', $event)" [data]="sms_pg_str.trend"></app-pagnation>
                    </div>

                    <div class="sms-card">
                    <div class="sms-card-title">依批次 <small>點欄位標題排序（再點一次反向）；灰字＝這個區間沒發；「累計」是批次上排程累加的開站以來數字，對照用；每頁 {{sms_pg.bulk.count}} 批</small>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="sms_export_csv('bulk')" [disabled]="!sms_camp.bulk?.length">匯出 CSV</button>
                    </div>
                    <div class="table-responsive">
                        <table class="table sms-wide">
                            <thead>
                                <tr>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('id')">批次{{sms_sort_arrow('id')}}</th>
                                    <th>說明／排程</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('last_dt')">派送期間{{sms_sort_arrow('last_dt')}}</th>
                                    <th>對象</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('gift_num')">回饋{{sms_sort_arrow('gift_num')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('sent')">發送／人{{sms_sort_arrow('sent')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('click_rate')">點開（率）{{sms_sort_arrow('click_rate')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('clk_1h_rate')">點開快慢 1分／1時／1天{{sms_sort_arrow('clk_1h_rate')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('login_rate')">點後登入（率）{{sms_sort_arrow('login_rate')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('login_per_click')">點開→登入{{sms_sort_arrow('login_per_click')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('dep7_twd')">7 天儲值 任一封{{sms_sort_arrow('dep7_twd')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('attr7_twd')">7 天儲值 歸因{{sms_sort_arrow('attr7_twd')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('twd_per_sent')">每封 NT${{sms_sort_arrow('twd_per_sent')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('done_rate')" title="收到這批簡訊的人「到今天為止」的狀態，不限 7 天：完成註冊＝後來有把生日填完（排程挑人就是拿沒填生日當未完成）；已刪帳號＝後來自己刪了帳號；曾儲值＝這些人一生有儲值過的人數，後面的金額是他們一生儲值的總和，不是這封簡訊帶來的">收件人現況（到今天）{{sms_sort_arrow('done_rate')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('gift_cost')" title="贈鑽 × 點後登入人數。點開簡訊後 1 小時內登入才會發鑽">回饋鑽成本{{sms_sort_arrow('gift_cost')}}</th>
                                    <th class="sms-th-sort" (click)="sms_sort_bulk('cum_sent')" title="排程程式每次發完累加在批次上的「開站以來」數字（發送／點開／點後登入），純對照用。左邊「發送／人」「點開」「點後登入」是依你選的期間從逐筆紀錄即時算的；勾全部歷史時兩邊應該接近，差一點是刪除帳號等造成">排程累計（開站以來）{{sms_sort_arrow('cum_sent')}}</th>
                                    <th>內容</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let c of sms_page('bulk', sms_camp.bulk)" [class.sms-dim]="!(c.sent > 0)">
                                    <td><b>#{{c.id}}</b><br><small class="text-muted">{{c.kind}}</small></td>
                                    <td style="min-width:150px;">{{c.title || '—'}}<br><small class="text-muted">{{c.schedule}}</small></td>
                                    <td style="white-space:nowrap;"><small>{{c.first_dt ? (c.first_dt | slice:0:10) : '—'}}<br>～ {{c.last_dt ? (c.last_dt | slice:0:10) : '—'}}</small></td>
                                    <td style="min-width:130px;"><small>推播：{{c.push_type}}<span *ngIf="c.quota">，配額 {{c.quota | number}}</span><br *ngIf="c.tags">{{c.tags}}<br *ngIf="c.target_user">發送者：{{c.target_user}}</small></td>
                                    <td>{{c.gift_num > 0 ? ((c.gift_num | number) + ' ' + c.gift_type) : '—'}}</td>
                                    <td><b>{{c.sent | number}}</b><br><small class="text-muted">{{c.users | number}} 人</small></td>
                                    <td>{{c.clicked | number}} <small [style.color]="c.click_rate >= 10 ? '#1a7f37' : '#888'">({{c.click_rate}}%)</small></td>
                                    <td style="white-space:nowrap;"><small><span [style.color]="c.clk_1m_rate >= 30 ? '#c00' : '#888'">{{c.clk_1m_rate}}%</span>／{{c.clk_1h_rate}}%／{{c.clk_1d_rate}}%</small></td>
                                    <td>{{c.login | number}} <small style="color:#888">({{c.login_rate}}%)</small></td>
                                    <td>{{c.login_per_click}}%</td>
                                    <td>{{c.dep7_users | number}} 人 <small style="color:#888">({{c.dep7_rate}}%)</small>／{{c.dep7_times | number}} 筆<br><small>NT$ {{c.dep7_twd | number}}</small></td>
                                    <td>{{c.attr7_users | number}} 人 <small [style.color]="c.attr7_rate >= 1 ? '#1a7f37' : '#888'">({{c.attr7_rate}}%)</small>／{{c.attr7_times | number}} 筆<br><small>NT$ {{c.attr7_twd | number}}</small></td>
                                    <td>NT$ {{c.twd_per_sent}}</td>
                                    <td style="white-space:nowrap;"><small>完成註冊 {{c.done_reg | number}} <span [style.color]="c.done_rate >= 20 ? '#1a7f37' : '#888'">({{c.done_rate}}%)</span><br>已刪帳號 {{c.deleted | number}}<br>曾儲值 {{c.ever_dep_users | number}} 人 ({{c.ever_dep_rate}}%)<br>一生累計 NT$ {{c.ever_dep_twd | number}}</small></td>
                                    <td>{{c.gift_cost > 0 ? ((c.gift_cost | number) + ' 鑽') : '—'}}</td>
                                    <td style="white-space:nowrap;"><small>發送 {{c.cum_sent | number}}<br>點開 {{c.cum_clicked | number}}<br>登入 {{c.cum_login | number}}</small></td>
                                    <td style="white-space:pre-wrap;min-width:260px;max-width:420px;"><small>{{c.content}}</small></td>
                                </tr>
                                <tr *ngIf="!sms_log_loading && sms_camp.bulk.length==0"><td colspan="18">沒有群發批次</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <app-pagnation *ngIf="sms_pg.bulk.total_count > sms_pg.bulk.count" (callback)="sms_pg_cb('bulk', $event)" [data]="sms_pg_str.bulk"></app-pagnation>
                    </div>
                </div>

                <!-- ══ 後台單人簡訊：KPI → 圖 → 分頁表 ══ -->
                <div *ngIf="sms_camp && sms_camp_tab=='manual'">
                    <details class="sms-card sms-note">
                        <summary>名詞說明（點開）：VIP 追蹤、回歸、有貢獻、賺回 是什麼意思、單位是什麼</summary>
                        <small class="text-muted">
                            <b>後台單人簡訊</b>＝員工在用戶履歷頁按「發送簡訊」一個一個發的，不是排程。<br>
                            <b>發送（人）</b>＝這位員工發了幾<u>封</u>（括號是發給幾個<u>不同的人</u>）。<br>
                            <b>成功／失敗／未知</b>＝簡訊商有沒有收下這封：成功＝簡訊商回覆已收；失敗＝簡訊商拒收（號碼錯、餘額不足…）；未知＝2026-09-14 以前的紀錄是從後台操作日誌補回來的，當時沒存簡訊商回覆（「補登」）。<br>
                            <b>VIP 追蹤</b>＝發簡訊時勾了「追蹤」。系統會在這個人身上掛一個追蹤紀錄，看他之後有沒有回來。
                            如果同時填了「贈鑽」，<u>發簡訊當下</u>就先把那些鑽石送給他（不是回來才送），所以贈鑽是先花出去的成本。<br>
                            <b>贈鑽</b>＝這位員工在追蹤時總共送出的<u>鑽石數</u>；後面「≈ NT$」是換成台幣的區間（女生 17 鑽＝1 元、男生 4 鑽＝1 元，不知道收件人性別所以給區間）。<br>
                            <b>回歸／追蹤（率）</b>＝「回歸」是被追蹤的人在收到簡訊後<u>有登入 App</u>（登入當下系統記下回歸時間）；「追蹤」是追蹤的<u>人數</u>；比例＝回歸 ÷ 追蹤。<br>
                            <b>有貢獻</b>＝回歸的人裡，回來之後<u>男生有成功儲值</u>、或<u>女生有賺到收入</u>（收入是鑽石，÷17 換成台幣）的<u>人數</u>。單位是人。<br>
                            <b>回歸後賺回</b>＝這些有貢獻的人回來之後帶來的<u>金額總和（新台幣）</u>：男生＝回歸後的儲值金額，女生＝回歸後收入鑽石 ÷ 17。拿它跟「贈鑽」的台幣比就是這位員工追蹤的划不划算。<br>
                            <b>7 天儲值人數（率）／金額</b>＝這位員工發過簡訊的人裡，收到後 7 天內有成功儲值的<u>人數</u>（÷ 發給的人數）與<u>金額（新台幣）</u>；不管有沒有勾追蹤、不管是不是因為簡訊。<br>
                            <span style="color:#8a6d3b;">2026-09-16 前「有貢獻」的排程會把還沒回來的人一輩子的儲值也算進去（數字偏高），已修成只算已回歸的人；舊資料要用 dev log 的 UPDATE 還原一次才會正確。</span>
                        </small>
                    </details>
                    <div class="sms-card">
                        <div class="sms-card-title">後台單人簡訊 <small>KPI 是各員工相加</small></div>
                        <div class="sms-kpis">
                            <div class="sms-kpi"><div class="k">發送</div><div class="v">{{sms_sum(sms_camp.manual_emp,'sent') | number}}</div><div class="s">{{sms_sum(sms_camp.manual_emp,'users') | number}} 人</div></div>
                            <div class="sms-kpi"><div class="k">成功／失敗／未知</div><div class="v">{{sms_sum(sms_camp.manual_emp,'ok') | number}}<small>／{{sms_sum(sms_camp.manual_emp,'fail') | number}}／{{sms_sum(sms_camp.manual_emp,'unknown') | number}}</small></div><div class="s">補登 {{sms_sum(sms_camp.manual_emp,'backfilled') | number}} 筆（結果未知）</div></div>
                            <div class="sms-kpi"><div class="k">VIP 追蹤</div><div class="v">{{sms_sum(sms_camp.manual_emp,'vip_n') | number}}</div><div class="s">贈鑽 {{sms_sum(sms_camp.manual_emp,'vip_cost') | number}} 鑽</div></div>
                            <div class="sms-kpi"><div class="k">已回歸</div><div class="v">{{sms_sum(sms_camp.manual_emp,'vip_back') | number}} <small>({{sms_pct(sms_sum(sms_camp.manual_emp,'vip_back'), sms_sum(sms_camp.manual_emp,'vip_n'))}})</small></div><div class="s">有貢獻 {{sms_sum(sms_camp.manual_emp,'vip_contrib') | number}}，賺回 NT$ {{sms_sum(sms_camp.manual_emp,'vip_earn') | number}}</div></div>
                            <div class="sms-kpi"><div class="k">7 天儲值</div><div class="v">{{sms_sum(sms_camp.manual_emp,'dep7_users') | number}} 人</div><div class="s">NT$ {{sms_sum(sms_camp.manual_emp,'dep7_twd') | number}}</div></div>
                        </div>
                    </div>
                    <div class="sms-card" *ngIf="sms_chart.manual">
                        <highcharts-chart [Highcharts]="Highcharts" [options]="sms_chart.manual" style="display:block;width:100%;"></highcharts-chart>
                    </div>
                    <div class="sms-card">
                    <div class="sms-card-title">依發送員工 <small>發送量多到少，每頁 {{sms_pg.manual.count}} 位</small></div>
                    <div class="table-responsive">
                        <table class="table sms-wide">
                            <thead><tr><th>員工</th><th title="發了幾封（括號：發給幾個不同的人）">發送（人）</th><th title="簡訊商有沒有收下：成功／拒收／未知（2026-09-14 前補登的沒存回覆）">成功／失敗／未知</th><th title="發簡訊時有勾「追蹤」的人數；系統會看他之後有沒有回來登入">VIP 追蹤（人）</th><th title="追蹤時送出去的鑽石總數，發簡訊當下就送了；≈NT$ 是換台幣（女 17 鑽=1 元、男 4 鑽=1 元）">贈鑽</th><th title="回歸＝被追蹤的人之後有登入 App 的人數；÷ 追蹤人數＝回歸率">回歸／追蹤（率）</th><th title="回歸的人裡，回來後男生有成功儲值、或女生有賺到收入的人數（單位：人）">有貢獻（人）</th><th title="有貢獻的人回來後帶來的金額總和（新台幣）：男生＝回歸後儲值金額；女生＝回歸後收入鑽石 ÷ 17">回歸後賺回 NT$</th><th title="這位員工發過的人裡，收到後 7 天內有成功儲值的人數（÷ 發給的人數）；不管有沒有追蹤、不管是不是因為簡訊">7 天儲值人數（率）</th><th title="上述那些人 7 天內儲值的總金額，新台幣">7 天儲值金額 NT$</th></tr></thead>
                            <tbody>
                                <tr *ngFor="let e of sms_page('manual', sms_camp.manual_emp)">
                                    <td>{{e.emp_name || ('#' + e.admin_id)}}</td>
                                    <td>{{e.sent | number}} <small style="color:#888">({{e.users | number}} 人)</small></td>
                                    <td><span style="color:#1a7f37">{{e.ok}}</span>／<span style="color:#c00">{{e.fail}}</span>／<span style="color:#888">{{e.unknown}}</span><small *ngIf="e.backfilled" style="color:#888">（補登 {{e.backfilled}}）</small></td>
                                    <td>{{e.vip_n | number}}<small *ngIf="e.track != e.vip_n" style="color:#888">（簡訊表記 {{e.track}}）</small></td>
                                    <td>{{e.vip_cost | number}} 鑽 <small style="color:#888">≈ NT$ {{e.vip_cost_twd_min | number}}～{{e.vip_cost_twd_max | number}}</small></td>
                                    <td>{{e.vip_back | number}}／{{e.vip_n | number}} <small [style.color]="e.vip_back_rate >= 30 ? '#1a7f37' : '#888'">({{e.vip_back_rate}}%)</small></td>
                                    <td>{{e.vip_contrib | number}}</td>
                                    <td>NT$ {{e.vip_earn | number}}</td>
                                    <td>{{e.dep7_users | number}} <small style="color:#888">({{e.dep7_rate}}%)</small></td>
                                    <td>NT$ {{e.dep7_twd | number}}</td>
                                </tr>
                                <tr *ngIf="!sms_log_loading && sms_camp.manual_emp.length==0"><td colspan="10">這個區間沒有後台單人簡訊</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <app-pagnation *ngIf="sms_pg.manual.total_count > sms_pg.manual.count" (callback)="sms_pg_cb('manual', $event)" [data]="sms_pg_str.manual"></app-pagnation>
                    </div>
                </div>
            </div>

            <!-- ═══ 逐筆紀錄 ═══ -->
            <div *ngIf="sms_view=='rows'">

            <!-- 區間內統計：後端對三張表各自 COUNT/SUM，跟下面名單同一組條件 -->
            <div class="d-flex flex-wrap" style="gap:8px;margin-bottom:10px;font-size:12px;" *ngIf="sms_stats">
                <div style="border:1px solid #dde2e6;border-radius:6px;padding:4px 10px;background:#fafbfc;">
                    共 <b>{{sms_stats.total | number}}</b> 筆
                </div>
                <div style="border:1px solid #dde2e6;border-radius:6px;padding:4px 10px;background:#fafbfc;" *ngIf="sms_source==0 || sms_source==1">
                    一次性 <b>{{sms_stats.once?.count | number}}</b> 筆／{{sms_stats.once?.campaigns | number}} 個任務，
                    點開 {{sms_stats.once?.clicked | number}}（{{sms_pct(sms_stats.once?.clicked, sms_stats.once?.count)}}）
                </div>
                <div style="border:1px solid #dde2e6;border-radius:6px;padding:4px 10px;background:#fafbfc;" *ngIf="sms_source==0 || sms_source==2">
                    群發 <b>{{sms_stats.bulk?.count | number}}</b> 筆／{{sms_stats.bulk?.campaigns | number}} 批，
                    點開 {{sms_stats.bulk?.clicked | number}}（{{sms_pct(sms_stats.bulk?.clicked, sms_stats.bulk?.count)}}），
                    點後登入 {{sms_stats.bulk?.login | number}}，點後儲值 {{sms_stats.bulk?.recharge_people | number}} 人／NT$ {{sms_stats.bulk?.recharge_twd | number}}
                </div>
                <div style="border:1px solid #dde2e6;border-radius:6px;padding:4px 10px;background:#fafbfc;" *ngIf="sms_source==0 || sms_source==3">
                    手動 <b>{{sms_stats.manual?.count | number}}</b> 筆：成功 {{sms_stats.manual?.ok | number}}／失敗 {{sms_stats.manual?.fail | number}}／未知 {{sms_stats.manual?.unknown | number}}
                    （補登 {{sms_stats.manual?.backfilled | number}}），含 VIP 追蹤 {{sms_stats.manual?.track | number}}（贈 {{sms_stats.manual?.track_diamond | number}} 鑽）
                </div>
            </div>

            <div class="table-responsive">
                <table class="table sms-wide">
                    <thead><tr><th>時間</th><th>來源</th><th>任務／批次</th><th>收件用戶</th><th>門號</th><th>內容</th><th>短網址／點擊</th><th>發送後 7 天</th><th>結果</th><th>發送人</th></tr></thead>
                    <tbody>
                        <tr *ngFor="let s of sms_log_arr">
                            <td><small>{{s.dt}}</small></td>
                            <td>
                                <span class="badge" [class.badge-info]="s.source==1" [class.badge-primary]="s.source==2" [class.badge-secondary]="s.source==3">{{s.source_name}}</span>
                            </td>
                            <td style="max-width:200px;">
                                <small *ngIf="s.camp_id">#{{s.camp_id}}</small> {{s.camp_title}}
                                <br *ngIf="s.camp_note"><small class="text-muted">{{s.camp_note}}</small>
                            </td>
                            <td>
                                <a *ngIf="s.uid" href="{{link}}/user/{{s.uid}};act=1;menu=15" target="_blank">{{s.name || s.uid}}</a>
                                <span *ngIf="!s.uid">#{{s.user_id}}（查無此用戶）</span>
                            </td>
                            <td><small>{{s.phone || '—'}}</small></td>
                            <td style="white-space: pre-wrap; max-width: 360px;">{{s.content || '—'}}</td>
                            <td>
                                <span *ngIf="!s.code" style="color:#aaa">—</span>
                                <span *ngIf="s.code">
                                    <small>ttpw.cc/{{s.code}}</small><br>
                                    <span *ngIf="s.clicked" style="color:#1a7f37">有點開<small *ngIf="s.click_dt"> {{s.click_dt}}</small></span>
                                    <span *ngIf="!s.clicked" style="color:#888">未點開</span>
                                    <span *ngIf="s.login_after" style="color:#1a7f37">、點後登入</span>
                                    <br *ngIf="s.recharge_num > 0"><small *ngIf="s.recharge_num > 0" style="color:#1a7f37">點後 7 天儲值 {{s.recharge_num}} 筆／NT$ {{s.recharge_twd | number}}</small>
                                </span>
                            </td>
                            <!-- 發送後 7 天追蹤（後端只對當頁這幾筆算）：登入看 user_behavor.login 逐日 JSON（含發送當天）；
                                 男生看 deposit_record 成功儲值、女生看 daily_income 收入。這不等於「因為這封才來」，只是有沒有動 -->
                            <td style="font-size:12px;white-space:nowrap;">
                                <span *ngIf="s.login_7d === null" style="color:#aaa">登入：無資料</span>
                                <span *ngIf="s.login_7d === 1" style="color:#1a7f37">有登入</span>
                                <span *ngIf="s.login_7d === 0" style="color:#888">沒登入</span>
                                <br>
                                <span *ngIf="s.gender != 2">
                                    <span *ngIf="s.dep7_num > 0" style="color:#1a7f37">儲值 {{s.dep7_num}} 筆／NT$ {{s.dep7_twd | number}}</span>
                                    <span *ngIf="!(s.dep7_num > 0)" style="color:#888">沒儲值</span>
                                </span>
                                <span *ngIf="s.gender == 2">
                                    <span *ngIf="s.inc7_diamond > 0" style="color:#1a7f37">收入 {{s.inc7_diamond | number}} 鑽</span>
                                    <span *ngIf="!(s.inc7_diamond > 0)" style="color:#888">沒收入</span>
                                </span>
                            </td>
                            <td [style.color]="s.status==1 ? '#1a7f37' : (s.status==2 ? '#c00' : (s.status==0 ? '#888' : '#333'))">
                                {{s.status_name}}<small *ngIf="s.backfilled">（補登）</small>
                                <div *ngIf="s.track_status_name" style="font-size:12px;" [style.color]="s.track_status >= 2 ? '#1a7f37' : (s.track_status == 1 ? '#8a6d3b' : '#888')">
                                    追蹤：{{s.track_status_name}}
                                    <small *ngIf="s.back_time"><br>回歸 {{s.back_time}}</small>
                                    <small *ngIf="s.back_earn_money > 0"><br>回歸後賺回 NT$ {{s.back_earn_money | number}}</small>
                                </div>
                            </td>
                            <td>{{s.source==3 ? (s.emp_name || '—') : '排程'}}</td>
                        </tr>
                        <tr *ngIf="sms_log_loading"><td colspan="10">載入中…</td></tr>
                        <tr *ngIf="!sms_log_loading && sms_log_arr.length==0"><td colspan="10">這個區間／條件沒有資料</td></tr>
                    </tbody>
                </table>
            </div>

            <app-pagnation (callback)="callback_sms($event)" [data]="page_sms_str"></app-pagnation>

            </div><!-- /逐筆紀錄 -->

        </div>

    </div>
    <div *ngIf="now=='10'">
        <div class="tagsystem">
            <p>Tag搜尋區</p>
        </div>
        <div>

            <app-date [time]="Usertime"  [timeset]="Usertimeset" (rangeSelected)="handleRangeUserSelected($event)"></app-date>

            <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;margin-left: 30px;" [(ngModel)]="tool_obj.tag" (ngModelChange)="showdeType(tool_obj.tag)">
                <option default disabled value="-2">請選擇Tag類型</option>
                <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <mat-form-field  *ngIf="tool_obj.tag > -1" style="width: 600px;">
                <mat-label>選擇呈現類別</mat-label>
                <mat-select [(ngModel)]="tool_obj.groupTag" multiple (ngModelChange)="showType(tool_obj.tag)" >
                    <mat-option *ngFor="let item of groupTaglist[tool_obj.tag]" [value]="item.name">{{ item.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <button class="btn btn-primary"  (click)="init_list()" style="margin-left: 5%;">確認</button>
        </div>

        <div  *ngFor="let itex of groupTagArr; let ix = index">

            <div *ngIf="itex != null">
                <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-primary"  (click)="clearbtn(item,ix,i)" >{{item}}</button>
            </div>

        </div>

        <!-- 2026-09-16：圖一律走 get_tag_trend.php（排程每天寫好的人數），任何天數同一個來源；日／週／月／月表全部從同一份每日數字算（週、月取期末），
             所以日期選一個月：月表那格＝月圖那點＝日圖最後一點。名單（下面的列表）只在 ≤ 62 天列。 -->
        <div class="utag-note" style="margin:6px 10px 0;">
            圖的數字＝排程每天算完的 tag 名單人數。「週／月」取該期間<b>最後一天</b>的人數（人數是存量，取期末），所以日期選一整個月時，月表那一格＝月圖那一點＝日圖最後一點，三個地方一定相同。
            多選 tag 預設算<b>同時符合</b>的人數（每天拿各 tag 當天的名單取交集，一條線）；想比較各 tag 的量體切「各自一條線」。交集第一次看要算一下（圖會一段一段長出來），算過的日子會存起來，之後秒開。
            下方名單＝日期<b>最後一天</b>的名單（只數啟用中帳號），總筆數＝圖的最後一點，日期選多長都一樣。
        </div>
        <div class="sms-card" style="margin:10px;" *ngIf="tag_trend || tag_trend_loading">
            <div class="d-flex align-items-center flex-wrap" style="gap:8px;margin-bottom:8px;">
                <ng-container *ngIf="tag_selected_names().length > 1">
                    <span style="font-weight:600;">多選</span>
                    <div class="btn-group btn-group-sm" style="margin-right:10px;">
                        <button type="button" class="btn" [class.btn-primary]="tag_combine" [class.btn-outline-secondary]="!tag_combine" (click)="tag_set_combine(true)" title="每天拿各 tag 當天的名單取交集，一條線">同時符合</button>
                        <button type="button" class="btn" [class.btn-primary]="!tag_combine" [class.btn-outline-secondary]="tag_combine" (click)="tag_set_combine(false)" title="每個 tag 各畫一條線，比較量體">各自一條線</button>
                    </div>
                </ng-container>
                <span style="font-weight:600;">粒度</span>
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn" [class.btn-primary]="tag_gran=='day'" [class.btn-outline-secondary]="tag_gran!='day'" (click)="tag_set_gran('day')">日</button>
                    <button type="button" class="btn" [class.btn-primary]="tag_gran=='week'" [class.btn-outline-secondary]="tag_gran!='week'" (click)="tag_set_gran('week')">週</button>
                    <button type="button" class="btn" [class.btn-primary]="tag_gran=='month'" [class.btn-outline-secondary]="tag_gran!='month'" (click)="tag_set_gran('month')">月</button>
                </div>
                <span style="font-weight:600;margin-left:10px;">Y 軸</span>
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn" [class.btn-primary]="tag_yaxis=='count'" [class.btn-outline-secondary]="tag_yaxis!='count'" (click)="tag_set_yaxis('count')">人數</button>
                    <button type="button" class="btn" [class.btn-primary]="tag_yaxis=='pct'" [class.btn-outline-secondary]="tag_yaxis!='pct'" (click)="tag_set_yaxis('pct')" title="÷ 當天全站累計註冊人數">占全站 %</button>
                </div>
                <label *ngIf="tag_trend?.mode != 'and'" style="margin:0 0 0 10px;font-size:13px;cursor:pointer;user-select:none;" title="排除停權、未完成註冊、已刪帳號後的人數；只有排程新寫的日子有，舊資料沒有">
                    <input type="checkbox" [ngModel]="tag_show_active" (ngModelChange)="tag_show_active = $event; render_tag_trend()"> 同時畫有效人數
                </label>
                <label *ngIf="tag_trend?.mode == 'and' && tag_trend?.combo?.count_basis == 'enabled'" style="margin:0 0 0 10px;font-size:13px;cursor:pointer;user-select:none;" title="主線只數目前啟用中（is_enable=1）的帳號，跟下方名單總筆數同口徑；勾了多畫一條虛線＝交集全部人數（含未啟用／停權）">
                    <input type="checkbox" [ngModel]="tag_show_active" (ngModelChange)="tag_show_active = $event; render_tag_trend()"> 同時畫全部人數（含未啟用）
                </label>
                <label style="margin:0 0 0 10px;font-size:13px;cursor:pointer;user-select:none;" title="預設 Y 軸貼著資料範圍畫，才看得出每天差幾十人的變化；勾了從 0 起，看的是量體">
                    <input type="checkbox" [ngModel]="tag_y_zero" (ngModelChange)="tag_y_zero = $event; render_tag_trend()"> Y 軸從 0 起
                </label>
                <span *ngIf="tag_trend_polling" class="text-muted" style="font-size:13px;">交集計算中…</span>
                <button type="button" class="btn btn-outline-primary btn-sm" style="margin-left:auto;" (click)="tag_create_composite()" title="把目前選的多個 tag 存成一個組合 Tag（交集），排程每天算它的人數，明天起就有交集的趨勢線">存成組合 Tag</button>
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="tag_export_csv()" [disabled]="!tag_month_rows.length">匯出月表 CSV</button>
            </div>
            <div *ngIf="tag_trend_loading" class="text-muted">讀取中…</div>
            <div *ngIf="tag_trend?.error" class="text-danger">{{tag_trend.error}}</div>
            <div *ngIf="tagTrendOptions">
                <!-- oneToOne=true：切粒度／Y 軸／取消勾有效人數時是 chart.update()，沒有 oneToOne 的話 series 變少（取消虛線）舊的線會留在圖上 -->
                <highcharts-chart [Highcharts]="Highcharts" [options]="tagTrendOptions" [oneToOne]="true" style="display:block;width:100%;"></highcharts-chart>
                <div *ngIf="tag_trend_notes.length" style="margin-top:6px;padding:8px 12px;background:#fff8e1;border-left:3px solid #e69138;font-size:13px;line-height:1.8;color:#5a4a1a;">
                    <div *ngFor="let n of tag_trend_notes">{{n}}</div>
                </div>
                <small class="text-muted" *ngIf="tag_trend?.missing > 0 && !tag_trend_notes.length">區間內有 {{tag_trend.missing | number}} 個「tag × 天」沒有人數（那天排程沒跑，或舊資料還沒跑補算工具），圖上那段會是空的。</small>
            </div>
            <div class="table-responsive" style="margin-top:12px;" *ngIf="tag_month_rows.length">
                <table class="table sms-wide">
                    <thead><tr>
                        <th>Tag</th><th>月份</th>
                        <th title="該月最後一個有資料的日子的人數＝圖上「月」那一點＝日圖該月最後一點">期末人數</th>
                        <th>期末日期</th>
                        <th title="期末人數 ÷ 當天全站累計註冊人數">占全站 %</th>
                        <th title="這個月期末 － 上個月期末（人數與 %）">比上月</th>
                        <th title="該月每天人數的最高值">該月最高</th><th title="該月每天人數的最低值">該月最低</th>
                        <th title="該月有排程資料的天數；不足代表排程沒跑或舊資料沒補算">有資料天數</th>
                    </tr></thead>
                    <tbody>
                        <tr *ngFor="let r of tag_month_rows">
                            <td>{{r.tag}}</td>
                            <td><b>{{r.month}}</b></td>
                            <td>{{r.end !== null ? (r.end | number) : '—'}}</td>
                            <td><small>{{r.end_date}}</small></td>
                            <td>{{r.pct !== null ? r.pct + '%' : '—'}}</td>
                            <td>
                                <span *ngIf="r.delta !== null" [style.color]="r.delta > 0 ? '#1a7f37' : (r.delta < 0 ? '#c00' : '#333')">{{r.delta > 0 ? '+' : ''}}{{r.delta | number}}<small *ngIf="r.delta_pct !== null"> ({{r.delta_pct > 0 ? '+' : ''}}{{r.delta_pct}}%)</small></span>
                                <span *ngIf="r.delta === null" style="color:#aaa">—</span>
                            </td>
                            <td>{{r.max !== null ? (r.max | number) : '—'}}</td>
                            <td>{{r.min !== null ? (r.min | number) : '—'}}</td>
                            <td>{{r.days}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div *ngIf="now=='0'" style="margin-left:10px ;">

        <hr>

                <div class="d-flex" style="gap: 15px;">
            <div class="accordion1 set_validate" id="accordionExample2" *ngIf="power*1>=5" style="flex: 1;">
                <div class="card">
                    <div class="card-header " id="headingOne2">
                        <h2 class="">
                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapsetwo" aria-expanded="true" aria-controls="collapsetwo">
                                熱門度設定
                            </button>
                        </h2>
                    </div>
                    <div id="collapsetwo" class="collapse" aria-labelledby="headingOne2" data-parent="#accordionExample2">
                        <div class="card-body">
                            <div class="user_edit_block form-group">
                                <textarea style="height: 200px;" placeholder="請輸入電話用半形,隔開且電話開頭不帶0 範例911901901,911902902,911903903" [(ngModel)]="hot_list.list_str" class="form-control"></textarea>
                            </div>
                            <div class="user_edit_block" *ngIf="power*1>=3">
                                熱門係數批次調整
                                <input type="range" class="form-range" min="0" max="9" step="1" [(ngModel)]="hot_list.score" >
                                {{hot_list.score}}
                            </div>
                            <button (click)="set_hot_score(1)"class="btn btn-primary"  type="button" style="margin: 10px;">
                                確認
                            </button>
                            <button (click)="set_hot_score(0)"class="btn btn-danger"  type="button" style="margin: 10px;">
                                將所有用戶的熱門度歸0
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="accordion1 set_validate" id="accordionExample" *ngIf="power*1>=5" style="flex: 1;">
                <div class="card">
                    <div class="card-header " id="headingOne">
                        <h2 class="">
                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                驗證碼設定
                            </button>
                        </h2>
                    </div>
                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body">
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label">國際碼</label>
                                <input type="number" class="form-control show_input"    [(ngModel)]="validate_info.country_code" (change)="check_validate(1,validate_info.country_code)" />
                            </div>
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label">電話</label>
                                <input type="number" class="form-control show_input"    [(ngModel)]="validate_info.phone_num" (change)="check_validate(1,validate_info.phone_num)" />
                            </div>
                            <div class="user_edit_block form-group">
                                <label class="col-sm-2 col-form-label">驗證碼</label>
                                <input type="number" class="form-control show_input" (change)="check_validate(2,validate_info.validate)"    [(ngModel)]="validate_info.validate" />
                            </div>
                            <button (click)="save_validate()"class="btn btn-primary" type="button" style="margin-top: 10px;">
                                確認
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="accordion1 set_validate" id="accordionExample3" *ngIf="power*1>=5" style="flex: 1;">
                <div class="card">
                    <div class="card-header" id="headingOne3">
                        <h2 class="">
                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                生成假帳號
                            </button>
                        </h2>
                    </div>
                    <div id="collapseThree" class="collapse" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                        <div class="card-body">
                            <div class="form-group row align-items-center mb-3">
                                <label class="col-sm-3 col-form-label font-weight-bold">數量</label>
                                <div class="col-sm-9">
                                    <input type="number" class="form-control" [(ngModel)]="fakeAccountCount" min="1" placeholder="請輸入生成數量" />
                                </div>
                            </div>
                            <div class="form-group row align-items-center mb-3">
                                <label class="col-sm-3 col-form-label font-weight-bold">密碼</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" [(ngModel)]="fakeAccountPassword" placeholder="請輸入登入密碼" />
                                </div>
                            </div>
                            <div class="text-right" style="margin-top: 15px;">
                                <button (click)="generateFakeAccounts()" class="btn btn-primary px-4">
                                    生成帳號
                                </button>
                            </div>
                            <div *ngIf="fakeAccountResult.length > 0" style="margin-top: 15px; padding: 10px; background: #f8f9fa; border-radius: 5px; border: 1px solid #dee2e6;">
                                <div class="font-weight-bold" style="margin-bottom: 8px;">本次生成的電話號碼：</div>
                                <div *ngFor="let phone of fakeAccountResult; let i = index" style="padding: 4px 8px; border-bottom: 1px solid #e9ecef;">
                                    {{i + 1}}. {{phone}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <hr>

        <div class="d-flex align-items-center flex-wrap mb-2 gap-1" >

            <div class="input-group m-1" style="width: 190px;">
                <div class="input-group-prepend">
                    <span class="input-group-text"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/accessibility-16.svg" width="16" height="16"></span>
                </div>
                <select class="form-control" [(ngModel)]="tool_obj.search_gender" (change)="defaultsort();init_list()">
                    <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="input-group m-1" style="width: 190px;">
                <div class="input-group-prepend">
                    <span class="input-group-text"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/globe-16.svg" width="16" height="16"></span>
                </div>
                <select class="form-control" [(ngModel)]="tool_obj.search_country" (change)="defaultsort();init_list()">
                    <option *ngFor="let item of country_list" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="input-group m-1" style="width: 190px;">
                <div class="input-group-prepend">
                    <span class="input-group-text"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/flame-16.svg" width="16" height="16"></span>
                </div>
                <select class="form-control" [(ngModel)]="tool_obj.is_enable" (change)="defaultsort();init_list()">
                    <option *ngFor="let item of status_option" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="input-group m-1" style="width: 190px;">
                <div class="input-group-prepend">
                    <span class="input-group-text"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/code-of-conduct-16.svg" width="16" height="16"></span>
                </div>
                <select class="form-control" [(ngModel)]="tool_obj.track" (change)="defaultsort();init_list()">
                    <option *ngFor="let item of track_option" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="input-group m-1" style="width: 190px;">
                <div class="input-group-prepend">
                    <span class="input-group-text"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/people-16.svg" width="16" height="16"></span>
                </div>
                <select class="form-control" [(ngModel)]="tool_obj.vender" (change)="defaultsort();init_list()">
                    <option *ngFor="let item of vender_option" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="input-group m-1" style="width: 220px;">
                <div class="input-group-prepend">
                    <span class="input-group-text"><img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/device-mobile-16.svg" width="16" height="16"></span>
                </div>
                <input (keyup.enter)="defaultsort();init_list()" type="text" [(ngModel)]="tool_obj.search_model" class="form-control" placeholder="請輸入姓名或手機">
            </div>

            <div class="d-flex align-items-center ml-2">
                <button class="btn btn-dark btn-hover rounded py-1 px-2" (click)="init_list()">
                    <img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/search-16.svg" width="20" height="20" class="mr-1" style="vertical-align: middle; filter: brightness(0) invert(1);">確認
                </button>
                <a [href]="urltoken" *ngIf="urltoken.length>0 && data.length>0" target="_blank" class="btn btn-dark btn-hover rounded px-2 py-1 ml-2">
                    <img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/desktop-download-24.svg" width="20" height="20" style="vertical-align: middle; filter: brightness(0) invert(1);">
                </a>
            </div>

        </div>

        <div class="d-flex align-items-center flex-wrap p-2 rounded-2 mb-3" style="gap: 10px; background: #f8f9fa; min-height: 38px;">
            <div class="d-flex align-items-center">
                <div class="d-flex align-items-center mr-2">
                    ⏰大於 n 天沒上線：
                </div>
                <div class="input-group" style="width: 150px;">
                    <input
                        (keyup.enter)="init_list()"
                        type="text"
                        [(ngModel)]="tool_obj.filter_num"
                        class="form-control"
                        placeholder="輸入天數"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text" style="background: #e9ecef; border-left: 0;">天</span>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center">
                <div class="d-flex align-items-center mr-2">
                    💰大於 n 萬：
                </div>
                <div class="input-group" style="width: 150px;">
                    <input
                        (keyup.enter)="init_list()"
                        type="text"
                        [(ngModel)]="tool_obj.filter_money_num"
                        class="form-control"
                        placeholder="輸入金額"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text" style="background: #e9ecef; border-left: 0;">萬</span>
                    </div>
                </div>
            </div>

            <div class="d-flex mr-2">
                <div class="d-flex align-items-center text-nowrap">
                    <img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/search-16.svg" width="16" height="16" class="mr-2">
                    搜索聊天/交易行為：
                </div>
                <div>
                    <app-date [time]="Usertime" [type]="true" [timeset]="Usertimeset" (rangeSelected)="handleRangeUserSelected($event)"></app-date>
                    <select  *ngIf="Usertime.start != ''"  class="form-control" style="width: 160px;display: inline-block;margin-left: 10px;" [(ngModel)]="search_date_user" (change)="defaultsort();init_list()">
                        <option *ngFor="let item of user_date_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>
            </div>

            <div class="d-flex">
                <div class="d-flex align-items-center text-nowrap">
                    <img loading="lazy" src="https://cdn.jsdelivr.net/npm/@primer/octicons@19/build/svg/calendar-16.svg" width="16" height="16" class="mr-2">
                    最後上線時間：
                </div>
                <div>
                    <app-date [time]="LastUsertime" [type]="true" [timeset]="LastTimeUsertimeset" (rangeSelected)="lasthandleRangeUserSelected($event)"></app-date>
                </div>
            </div>
        </div>
    </div>


    <!-- Tag數據 的舊圖（每天名單交集後數人）已由上面的趨勢圖取代（2026-09-16），後端也帶 skip_chart 不再算 -->


    <div *ngIf="now=='0' || now=='10'" style="margin-left:10px ;">
        <div class="d-flex align-items-center flex-wrap p-2">
            <h5 style="margin: 10px;">✎ 總筆數：{{pageobj.total_count|number}}</h5>
            <app-check-permissions [data]="'sXQy'" style="margin-right: 1%;">
                <button class="special-button" (click)="check_all_list()"  *ngIf="pageobj.total_count > 0 && top_data.length == 0 ">選擇懸賞通緝令</button>
                <button class="special-button-red" (click)="all_list()"  *ngIf="top_data.length > 0">設定懸賞通緝令</button>
            </app-check-permissions>
            <app-pushmessage  [select_num]="pageobj.total_count" (pushMessageEmt)="handlePushMessageEmtSelected($event)"></app-pushmessage>
        </div>

        <p *ngIf="now == '10' && data.length > 0">更新時間:{{uptime}}</p>
        <app-table-v2 [type]="1"  [filter_title] = "true" [urltoken]="urltabletoken" [urltokencsv]="urltokencsv" [bounty_id] = "bounty_id" [bounty_arr] = "bounty_arr" [data]="data" [topData]="top_data"   [tcontent]="tcontent" (topDataout) = "handletopDataout($event)" (sortdata)="handlesortdata($event)" *ngIf="data.length>0">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'money'">
                    <span *ngIf="post.val.money==0">{{post.val.money}}</span>
                    <span  *ngIf="post.val.money>0">
                        <a  target="_blank" href="{{link}}/tradelist/{{post.val.uid}}">{{post.val.money|number}}</a>
                        <span *ngIf="post.val.refund>0 && post.val.gender!=2">(退款:{{post.val.refund}}元)</span>
                    </span>
                </div>
                <div *ngIf="post.key == 'diamond'">
                    <a target="_blank"  href="{{ link }}/user/{{ post.val.uid }};act=1;menu=5">{{post.val.diamond|number}}</a>
                </div>
                <div *ngIf="post.key == 'total_income'">
                    {{post.val.total_income|number}}
                </div>
                <div *ngIf="post.key == 'text_income'">
                    {{post.val.text_income|number}}
                </div>
                <div *ngIf="post.key == 'voice_income'">
                    {{post.val.voice_income|number}}
                </div>
                <div *ngIf="post.key == 'video_income'">
                    {{post.val.video_income|number}}
                </div>
                <div *ngIf="post.key == 'album_income'">
                    {{post.val.album_income|number}}
                </div>
                <div *ngIf="post.key == 'game_income'">
                    {{post.val.game_income|number}}
                </div>
                <div *ngIf="post.key == 'active_reward'">
                    {{post.val.active_reward|number}}
                </div>
                <div *ngIf="post.key == 'gift_reward'">
                    {{post.val.gift_reward|number}}
                </div>
                <div *ngIf="post.key == 'live_reward'">
                    {{post.val.live_reward|number}}
                </div>
                <div *ngIf="post.key == 'date_reward'">
                    {{post.val.date_reward|number}}
                </div>
                <div *ngIf="post.key == 'voice_room_income'">
                    {{post.val.voice_room_income|number}}
                </div>
                <div *ngIf="post.key == 'donate_income'">
                    {{post.val.donate_income|number}}
                </div>
                <div *ngIf="post.key == 'other'">
                    {{post.val.other|number}}
                </div>
                <div *ngIf="post.key == 'last_singin_date'">
                    <a target="_blank" href="{{ link }}/user/{{ post.val.uid }};act=1;menu=3">{{post.val.last_singin_date}}</a>
                </div>
                <div *ngIf="post.key == 'is_enable'">
                    {{post.val.phone_num < 0?'刪除' : post.val.is_enable==1?'正常':'停權'}}
                </div>
                <div *ngIf="post.key == 'gg'">
                    <app-check-permissions [data]="'sXQy'">
                        <a  *ngIf="bounty_id.includes(post.val.id)" href="javascript:void(0)" title="懸賞設定" (click)="click_bounty(post.val.id)" data-toggle="modal" data-target=".bdx-example-modal-xl">
                            <i style="margin: 0 10px 0 0;" class="fas fa-address-book"></i>
                        </a>
                    </app-check-permissions>
                    <a href="javascript:void(0)" title="點我設定"  (click)="edit_data=post.val;msg='';changePhone='';subnow='0'" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-wrench"></i>
                    </a>
                    <a href="javascript:void(0)" title="追蹤資料明細"  (click)="edit_data=post.val;get_track_detail();subnow='1'" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-list-ul"></i>
                    </a>
                    <a href="javascript:void(0)" title="寄送訊息"  (click)="edit_data=post.val;edit_data.sms='';subnow='2'" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-envelope"></i>
                    </a>
                    <a href="javascript:void(0)" title="用戶履歷"  href="{{ link }}/user/{{ post.val.uid }};act=1" target="_blank">
                        <i class="fas fa- fa-address-card"></i>
                    </a>

                </div>
                <div *ngIf="post.key == 'memo'">
                    <div *ngIf="post.val.memo_edit==0" (click)="cp_item(post.val)" style="display: block;  width: 220px; white-space: break-spaces;overflow: auto;height: 150px;">{{post.val.memo}}</div>

                    <app-check-permissions [data]="'Kus1'">
                        <textarea  *ngIf="post.val.memo_edit!=0" (change)="post.val.memo_edit=2" [(ngModel)]="edit_data.memo" class="form-control" style="width:400px;height: 120px;"></textarea>
                    </app-check-permissions>
                    <app-check-permissions [data]="'Kus1'"  [type]="1">
                        <textarea  *ngIf="post.val.memo_edit!=0"  [(ngModel)]="edit_data.memo" class="form-control" style="width:400px;height: 120px;"></textarea>
                    </app-check-permissions>
                    <button  *ngIf="post.val.memo_edit==2" class="btn btn-danger" (click)="post.val.memo_edit=0;save()">確認</button>
                    <button *ngIf="post.val.memo_edit==2" class="btn btn-default" (click)="post.val.memo_edit=0;edit_data=post.val">取消</button>
                </div>
            </ng-template>
        </app-table-v2>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
        <!-- <div *ngIf="data.length==0">無資料</div> -->
    </div>
    <div *ngIf="now=='1'">
        <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="barOptions" style="display: block;width: 70%;"></highcharts-chart>
    </div>
    <div *ngIf="now=='2'||now=='5'||now=='6'">
        <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="pieOptions" style="display: block;width: 70%;"></highcharts-chart>
    </div>
    <div *ngIf="now=='7'">
        <button [ngClass]="sub_type=='0'?'btn-danger':'btn-secondary'"  (click)="sub_type='0';choose('7')" class="btn" >依裝置區分</button>
        <button [ngClass]="sub_type=='1'?'btn-danger':'btn-secondary'" (click)="sub_type='1';choose('7')" class="btn" >依性別區分</button>
        <div *ngFor="let item of yearList; let key = index">
            <div>{{ item }}年</div>
            <div *ngIf="key == 0">
                <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="barOptions2" style="display: block;width: 70%;margin:10px" *ngIf="chart_satrt==1"></highcharts-chart>
            </div>
            <div *ngIf="key == 1">
                <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="barOptions3" style="display: block;width: 70%;margin:10px" *ngIf="chart_satrt==1"></highcharts-chart>
            </div>
            <div *ngIf="key == 2">
                <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="barOptions4" style="display: block;width: 70%;margin:10px" *ngIf="chart_satrt==1"></highcharts-chart>
            </div>
        </div>
        <app-pagnation (callback)="callbackgrow($event)" [data]="pagegrowstr"></app-pagnation>
    </div>

    <div *ngIf="now=='3'&& fake_info">
        <div class="create_area_wraper">
            <div class="create_area">
                <h5>請選擇性別</h5>
                <button  [ngClass]="fake_info.gender=='1'?'btn-danger':'btn-dark'"   (click)="fake_info.gender='1'" class="btn">男生</button>
                <button  [ngClass]="fake_info.gender=='2'?'btn-danger':'btn-dark'" (click)="fake_info.gender='2'" class="btn">女生</button>
            </div>
            <div class="create_area">
                <h5>請輸入假帳號名稱</h5>
                <input type="text" [(ngModel)]="fake_info.name" class="form-control" style="width: 160px;">
            </div>
            <div class="create_area">
                <h5>請輸入招呼語</h5>
                <input type="text" [(ngModel)]="fake_info.greeting" class="form-control" style="width: 160px;">
            </div>
            <div class="create_area">
                <h5>請輸入自我介紹</h5>
                <textarea  [(ngModel)]="fake_info.introduction" class="form-control" style="width:400px;height: 120px;"></textarea>
            </div>
            <div class="create_area">
                <h5>請輸入生日</h5>
                <input type="date" [(ngModel)]="fake_info.birthday" class="form-control" style="width: 160px;">
            </div>
            <div class="create_area">
                <h5>請輸入興趣並用","分開</h5>
                <input type="text" [(ngModel)]="fake_info.hobby_name" class="form-control" style="width: 260px;">
            </div>
            <div class="create_area">
                <h5>請上傳照片</h5>
                <span (click)="fake_info.pic='';tmp_img_b64=undefined" style="cursor:pointer;"><img loading="lazy"  [src]="tmp_img_b64?tmp_img_b64:fake_info.pic" style="margin:0 5px 0 0px;width: 100px;display: inline;"></span>
                <app-crop (imgback)="imgback($event)"></app-crop>
            </div>
            <button id="create" class=" btn btn-info" (click)="create(1)">確定新增</button>
        </div>
    </div>
    <div *ngIf="now=='4'&& fake_info">
        <div class="create_area_wraper">
            <div class="create_area">
                <h5>請輸入假帳號名稱</h5>
                <input type="text" [(ngModel)]="fake_info.name" class="form-control" style="width: 160px;">
            </div>
            <div class="create_area">
                <h5>請輸入招呼語</h5>
                <input type="text" [(ngModel)]="fake_info.greeting" class="form-control" style="width: 160px;">
            </div>
            <div class="create_area">
                <h5>請輸入自我介紹</h5>
                <textarea  [(ngModel)]="fake_info.introduction" class="form-control" style="width:400px;height: 120px;"></textarea>
            </div>
            <div class="create_area">
                <h5>請輸入生日</h5>
                <input type="date" [(ngModel)]="fake_info.birthday" class="form-control" style="width: 160px;">
            </div>
            <div class="create_area">
                <h5>請輸入興趣並用","分開</h5>
                <input type="text" [(ngModel)]="fake_info.hobby_name" class="form-control" style="width: 260px;">
            </div>
            <div class="create_area">
                <h5>請上傳照片</h5>
                <span (click)="fake_info.pic='';tmp_img_b64=undefined" style="cursor:pointer;"><img loading="lazy"  [src]="tmp_img_b64?tmp_img_b64:fake_info.pic" style="margin:0 5px 0 0px;width: 100px;display: inline;"></span>
                <app-crop (imgback)="imgback($event)"></app-crop>
            </div>
            <button id="create" class=" btn btn-info" (click)="create(0)">確定修改</button>
        </div>
    </div>
</div>

<div class="modal fade bdx-example-modal-xl" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" *ngIf="subnow=='0'">更新懸賞設定</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->

            <div class="modal-body">
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">懸賞用戶</label>
                    <label class="col-sm-2 col-form-label">{{abounty_Data[0]?.name}}</label>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">懸賞金額</label>
                    <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_bounty_data.diamond">
                </div>
                <div class="user_edit_block form-group"  *ngIf="datestatus == true">
                    <label class="col-sm-2 col-form-label">懸賞時間</label>
                    <app-date [time]="bounty_time"  [timeset]="bounty_timeset" (rangeSelected)="handleBountyRangeSelected($event)"></app-date>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button"  (click)="init_list();savebounty(abounty_Data[0]?.user_id)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button id="ModalClose" type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>



<div *ngIf="edit_data && (now=='0' || now=='10')" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" *ngIf="subnow=='0'">{{subnow=='0'?'設定':'追蹤資料'}}</h5>
                <h5 class="modal-title" *ngIf="subnow!='0'">{{subnow=='1'?'追蹤資料':'發送簡訊'}}</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body" *ngIf="subnow=='2'">
                <div class="user_edit_block">
                    追蹤用戶是否回歸
                    <button [ngClass]="edit_data.track==0?'btn-danger':'btn-secondary'"  (click)="edit_data.track=0" class="btn" >否</button>
                    <button [ngClass]="edit_data.track==1?'btn-danger':'btn-secondary'" (click)="edit_data.track=1" class="btn" >是</button>
                </div>
                <div class="user_edit_block" *ngIf="edit_data.track*1==1">
                    贈送鑽石數
                    <input type="number" class="form-control" style="display: inline-block;" [(ngModel)]="edit_data.track_diamond" placeholder="贈送鑽石數">
                </div>
                <textarea class="form-control"  [(ngModel)]="edit_data.sms" style="min-height: 200px;margin-top: 15px;"></textarea>
            </div>
            <div class="modal-body" *ngIf="subnow=='1'">
                <div *ngIf="!edit_data.track_list || edit_data.track_list.length==0">無資料</div>
                <table class="table table-responsive-sm" *ngIf="edit_data.track_list && edit_data.track_list.length>0">
                    <thead>
                        <tr class="table-primary">
                            <th style="width:5%">是否有效</th>
                            <th style="width:5%">贈送鑽石</th>
                            <th style="width:5%">簡訊內容</th>
                            <th style="width:5%">回歸後貢獻</th>
                            <th style="width:5%">追蹤日</th>
                            <th style="width:5%">回歸日</th>
                            <th style="width:5%">負責人</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of edit_data.track_list; let key = index"  class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                            <td>{{item.success?'有':'無'}} </td>
                            <td>{{item.cost_diamond|number}}鑽</td>
                            <td>{{item.msg_content}}</td>
                            <td>{{item.back_earn_money|number}}元</td>
                            <td>{{item.create_dt}}</td>
                            <td>{{item.back_time=='0000-00-00 00:00:00'?'-':item.back_time}}</td>
                            <td>{{item.emp_name}}</td>
                        </tr>
                    </tbody>
                </table>
                <app-pagnation (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation>
            </div>
            <div class="modal-body" *ngIf="subnow=='0'">
                <div class="user_edit_block">
                    🏷️ 暱稱: {{edit_data.name}}( {{edit_data.uid}} )
                    <input type="text" [(ngModel)]="changeName" class="form-control fix_input" style="width: 200px;">
                    <button style="margin: 10px;" (click)="changeNameText()" class="btn-danger btn">更改暱稱</button>
                </div>
                <div class="user_edit_block">
                    🖥️ 作業系統:
                    <span *ngIf="edit_data.os_type==3">網頁</span>
                    <span *ngIf="edit_data.os_type==2">iOs</span>
                    <span *ngIf="edit_data.os_type==1">安卓</span>
                </div>
                <div class="user_edit_block">
                    📱 電話: {{edit_data.phone_num}}
                    <app-check-permissions [data]="'ORa6'">
                        <input type="text" [(ngModel)]="changePhone" class="form-control fix_input" style="width: 200px;">
                        <button style="margin: 10px;" (click)="changePhoneText()"  class=" btn-danger btn">更改電話</button>
                    </app-check-permissions>
                </div>
                <div class="user_edit_block">
                    大頭貼
                    <img loading="lazy" style="height: 100px;" [src]="edit_data.profile_pic">
                    <button (click)="edit_data.profile_pic=iconPic" style="margin: 10px;" class=" btn-danger btn" >預設</button>
                </div>
                <div class="user_edit_block">
                    照片集
                    <div *ngFor="let item of edit_data.profile_pics; let i = index" style="margin:8px;display: inline;">
                        <img loading="lazy" [src]="item.url" style="height: 100px;">
                        <button class="btn btn-danger" (click)="edit_data.profile_pics.splice(i,1)">下架</button>
                    </div>
                </div>
                <div class="user_edit_block" *ngIf="power*1==5">
                    提領匯率
                    <input type="range" [disabled]="edit_data.gender*1==1 ? true : null"  class="form-range" min="0" max="0.7" step="0.1" [(ngModel)]="edit_data.customer_rate" id="customRange1">
                    {{edit_data.customer_rate}}<span class="msg" *ngIf="edit_data.gender*1==1">男生無法提領</span>
                </div>
                <div class="user_edit_block" *ngIf="power*1 >= 3 && edit_data.sort_score != -4">
                    推薦分數
                    <input type="range" class="form-range" min="1" max="9" step="1" [(ngModel)]="edit_data.sort_score" >
                    {{edit_data.sort_score}}
                </div>
                <div class="user_edit_block" *ngIf="edit_data.gender == '2' && (edit_data.user_kyc_status == '1' || edit_data.user_kyc_status == '-2')">
                    後台隱藏用戶
                    <button [ngClass]="edit_data.sort_score != -4 ? 'btn-danger' : 'btn-secondary'"  (click)="edit_data.sort_score = 0" class="btn" style="margin-right: 5px;" [disabled]="edit_data.gender != '2' || !['1', '-2'].includes(edit_data.user_kyc_status)">正常</button>
                    <button [ngClass]="edit_data.sort_score == -4 ? 'btn-danger' : 'btn-secondary'" (click)="edit_data.sort_score = -4" class="btn" style="margin-right: 5px;" [disabled]="edit_data.gender != '2' || !['1', '-2'].includes(edit_data.user_kyc_status)">隱藏此用戶</button>
                    <p class="ml-2 text-muted">(如果隱藏用戶，被隱藏用戶不會知道自己是淺水狀態)</p>
                </div>
                <div class="user_edit_block" *ngIf="power*1>=3">
                    熱門女神係數
                    <input type="range" class="form-range" min="0" max="9" step="1" [(ngModel)]="edit_data.fake_hot_num" >
                    {{edit_data.fake_hot_num}}
                </div>
                <div class="user_edit_block" style="display: flex;">
                    帳號使用狀態

                    <app-check-permissions [data]="'VbpG'">
                        <button [ngClass]="edit_data.is_enable==2?'btn-danger':'btn-secondary'" (click)="edit_data.is_enable=2" class="btn" style="margin-right: 5px;margin-left: 5px;">復權</button>
                    </app-check-permissions>
                    <app-check-permissions [data]="'xEkH'">
                        <button [ngClass]="edit_data.is_enable==1?'btn-danger':'btn-secondary'" (click)="edit_data.is_enable=1" class="btn" style="margin-right: 5px;margin-left: 5px;">正常</button>
                    </app-check-permissions>
                    <div>
                        <button [ngClass]="edit_data.is_enable==0||edit_data.is_enable==-1?'btn-danger':'btn-secondary'"  (click)="edit_data.is_enable=-1" class="btn" style="margin-right: 5px;">停權且鎖裝置</button>
                        <button [ngClass]="edit_data.is_enable==-1?'btn-danger':'btn-secondary'"  (click)="edit_data.is_enable=0" class="btn" style="margin-right: 5px;" *ngIf="false">停權</button>
                    </div>

                    <input *ngIf="edit_data.is_enable==0 || edit_data.is_enable==-1" type="text" [(ngModel)]="edit_data.block_reason" class="form-control fix_input"  placeholder="停權原因" >
                    <input *ngIf=" edit_data.is_enable==2" type="text" [(ngModel)]="edit_data.block_reason" class="form-control fix_input"  placeholder="復權原因" >
                </div>
                <div class="user_edit_block" *ngIf="edit_data.identity != 3">
                    帳號身分
                    <button [ngClass]="edit_data.identity==1?'btn-danger':'btn-secondary'"  (click)="edit_data.identity=1" class="btn" style="margin-right: 5px;">一般會員</button>
                    <button [ngClass]="edit_data.identity==2?'btn-danger':'btn-secondary'" (click)="edit_data.identity=2" class="btn" style="margin-right: 5px;">內部員工</button>
                    <!-- <button [ngClass]="edit_data.identity==3?'btn-danger':'btn-secondary'" (click)="edit_data.identity=3" class="btn" style="margin-right: 5px;">簽約員工</button> -->
                    <button [ngClass]="edit_data.identity==5?'btn-danger':'btn-secondary'" (click)="edit_data.identity=5" class="btn" style="margin-right: 5px;">陪聊員工</button>
                    <button [ngClass]="edit_data.identity==6?'btn-danger':'btn-secondary'" (click)="edit_data.identity=6" class="btn" >平台內主播</button>
                </div>
                <div class="user_edit_block">
                     是否淺水
                    <button [ngClass]="edit_data.is_hidden==0?'btn-danger':'btn-secondary'"  (click)="edit_data.is_hidden=0" class="btn" style="margin-right: 5px;">正常</button>
                    <button [ngClass]="edit_data.is_hidden==1?'btn-danger':'btn-secondary'" (click)="edit_data.is_hidden=1" class="btn" style="margin-right: 5px;">淺水</button>
                </div>
                <div *ngIf="power == 5 || power == 6 || power == 13 || power == 14" class="user_edit_block d-flex align-items-center">
                    💰 手動申請提領
                    <button
                        [ngClass]="edit_data.isWithdrawInputVisible ? 'btn-success' : 'btn-secondary'"
                        (click)="edit_data.isWithdrawInputVisible = !edit_data.isWithdrawInputVisible"
                        [disabled]="edit_data.gender != '2' || !(edit_data.user_kyc_status == -2 || edit_data.user_kyc_status == 1) || edit_data.bank_Status != 1 || edit_data.identity != 1 || edit_data.diamond <= 51000"
                        class="btn ml-2">
                        申請
                    </button>

                    <!-- 只有點擊後，對應的 input 才會顯示 -->
                    <div *ngIf="edit_data.isWithdrawInputVisible" class="d-flex align-items-center ml-2">
                        <input
                            type="number"
                            [(ngModel)]="edit_data.withdrawAmount"
                            [attr.min]="51000"
                            [attr.max]="edit_data.diamond"
                            (change)="checkMaxValue()"
                            class="form-control"
                            style="margin-right: 5px;">

                        <button
                            class="btn btn-success text-nowrap"
                            (click)="userWithdrawDiamond()">
                            確認
                        </button>

                        <!-- 提示訊息 -->
                        <div *ngIf="edit_data.showMaxWarning" class="ml-2 text-danger text-nowrap">
                            已經達到可提領的最大值！
                        </div>
                        <!-- 提示訊息 -->
                        <div *ngIf="edit_data.showMinWarning" class="ml-2 text-danger text-nowrap">
                            尚未到達可提領的最小值！
                        </div>
                        <!-- 提示訊息 -->
                        <div *ngIf="withdrawSuccess[edit_data.id]" class="ml-2 text-success text-nowrap">
                            申請提領已成功加入排程！
                        </div>
                    </div>
                </div>
                <div *ngIf="power == 5 || power == 6 || power == 13 || power == 14">
                    <div class="ml-4 d-flex flex-column text-muted small" *ngIf="!(edit_data.gender != '2' || !(edit_data.user_kyc_status == -2 || edit_data.user_kyc_status == 1) || edit_data.bank_Status != 1 || edit_data.identity != 1 || edit_data.diamond <= 51000)">
                        <!-- 主標題 -->
                        <span>💎 用戶目前鑽石數: {{ edit_data.diamond }}</span>
                    </div>
                    <div class="ml-4 d-flex flex-column text-muted small" *ngIf="edit_data.gender != '2' || !(edit_data.user_kyc_status == -2 || edit_data.user_kyc_status == 1) || edit_data.bank_Status != 1 || edit_data.identity != 1 || edit_data.diamond <= 51000">
                        <!-- 主標題 -->
                        <span>❌ 申請條件不符！</span>

                        <!-- 顯示錯誤原因列表 -->
                        <ul class="ml-5 d-flex flex-column" style="list-style: disc;">
                            <li *ngIf="edit_data.gender != '2'">
                                原因：必須是女性
                            </li>
                            <li *ngIf="!(edit_data.user_kyc_status == -2 || edit_data.user_kyc_status == 1)">
                                原因：未通過 KYC 驗證
                            </li>
                            <li *ngIf="edit_data.bank_Status != 1">
                                原因：銀行帳戶未驗證
                            </li>
                            <li *ngIf="edit_data.identity != 1">
                                原因：必須為非經紀用戶
                            </li>
                            <li *ngIf="edit_data.diamond <= 51000">
                                原因：鑽石數必須大於 51000
                            </li>
                        </ul>
                    </div>
                </div>


                <div class="user_edit_block" id="ggggwp">
                    測試該用戶網路
                    <div>
                        <button  class="btn btn-primary" (click)="cp_net_url()" style="margin-top:10px">複製網址</button>
                    </div>
                </div>

                <div class="user_edit_block">
                    招呼語
                    <input type="text" [(ngModel)]="edit_data.greeting" class="form-control fix_input">
                    <button (click)="edit_data.greeting='找我聊天嗎'" class=" btn-danger btn" >預設</button>
                </div>
                <div class="user_edit_block">
                    自我介紹
                    <input type="text" [(ngModel)]="edit_data.introduction" class="form-control fix_input" >
                    <button (click)="edit_data.introduction='安安想認識我嗎'" class=" btn-danger btn" >預設</button>
                </div>
                <div class="subtitle">追蹤網路節點:</div>
                <app-check-permissions [data]="'Kus1'">
                    <div class="subitem">
                        <button class="btn btn-primary" (click)="trace_net()">發送</button>
                    </div>
                </app-check-permissions>
                <div class="user_edit_block">
                    近期上傳紀錄
                    <a *ngIf="edit_data.log!=-1" href="{{edit_data.log_link}}" target="_blank">link</a>
                </div>
                <div class="user_edit_block">
                    摸彩發送張數
                    <input type="number" [(ngModel)]="ticket_num" class="form-control fix_input" style="width: 200px;">
                    <button (click)="ticket_send(edit_data)" class=" btn-success btn" >發送</button>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" *ngIf="subnow!='1' && subnow!='2'" (click)="save()"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button" *ngIf="subnow=='1'"  (click)="init_list()"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <app-check-permissions [data]="'Kus1'" *ngIf="subnow=='2'">
                    <button type="button"  (click)="sms_go()"  class="btn btn-primary" data-dismiss="modal">發送</button>
                </app-check-permissions>
                <button id="ModalClose" type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>
<ng-template #yourModalContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" >懸賞設定</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="user_edit_block form-group">
            <label class="col-sm-2 col-form-label">懸賞用戶</label>
            <select class="form-control" style="width: 220px;display: inline-block;"  *ngIf="user_type == 1">
                <option *ngFor="let item of  bounty_menu" [ngValue]="item.id">{{item.name}}</option>
            </select>
            已選 : {{bounty_menuLeng}} 人

        </div>
        <div class="user_edit_block form-group">
            <button [ngClass]="'btn-info'"  (click)="user_type = 1;changeUser()" class="btn modalbtn" *ngIf="user_type == 2">手動選擇用戶</button>
            <button [ngClass]="'btn-info'" (click)="user_type = 2;changeUser()" class="btn modalbtn"  *ngIf="user_type == 1">選擇全部用戶</button>
        </div>
        <div class="user_edit_block form-group">
            <label class="col-sm-2 col-form-label">懸賞鑽石數</label>
            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_bounty_data.diamond">
        </div>
        <div class="user_edit_block form-group">
            <label class="col-sm-2 col-form-label">懸賞開始時間</label>
            <app-date [time]="bounty_time"   [limitset]="limitset" [timeset]="bounty_timeset" (rangeSelected)="handleBountyRangeSelected($event)"></app-date>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button"  *ngIf="subnow=='0'" (click)="bounty_control()" class="btn btn-primary">確認</button>
        <button type="button"  *ngIf="subnow=='0'" (click)="init_list();modal.dismiss('Cross click')" class="btn btn-danger">取消</button>
    </div>


</ng-template>

<ng-template #yourModalContenthistorymanage let-modal>
    <div class="modal-header" style="background: #f8f9fa; border-bottom: 1px solid #e9ecef;">
        <h4 class="modal-title" style="font-weight: 600;">經紀歷史紀錄</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 20px;">
        <div style="display: flex; justify-content: center;">
            <app-table-v2 [type]="1" [data]="contenthistoryData" [tcontent]="contenthistorytcontent" *ngIf="data.length>0"></app-table-v2>
        </div>
        <div *ngIf="data.length === 0" style="text-align: center; padding: 40px; color: #999;">
            暫無經紀歷史紀錄
        </div>
    </div>
</ng-template>

<ng-template #yourModalContentNicknameHistory let-modal>
    <div class="modal-header" style="background: #f8f9fa; border-bottom: 1px solid #e9ecef;">
        <h4 class="modal-title" style="font-weight: 600;">暱稱歷史紀錄</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 20px;">
        <div style="display: flex; justify-content: center;">
            <app-table-v2 [type]="1" [data]="nicknameHistoryData" [tcontent]="nicknameHistorytcontent" *ngIf="nicknameHistoryData.length>0"></app-table-v2>
        </div>
        <div *ngIf="nicknameHistoryData.length === 0" style="text-align: center; padding: 40px; color: #999;">
            暫無暱稱變更紀錄
        </div>
        <app-pagnation (callback)="callbackNicknameHistory($event)" [data]="pageobjstr7" style="margin-top: 16px;"></app-pagnation>
    </div>
</ng-template>

<ng-template #yourModalContentUserDetail let-modal>
    <div class="modal-header">
        <h4 class="modal-title" >用戶歷史紀錄</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-table-v2 [type]="1" [data]="list_detail_arr" [tcontent]="list_detail_tcontent" *ngIf="list_detail_arr.length>0" (sortdata)="handlesortdatadetail2($event,1)"></app-table-v2>
        <app-pagnation (callback)="callbackListDetail($event)" [data]="pageobjstr6"></app-pagnation>
    </div>
</ng-template>


<ng-template #yourModalContent123 let-modal>
    <div class="modal-header">
        <h4 class="modal-title" >補通訊紀錄備查</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">

        <app-search [id] = "1"  [limit] = "1" (item)="callitem($event)"  (searchstr)="searchstr($event)"></app-search>
        <div class="user_edit_block form-group">
            <label class="col-sm-2 col-form-label">異常類型</label>
            <button [ngClass]="errtype == 1?'btn-info':'btn-secondary'"  (click)="errtype = 1" class="btn" style="margin-right: 5px;">語音</button>
            <button [ngClass]="errtype == 2?'btn-info':'btn-secondary'" (click)="errtype = 2" class="btn" style="margin-right: 5px;">視訊</button>
        </div>
        <div class="user_edit_block form-group">
            <label class="col-sm-2 col-form-label">對象用戶</label>
            <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="target_by_err.name" disabled>
        </div>

        <div class="user_edit_block form-group" *ngIf="errtype == 1">
            <label class="col-sm-2 col-form-label">語音費率</label>
            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="error_voice_list.voice_fee" >
        </div>
        <div class="user_edit_block form-group" *ngIf="errtype == 2">
            <label class="col-sm-2 col-form-label" >視訊費率</label>
            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="error_voice_list.video_fee" >
        </div>

        <div class="user_edit_block form-group">
            <label class="col-sm-2 col-form-label">秒數</label>
            <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="error_voice_list.second">
        </div>

        <div class="user_edit_block form-group">
            <label class="col-sm-2 col-form-label">通訊時間</label>
            <app-date [time]="errtime" [format]="'YYYY-MM-DD HH:mm:ss'" (rangeSelected)="handleRangeSelected1($event)" [auto]="false" [css]="'width: 500px; display: inline-block; margin-right: 16px;'"></app-date>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button"  *ngIf="subnow=='0'" (click)="add_err();modal.dismiss('Cross click')" class="btn btn-primary">確認</button>
        <button type="button"  *ngIf="subnow=='0'" (click)="modal.dismiss('Cross click')" class="btn btn-danger">取消</button>
    </div>
</ng-template>
<app-spinner [loading]="loading"></app-spinner>
